import { jsx as m, Fragment as Oe, jsxs as B } from "react/jsx-runtime";
import * as b from "react";
import et, { forwardRef as ne, useCallback as re, useRef as pe, useEffect as ie, useImperativeHandle as Tn, useLayoutEffect as _i, useState as J, Fragment as nt, createElement as Ii, useMemo as Bn } from "react";
import gn from "rehype-raw";
import { useTranslation as Re } from "react-i18next";
import Ei from "react-stay-scrolled";
import Si from "copy-to-clipboard";
import { toast as Ni, ToastContainer as Li } from "react-toastify";
import { QuestionType as U } from "@law-connect/types";
import Ai from "react-dom";
import './index.css';const Mi = "_textareaInput_1gk9p_1149", Ti = {
  textareaInput: Mi
}, Pi = ne((e, n) => {
  var o;
  const { value: t = "", disabled: r, onChange: i } = e, l = re((a) => {
    r || i(a.target.value);
  }, [r, i]);
  return /* @__PURE__ */ m(
    "textarea",
    {
      ref: n,
      ...e.props,
      className: `${Ti.textareaInput} ${(o = e.props) == null ? void 0 : o.className}`,
      onChange: l,
      disabled: r,
      value: t
    }
  );
}), Ri = "_message_ktvqw_1149", Fi = {
  message: Ri
};
function Di(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const Bi = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, $i = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Oi = {};
function Tt(e, n) {
  return (Oi.jsx ? $i : Bi).test(e);
}
const zi = /[ \t\n\f\r]/g;
function Hi(e) {
  return typeof e == "object" ? e.type === "text" ? Pt(e.value) : !1 : Pt(e);
}
function Pt(e) {
  return e.replace(zi, "") === "";
}
class Cn {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, t, r) {
    this.property = n, this.normal = t, r && (this.space = r);
  }
}
Cn.prototype.property = {};
Cn.prototype.normal = {};
Cn.prototype.space = null;
function Ar(e, n) {
  const t = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(t, e[i].property), Object.assign(r, e[i].normal);
  return new Cn(t, r, n);
}
function tt(e) {
  return e.toLowerCase();
}
class Ie {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, t) {
    this.property = n, this.attribute = t;
  }
}
Ie.prototype.space = null;
Ie.prototype.boolean = !1;
Ie.prototype.booleanish = !1;
Ie.prototype.overloadedBoolean = !1;
Ie.prototype.number = !1;
Ie.prototype.commaSeparated = !1;
Ie.prototype.spaceSeparated = !1;
Ie.prototype.commaOrSpaceSeparated = !1;
Ie.prototype.mustUseProperty = !1;
Ie.prototype.defined = !1;
let Vi = 0;
const q = Ke(), ae = Ke(), Mr = Ke(), R = Ke(), G = Ke(), tn = Ke(), xe = Ke();
function Ke() {
  return 2 ** ++Vi;
}
const rt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: q,
  booleanish: ae,
  commaOrSpaceSeparated: xe,
  commaSeparated: tn,
  number: R,
  overloadedBoolean: Mr,
  spaceSeparated: G
}, Symbol.toStringTag, { value: "Module" })), $n = Object.keys(rt);
class dt extends Ie {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, t, r, i) {
    let l = -1;
    if (super(n, t), Rt(this, "space", i), typeof r == "number")
      for (; ++l < $n.length; ) {
        const o = $n[l];
        Rt(this, $n[l], (r & rt[o]) === rt[o]);
      }
  }
}
dt.prototype.defined = !0;
function Rt(e, n, t) {
  t && (e[n] = t);
}
const ji = {}.hasOwnProperty;
function on(e) {
  const n = {}, t = {};
  let r;
  for (r in e.properties)
    if (ji.call(e.properties, r)) {
      const i = e.properties[r], l = new dt(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (l.mustUseProperty = !0), n[r] = l, t[tt(r)] = r, t[tt(l.attribute)] = r;
    }
  return new Cn(n, t, e.space);
}
const Tr = on({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Pr = on({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Rr(e, n) {
  return n in e ? e[n] : n;
}
function Fr(e, n) {
  return Rr(e, n.toLowerCase());
}
const Dr = on({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Fr,
  properties: { xmlns: null, xmlnsXLink: null }
}), Br = on({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ae,
    ariaAutoComplete: null,
    ariaBusy: ae,
    ariaChecked: ae,
    ariaColCount: R,
    ariaColIndex: R,
    ariaColSpan: R,
    ariaControls: G,
    ariaCurrent: null,
    ariaDescribedBy: G,
    ariaDetails: null,
    ariaDisabled: ae,
    ariaDropEffect: G,
    ariaErrorMessage: null,
    ariaExpanded: ae,
    ariaFlowTo: G,
    ariaGrabbed: ae,
    ariaHasPopup: null,
    ariaHidden: ae,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: G,
    ariaLevel: R,
    ariaLive: null,
    ariaModal: ae,
    ariaMultiLine: ae,
    ariaMultiSelectable: ae,
    ariaOrientation: null,
    ariaOwns: G,
    ariaPlaceholder: null,
    ariaPosInSet: R,
    ariaPressed: ae,
    ariaReadOnly: ae,
    ariaRelevant: null,
    ariaRequired: ae,
    ariaRoleDescription: G,
    ariaRowCount: R,
    ariaRowIndex: R,
    ariaRowSpan: R,
    ariaSelected: ae,
    ariaSetSize: R,
    ariaSort: null,
    ariaValueMax: R,
    ariaValueMin: R,
    ariaValueNow: R,
    ariaValueText: null,
    role: null
  }
}), qi = on({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Fr,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: tn,
    acceptCharset: G,
    accessKey: G,
    action: null,
    allow: null,
    allowFullScreen: q,
    allowPaymentRequest: q,
    allowUserMedia: q,
    alt: null,
    as: null,
    async: q,
    autoCapitalize: null,
    autoComplete: G,
    autoFocus: q,
    autoPlay: q,
    blocking: G,
    capture: null,
    charSet: null,
    checked: q,
    cite: null,
    className: G,
    cols: R,
    colSpan: null,
    content: null,
    contentEditable: ae,
    controls: q,
    controlsList: G,
    coords: R | tn,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: q,
    defer: q,
    dir: null,
    dirName: null,
    disabled: q,
    download: Mr,
    draggable: ae,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: q,
    formTarget: null,
    headers: G,
    height: R,
    hidden: q,
    high: R,
    href: null,
    hrefLang: null,
    htmlFor: G,
    httpEquiv: G,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: q,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: q,
    itemId: null,
    itemProp: G,
    itemRef: G,
    itemScope: q,
    itemType: G,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: q,
    low: R,
    manifest: null,
    max: null,
    maxLength: R,
    media: null,
    method: null,
    min: null,
    minLength: R,
    multiple: q,
    muted: q,
    name: null,
    nonce: null,
    noModule: q,
    noValidate: q,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: q,
    optimum: R,
    pattern: null,
    ping: G,
    placeholder: null,
    playsInline: q,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: q,
    referrerPolicy: null,
    rel: G,
    required: q,
    reversed: q,
    rows: R,
    rowSpan: R,
    sandbox: G,
    scope: null,
    scoped: q,
    seamless: q,
    selected: q,
    shadowRootDelegatesFocus: q,
    shadowRootMode: null,
    shape: null,
    size: R,
    sizes: null,
    slot: null,
    span: R,
    spellCheck: ae,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: R,
    step: null,
    style: null,
    tabIndex: R,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: q,
    useMap: null,
    value: ae,
    width: R,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: G,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: R,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: R,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: q,
    // Lists. Use CSS to reduce space between items instead
    declare: q,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: R,
    // `<img>` and `<object>`
    leftMargin: R,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: R,
    // `<body>`
    marginWidth: R,
    // `<body>`
    noResize: q,
    // `<frame>`
    noHref: q,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: q,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: q,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: R,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ae,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: R,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: R,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: q,
    disableRemotePlayback: q,
    prefix: null,
    property: null,
    results: R,
    security: null,
    unselectable: null
  }
}), Wi = on({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Rr,
  properties: {
    about: xe,
    accentHeight: R,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: R,
    amplitude: R,
    arabicForm: null,
    ascent: R,
    attributeName: null,
    attributeType: null,
    azimuth: R,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: R,
    by: null,
    calcMode: null,
    capHeight: R,
    className: G,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: R,
    diffuseConstant: R,
    direction: null,
    display: null,
    dur: null,
    divisor: R,
    dominantBaseline: null,
    download: q,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: R,
    enableBackground: null,
    end: null,
    event: null,
    exponent: R,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: R,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: tn,
    g2: tn,
    glyphName: tn,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: R,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: R,
    horizOriginX: R,
    horizOriginY: R,
    id: null,
    ideographic: R,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: R,
    k: R,
    k1: R,
    k2: R,
    k3: R,
    k4: R,
    kernelMatrix: xe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: R,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: R,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: R,
    overlineThickness: R,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: R,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: G,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: R,
    pointsAtY: R,
    pointsAtZ: R,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: xe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: xe,
    rev: xe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: xe,
    requiredFeatures: xe,
    requiredFonts: xe,
    requiredFormats: xe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: R,
    specularExponent: R,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: R,
    strikethroughThickness: R,
    string: null,
    stroke: null,
    strokeDashArray: xe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: R,
    strokeOpacity: R,
    strokeWidth: null,
    style: null,
    surfaceScale: R,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: xe,
    tabIndex: R,
    tableValues: null,
    target: null,
    targetX: R,
    targetY: R,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: xe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: R,
    underlineThickness: R,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: R,
    values: null,
    vAlphabetic: R,
    vMathematical: R,
    vectorEffect: null,
    vHanging: R,
    vIdeographic: R,
    version: null,
    vertAdvY: R,
    vertOriginX: R,
    vertOriginY: R,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: R,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Zi = /^data[-\w.:]+$/i, Ft = /-[a-z]/g, Ui = /[A-Z]/g;
function Qi(e, n) {
  const t = tt(n);
  let r = n, i = Ie;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && Zi.test(n)) {
    if (n.charAt(4) === "-") {
      const l = n.slice(5).replace(Ft, Ki);
      r = "data" + l.charAt(0).toUpperCase() + l.slice(1);
    } else {
      const l = n.slice(4);
      if (!Ft.test(l)) {
        let o = l.replace(Ui, Yi);
        o.charAt(0) !== "-" && (o = "-" + o), n = "data" + o;
      }
    }
    i = dt;
  }
  return new i(r, n);
}
function Yi(e) {
  return "-" + e.toLowerCase();
}
function Ki(e) {
  return e.charAt(1).toUpperCase();
}
const Xi = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Ji = Ar([Pr, Tr, Dr, Br, qi], "html"), ht = Ar([Pr, Tr, Dr, Br, Wi], "svg");
function Gi(e) {
  return e.join(" ").trim();
}
var Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function el(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $r = {}, Bt = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, nl = /\n/g, tl = /^\s*/, rl = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, il = /^:\s*/, ll = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, ol = /^[;\s]*/, al = /^\s+|\s+$/g, sl = `
`, $t = "/", Ot = "*", Ye = "", cl = "comment", ul = "declaration", pl = function(e, n) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  n = n || {};
  var t = 1, r = 1;
  function i(C) {
    var x = C.match(nl);
    x && (t += x.length);
    var k = C.lastIndexOf(sl);
    r = ~k ? C.length - k : r + C.length;
  }
  function l() {
    var C = { line: t, column: r };
    return function(x) {
      return x.position = new o(C), c(), x;
    };
  }
  function o(C) {
    this.start = C, this.end = { line: t, column: r }, this.source = n.source;
  }
  o.prototype.content = e;
  function a(C) {
    var x = new Error(
      n.source + ":" + t + ":" + r + ": " + C
    );
    if (x.reason = C, x.filename = n.source, x.line = t, x.column = r, x.source = e, !n.silent) throw x;
  }
  function s(C) {
    var x = C.exec(e);
    if (x) {
      var k = x[0];
      return i(k), e = e.slice(k.length), x;
    }
  }
  function c() {
    s(tl);
  }
  function p(C) {
    var x;
    for (C = C || []; x = d(); )
      x !== !1 && C.push(x);
    return C;
  }
  function d() {
    var C = l();
    if (!($t != e.charAt(0) || Ot != e.charAt(1))) {
      for (var x = 2; Ye != e.charAt(x) && (Ot != e.charAt(x) || $t != e.charAt(x + 1)); )
        ++x;
      if (x += 2, Ye === e.charAt(x - 1))
        return a("End of comment missing");
      var k = e.slice(2, x - 2);
      return r += 2, i(k), e = e.slice(x), r += 2, C({
        type: cl,
        comment: k
      });
    }
  }
  function f() {
    var C = l(), x = s(rl);
    if (x) {
      if (d(), !s(il)) return a("property missing ':'");
      var k = s(ll), w = C({
        type: ul,
        property: zt(x[0].replace(Bt, Ye)),
        value: k ? zt(k[0].replace(Bt, Ye)) : Ye
      });
      return s(ol), w;
    }
  }
  function u() {
    var C = [];
    p(C);
    for (var x; x = f(); )
      x !== !1 && (C.push(x), p(C));
    return C;
  }
  return c(), u();
};
function zt(e) {
  return e ? e.replace(al, Ye) : Ye;
}
var dl = Dt && Dt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($r, "__esModule", { value: !0 });
var hl = dl(pl);
function fl(e, n) {
  var t = null;
  if (!e || typeof e != "string")
    return t;
  var r = (0, hl.default)(e), i = typeof n == "function";
  return r.forEach(function(l) {
    if (l.type === "declaration") {
      var o = l.property, a = l.value;
      i ? n(o, a, l) : a && (t = t || {}, t[o] = a);
    }
  }), t;
}
var Ht = $r.default = fl;
const ml = Ht.default || Ht, Or = zr("end"), ft = zr("start");
function zr(e) {
  return n;
  function n(t) {
    const r = t && t.position && t.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function gl(e) {
  const n = ft(e), t = Or(e);
  if (n && t)
    return { start: n, end: t };
}
function fn(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Vt(e.position) : "start" in e || "end" in e ? Vt(e) : "line" in e || "column" in e ? it(e) : "";
}
function it(e) {
  return jt(e && e.line) + ":" + jt(e && e.column);
}
function Vt(e) {
  return it(e && e.start) + "-" + it(e && e.end);
}
function jt(e) {
  return e && typeof e == "number" ? e : 1;
}
class ce extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, r) {
    super(), typeof t == "string" && (r = t, t = void 0);
    let i = "", l = {}, o = !1;
    if (t && ("line" in t && "column" in t ? l = { place: t } : "start" in t && "end" in t ? l = { place: t } : "type" in t ? l = {
      ancestors: [t],
      place: t.position
    } : l = { ...t }), typeof n == "string" ? i = n : !l.cause && n && (o = !0, i = n.message, l.cause = n), !l.ruleId && !l.source && typeof r == "string") {
      const s = r.indexOf(":");
      s === -1 ? l.ruleId = r : (l.source = r.slice(0, s), l.ruleId = r.slice(s + 1));
    }
    if (!l.place && l.ancestors && l.ancestors) {
      const s = l.ancestors[l.ancestors.length - 1];
      s && (l.place = s.position);
    }
    const a = l.place && "start" in l.place ? l.place.start : l.place;
    this.ancestors = l.ancestors || void 0, this.cause = l.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = a ? a.line : void 0, this.name = fn(l.place) || "1:1", this.place = l.place || void 0, this.reason = this.message, this.ruleId = l.ruleId || void 0, this.source = l.source || void 0, this.stack = o && l.cause && typeof l.cause.stack == "string" ? l.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
ce.prototype.file = "";
ce.prototype.name = "";
ce.prototype.reason = "";
ce.prototype.message = "";
ce.prototype.stack = "";
ce.prototype.column = void 0;
ce.prototype.line = void 0;
ce.prototype.ancestors = void 0;
ce.prototype.cause = void 0;
ce.prototype.fatal = void 0;
ce.prototype.place = void 0;
ce.prototype.ruleId = void 0;
ce.prototype.source = void 0;
const mt = {}.hasOwnProperty, yl = /* @__PURE__ */ new Map(), wl = /[A-Z]/g, Cl = /-([a-z])/g, xl = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), vl = /* @__PURE__ */ new Set(["td", "th"]), Hr = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function bl(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let r;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = Al(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = Ll(t, n.jsx, n.jsxs);
  }
  const i = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: r,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? ht : Ji,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, l = Vr(i, e, void 0);
  return l && typeof l != "string" ? l : i.create(
    e,
    i.Fragment,
    { children: l || void 0 },
    void 0
  );
}
function Vr(e, n, t) {
  if (n.type === "element")
    return kl(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return _l(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return El(e, n, t);
  if (n.type === "mdxjsEsm")
    return Il(e, n);
  if (n.type === "root")
    return Sl(e, n, t);
  if (n.type === "text")
    return Nl(e, n);
}
function kl(e, n, t) {
  const r = e.schema;
  let i = r;
  n.tagName.toLowerCase() === "svg" && r.space === "html" && (i = ht, e.schema = i), e.ancestors.push(n);
  const l = qr(e, n.tagName, !1), o = Ml(e, n);
  let a = yt(e, n);
  return xl.has(n.tagName) && (a = a.filter(function(s) {
    return typeof s == "string" ? !Hi(s) : !0;
  })), jr(e, o, l, n), gt(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function _l(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const r = n.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  yn(e, n.position);
}
function Il(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  yn(e, n.position);
}
function El(e, n, t) {
  const r = e.schema;
  let i = r;
  n.name === "svg" && r.space === "html" && (i = ht, e.schema = i), e.ancestors.push(n);
  const l = n.name === null ? e.Fragment : qr(e, n.name, !0), o = Tl(e, n), a = yt(e, n);
  return jr(e, o, l, n), gt(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function Sl(e, n, t) {
  const r = {};
  return gt(r, yt(e, n)), e.create(n, e.Fragment, r, t);
}
function Nl(e, n) {
  return n.value;
}
function jr(e, n, t, r) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = r);
}
function gt(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function Ll(e, n, t) {
  return r;
  function r(i, l, o, a) {
    const c = Array.isArray(o.children) ? t : n;
    return a ? c(l, o, a) : c(l, o);
  }
}
function Al(e, n) {
  return t;
  function t(r, i, l, o) {
    const a = Array.isArray(l.children), s = ft(r);
    return n(
      i,
      l,
      o,
      a,
      {
        columnNumber: s ? s.column - 1 : void 0,
        fileName: e,
        lineNumber: s ? s.line : void 0
      },
      void 0
    );
  }
}
function Ml(e, n) {
  const t = {};
  let r, i;
  for (i in n.properties)
    if (i !== "children" && mt.call(n.properties, i)) {
      const l = Pl(e, i, n.properties[i]);
      if (l) {
        const [o, a] = l;
        e.tableCellAlignToStyle && o === "align" && typeof a == "string" && vl.has(n.tagName) ? r = a : t[o] = a;
      }
    }
  if (r) {
    const l = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    l[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return t;
}
function Tl(e, n) {
  const t = {};
  for (const r of n.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const l = r.data.estree.body[0];
        l.type;
        const o = l.expression;
        o.type;
        const a = o.properties[0];
        a.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        yn(e, n.position);
    else {
      const i = r.name;
      let l;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, l = e.evaluater.evaluateExpression(a.expression);
        } else
          yn(e, n.position);
      else
        l = r.value === null ? !0 : r.value;
      t[i] = /** @type {Props[keyof Props]} */
      l;
    }
  return t;
}
function yt(e, n) {
  const t = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : yl;
  for (; ++r < n.children.length; ) {
    const l = n.children[r];
    let o;
    if (e.passKeys) {
      const s = l.type === "element" ? l.tagName : l.type === "mdxJsxFlowElement" || l.type === "mdxJsxTextElement" ? l.name : void 0;
      if (s) {
        const c = i.get(s) || 0;
        o = s + "-" + c, i.set(s, c + 1);
      }
    }
    const a = Vr(e, l, o);
    a !== void 0 && t.push(a);
  }
  return t;
}
function Pl(e, n, t) {
  const r = Qi(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = r.commaSeparated ? Di(t) : Gi(t)), r.property === "style") {
      let i = typeof t == "object" ? t : Rl(e, String(t));
      return e.stylePropertyNameCase === "css" && (i = Fl(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? Xi[r.property] || r.property : r.attribute,
      t
    ];
  }
}
function Rl(e, n) {
  const t = {};
  try {
    ml(n, r);
  } catch (i) {
    if (!e.ignoreInvalidStyle) {
      const l = (
        /** @type {Error} */
        i
      ), o = new ce("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: l,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw o.file = e.filePath || void 0, o.url = Hr + "#cannot-parse-style-attribute", o;
    }
  }
  return t;
  function r(i, l) {
    let o = i;
    o.slice(0, 2) !== "--" && (o.slice(0, 4) === "-ms-" && (o = "ms-" + o.slice(4)), o = o.replace(Cl, Bl)), t[o] = l;
  }
}
function qr(e, n, t) {
  let r;
  if (!t)
    r = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const i = n.split(".");
    let l = -1, o;
    for (; ++l < i.length; ) {
      const a = Tt(i[l]) ? { type: "Identifier", name: i[l] } : { type: "Literal", value: i[l] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: a,
        computed: !!(l && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = o;
  } else
    r = Tt(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (r.type === "Literal") {
    const i = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return mt.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  yn(e);
}
function yn(e, n) {
  const t = new ce(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = Hr + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function Fl(e) {
  const n = {};
  let t;
  for (t in e)
    mt.call(e, t) && (n[Dl(t)] = e[t]);
  return n;
}
function Dl(e) {
  let n = e.replace(wl, $l);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function Bl(e, n) {
  return n.toUpperCase();
}
function $l(e) {
  return "-" + e.toLowerCase();
}
const On = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, Ol = {};
function zl(e, n) {
  const t = Ol, r = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, i = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return Wr(e, r, i);
}
function Wr(e, n, t) {
  if (Hl(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return qt(e.children, n, t);
  }
  return Array.isArray(e) ? qt(e, n, t) : "";
}
function qt(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Wr(e[i], n, t);
  return r.join("");
}
function Hl(e) {
  return !!(e && typeof e == "object");
}
const Wt = document.createElement("i");
function wt(e) {
  const n = "&" + e + ";";
  Wt.innerHTML = n;
  const t = Wt.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function Pe(e, n, t, r) {
  const i = e.length;
  let l = 0, o;
  if (n < 0 ? n = -n > i ? 0 : i + n : n = n > i ? i : n, t = t > 0 ? t : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(n, t), e.splice(...o);
  else
    for (t && e.splice(n, t); l < r.length; )
      o = r.slice(l, l + 1e4), o.unshift(n, 0), e.splice(...o), l += 1e4, n += 1e4;
}
function _e(e, n) {
  return e.length > 0 ? (Pe(e, e.length, 0, n), e) : n;
}
const Zt = {}.hasOwnProperty;
function Vl(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    jl(n, e[t]);
  return n;
}
function jl(e, n) {
  let t;
  for (t in n) {
    const i = (Zt.call(e, t) ? e[t] : void 0) || (e[t] = {}), l = n[t];
    let o;
    if (l)
      for (o in l) {
        Zt.call(i, o) || (i[o] = []);
        const a = l[o];
        ql(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function ql(e, n) {
  let t = -1;
  const r = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : r).push(n[t]);
  Pe(e, 0, 0, r);
}
function Zr(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function rn(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Te = qe(/[A-Za-z]/), ve = qe(/[\dA-Za-z]/), Wl = qe(/[#-'*+\--9=?A-Z^-~]/);
function lt(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ot = qe(/\d/), Zl = qe(/[\dA-Fa-f]/), Ul = qe(/[!-/:-@[-`{-~]/);
function z(e) {
  return e !== null && e < -2;
}
function ge(e) {
  return e !== null && (e < 0 || e === 32);
}
function Q(e) {
  return e === -2 || e === -1 || e === 32;
}
const Ql = qe(new RegExp("\\p{P}|\\p{S}", "u")), Yl = qe(/\s/);
function qe(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function an(e) {
  const n = [];
  let t = -1, r = 0, i = 0;
  for (; ++t < e.length; ) {
    const l = e.charCodeAt(t);
    let o = "";
    if (l === 37 && ve(e.charCodeAt(t + 1)) && ve(e.charCodeAt(t + 2)))
      i = 2;
    else if (l < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(l)) || (o = String.fromCharCode(l));
    else if (l > 55295 && l < 57344) {
      const a = e.charCodeAt(t + 1);
      l < 56320 && a > 56319 && a < 57344 ? (o = String.fromCharCode(l, a), i = 1) : o = "�";
    } else
      o = String.fromCharCode(l);
    o && (n.push(e.slice(r, t), encodeURIComponent(o)), r = t + i + 1, o = ""), i && (t += i, i = 0);
  }
  return n.join("") + e.slice(r);
}
function ee(e, n, t, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let l = 0;
  return o;
  function o(s) {
    return Q(s) ? (e.enter(t), a(s)) : n(s);
  }
  function a(s) {
    return Q(s) && l++ < i ? (e.consume(s), a) : (e.exit(t), n(s));
  }
}
const Kl = {
  tokenize: Xl
};
function Xl(e) {
  const n = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let t;
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), ee(e, n, "linePrefix");
  }
  function i(a) {
    return e.enter("paragraph"), l(a);
  }
  function l(a) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = s), t = s, o(a);
  }
  function o(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return z(a) ? (e.consume(a), e.exit("chunkText"), l) : (e.consume(a), o);
  }
}
const Jl = {
  tokenize: Gl
}, Ut = {
  tokenize: eo
};
function Gl(e) {
  const n = this, t = [];
  let r = 0, i, l, o;
  return a;
  function a(v) {
    if (r < t.length) {
      const A = t[r];
      return n.containerState = A[1], e.attempt(
        A[0].continuation,
        s,
        c
      )(v);
    }
    return c(v);
  }
  function s(v) {
    if (r++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, i && I();
      const A = n.events.length;
      let L = A, y;
      for (; L--; )
        if (n.events[L][0] === "exit" && n.events[L][1].type === "chunkFlow") {
          y = n.events[L][1].end;
          break;
        }
      w(r);
      let T = A;
      for (; T < n.events.length; )
        n.events[T][1].end = Object.assign({}, y), T++;
      return Pe(
        n.events,
        L + 1,
        0,
        n.events.slice(A)
      ), n.events.length = T, c(v);
    }
    return a(v);
  }
  function c(v) {
    if (r === t.length) {
      if (!i)
        return f(v);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return C(v);
      n.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(
      Ut,
      p,
      d
    )(v);
  }
  function p(v) {
    return i && I(), w(r), f(v);
  }
  function d(v) {
    return n.parser.lazy[n.now().line] = r !== t.length, o = n.now().offset, C(v);
  }
  function f(v) {
    return n.containerState = {}, e.attempt(
      Ut,
      u,
      C
    )(v);
  }
  function u(v) {
    return r++, t.push([n.currentConstruct, n.containerState]), f(v);
  }
  function C(v) {
    if (v === null) {
      i && I(), w(0), e.consume(v);
      return;
    }
    return i = i || n.parser.flow(n.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: l,
      _tokenizer: i
    }), x(v);
  }
  function x(v) {
    if (v === null) {
      k(e.exit("chunkFlow"), !0), w(0), e.consume(v);
      return;
    }
    return z(v) ? (e.consume(v), k(e.exit("chunkFlow")), r = 0, n.interrupt = void 0, a) : (e.consume(v), x);
  }
  function k(v, A) {
    const L = n.sliceStream(v);
    if (A && L.push(null), v.previous = l, l && (l.next = v), l = v, i.defineSkip(v.start), i.write(L), n.parser.lazy[v.start.line]) {
      let y = i.events.length;
      for (; y--; )
        if (
          // The token starts before the line ending…
          i.events[y][1].start.offset < o && // …and either is not ended yet…
          (!i.events[y][1].end || // …or ends after it.
          i.events[y][1].end.offset > o)
        )
          return;
      const T = n.events.length;
      let P = T, _, E;
      for (; P--; )
        if (n.events[P][0] === "exit" && n.events[P][1].type === "chunkFlow") {
          if (_) {
            E = n.events[P][1].end;
            break;
          }
          _ = !0;
        }
      for (w(r), y = T; y < n.events.length; )
        n.events[y][1].end = Object.assign({}, E), y++;
      Pe(
        n.events,
        P + 1,
        0,
        n.events.slice(T)
      ), n.events.length = y;
    }
  }
  function w(v) {
    let A = t.length;
    for (; A-- > v; ) {
      const L = t[A];
      n.containerState = L[1], L[0].exit.call(n, e);
    }
    t.length = v;
  }
  function I() {
    i.write([null]), l = void 0, i = void 0, n.containerState._closeFlow = void 0;
  }
}
function eo(e, n, t) {
  return ee(
    e,
    e.attempt(this.parser.constructs.document, n, t),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Qt(e) {
  if (e === null || ge(e) || Yl(e))
    return 1;
  if (Ql(e))
    return 2;
}
function Ct(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const l = e[i].resolveAll;
    l && !r.includes(l) && (n = l(n, t), r.push(l));
  }
  return n;
}
const at = {
  name: "attention",
  tokenize: to,
  resolveAll: no
};
function no(e, n) {
  let t = -1, r, i, l, o, a, s, c, p;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (r = t; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        n.sliceSerialize(e[r][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          s = e[r][1].end.offset - e[r][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, e[r][1].end), f = Object.assign({}, e[t][1].start);
          Yt(d, -s), Yt(f, s), o = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, e[r][1].end)
          }, a = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[t][1].start),
            end: f
          }, l = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[t][1].start)
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: Object.assign({}, o.start),
            end: Object.assign({}, a.end)
          }, e[r][1].end = Object.assign({}, o.start), e[t][1].start = Object.assign({}, a.end), c = [], e[r][1].end.offset - e[r][1].start.offset && (c = _e(c, [
            ["enter", e[r][1], n],
            ["exit", e[r][1], n]
          ])), c = _e(c, [
            ["enter", i, n],
            ["enter", o, n],
            ["exit", o, n],
            ["enter", l, n]
          ]), c = _e(
            c,
            Ct(
              n.parser.constructs.insideSpan.null,
              e.slice(r + 1, t),
              n
            )
          ), c = _e(c, [
            ["exit", l, n],
            ["enter", a, n],
            ["exit", a, n],
            ["exit", i, n]
          ]), e[t][1].end.offset - e[t][1].start.offset ? (p = 2, c = _e(c, [
            ["enter", e[t][1], n],
            ["exit", e[t][1], n]
          ])) : p = 0, Pe(e, r - 1, t - r + 3, c), t = r + c.length - p - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function to(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Qt(r);
  let l;
  return o;
  function o(s) {
    return l = s, e.enter("attentionSequence"), a(s);
  }
  function a(s) {
    if (s === l)
      return e.consume(s), a;
    const c = e.exit("attentionSequence"), p = Qt(s), d = !p || p === 2 && i || t.includes(s), f = !i || i === 2 && p || t.includes(r);
    return c._open = !!(l === 42 ? d : d && (i || !f)), c._close = !!(l === 42 ? f : f && (p || !d)), n(s);
  }
}
function Yt(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const ro = {
  name: "autolink",
  tokenize: io
};
function io(e, n, t) {
  let r = 0;
  return i;
  function i(u) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(u), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), l;
  }
  function l(u) {
    return Te(u) ? (e.consume(u), o) : c(u);
  }
  function o(u) {
    return u === 43 || u === 45 || u === 46 || ve(u) ? (r = 1, a(u)) : c(u);
  }
  function a(u) {
    return u === 58 ? (e.consume(u), r = 0, s) : (u === 43 || u === 45 || u === 46 || ve(u)) && r++ < 32 ? (e.consume(u), a) : (r = 0, c(u));
  }
  function s(u) {
    return u === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(u), e.exit("autolinkMarker"), e.exit("autolink"), n) : u === null || u === 32 || u === 60 || lt(u) ? t(u) : (e.consume(u), s);
  }
  function c(u) {
    return u === 64 ? (e.consume(u), p) : Wl(u) ? (e.consume(u), c) : t(u);
  }
  function p(u) {
    return ve(u) ? d(u) : t(u);
  }
  function d(u) {
    return u === 46 ? (e.consume(u), r = 0, p) : u === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(u), e.exit("autolinkMarker"), e.exit("autolink"), n) : f(u);
  }
  function f(u) {
    if ((u === 45 || ve(u)) && r++ < 63) {
      const C = u === 45 ? f : d;
      return e.consume(u), C;
    }
    return t(u);
  }
}
const Pn = {
  tokenize: lo,
  partial: !0
};
function lo(e, n, t) {
  return r;
  function r(l) {
    return Q(l) ? ee(e, i, "linePrefix")(l) : i(l);
  }
  function i(l) {
    return l === null || z(l) ? n(l) : t(l);
  }
}
const Ur = {
  name: "blockQuote",
  tokenize: oo,
  continuation: {
    tokenize: ao
  },
  exit: so
};
function oo(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), l;
    }
    return t(o);
  }
  function l(o) {
    return Q(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(o));
  }
}
function ao(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return Q(o) ? ee(
      e,
      l,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(o) : l(o);
  }
  function l(o) {
    return e.attempt(Ur, n, t)(o);
  }
}
function so(e) {
  e.exit("blockQuote");
}
const Qr = {
  name: "characterEscape",
  tokenize: co
};
function co(e, n, t) {
  return r;
  function r(l) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(l), e.exit("escapeMarker"), i;
  }
  function i(l) {
    return Ul(l) ? (e.enter("characterEscapeValue"), e.consume(l), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(l);
  }
}
const Yr = {
  name: "characterReference",
  tokenize: uo
};
function uo(e, n, t) {
  const r = this;
  let i = 0, l, o;
  return a;
  function a(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), s;
  }
  function s(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), l = 31, o = ve, p(d));
  }
  function c(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), l = 6, o = Zl, p) : (e.enter("characterReferenceValue"), l = 7, o = ot, p(d));
  }
  function p(d) {
    if (d === 59 && i) {
      const f = e.exit("characterReferenceValue");
      return o === ve && !wt(r.sliceSerialize(f)) ? t(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return o(d) && i++ < l ? (e.consume(d), p) : t(d);
  }
}
const Kt = {
  tokenize: ho,
  partial: !0
}, Xt = {
  name: "codeFenced",
  tokenize: po,
  concrete: !0
};
function po(e, n, t) {
  const r = this, i = {
    tokenize: L,
    partial: !0
  };
  let l = 0, o = 0, a;
  return s;
  function s(y) {
    return c(y);
  }
  function c(y) {
    const T = r.events[r.events.length - 1];
    return l = T && T[1].type === "linePrefix" ? T[2].sliceSerialize(T[1], !0).length : 0, a = y, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), p(y);
  }
  function p(y) {
    return y === a ? (o++, e.consume(y), p) : o < 3 ? t(y) : (e.exit("codeFencedFenceSequence"), Q(y) ? ee(e, d, "whitespace")(y) : d(y));
  }
  function d(y) {
    return y === null || z(y) ? (e.exit("codeFencedFence"), r.interrupt ? n(y) : e.check(Kt, x, A)(y)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(y));
  }
  function f(y) {
    return y === null || z(y) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(y)) : Q(y) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ee(e, u, "whitespace")(y)) : y === 96 && y === a ? t(y) : (e.consume(y), f);
  }
  function u(y) {
    return y === null || z(y) ? d(y) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(y));
  }
  function C(y) {
    return y === null || z(y) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(y)) : y === 96 && y === a ? t(y) : (e.consume(y), C);
  }
  function x(y) {
    return e.attempt(i, A, k)(y);
  }
  function k(y) {
    return e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), w;
  }
  function w(y) {
    return l > 0 && Q(y) ? ee(
      e,
      I,
      "linePrefix",
      l + 1
    )(y) : I(y);
  }
  function I(y) {
    return y === null || z(y) ? e.check(Kt, x, A)(y) : (e.enter("codeFlowValue"), v(y));
  }
  function v(y) {
    return y === null || z(y) ? (e.exit("codeFlowValue"), I(y)) : (e.consume(y), v);
  }
  function A(y) {
    return e.exit("codeFenced"), n(y);
  }
  function L(y, T, P) {
    let _ = 0;
    return E;
    function E($) {
      return y.enter("lineEnding"), y.consume($), y.exit("lineEnding"), S;
    }
    function S($) {
      return y.enter("codeFencedFence"), Q($) ? ee(
        y,
        M,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )($) : M($);
    }
    function M($) {
      return $ === a ? (y.enter("codeFencedFenceSequence"), F($)) : P($);
    }
    function F($) {
      return $ === a ? (_++, y.consume($), F) : _ >= o ? (y.exit("codeFencedFenceSequence"), Q($) ? ee(y, O, "whitespace")($) : O($)) : P($);
    }
    function O($) {
      return $ === null || z($) ? (y.exit("codeFencedFence"), T($)) : P($);
    }
  }
}
function ho(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? t(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
const zn = {
  name: "codeIndented",
  tokenize: mo
}, fo = {
  tokenize: go,
  partial: !0
};
function mo(e, n, t) {
  const r = this;
  return i;
  function i(c) {
    return e.enter("codeIndented"), ee(e, l, "linePrefix", 5)(c);
  }
  function l(c) {
    const p = r.events[r.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? o(c) : t(c);
  }
  function o(c) {
    return c === null ? s(c) : z(c) ? e.attempt(fo, o, s)(c) : (e.enter("codeFlowValue"), a(c));
  }
  function a(c) {
    return c === null || z(c) ? (e.exit("codeFlowValue"), o(c)) : (e.consume(c), a);
  }
  function s(c) {
    return e.exit("codeIndented"), n(c);
  }
}
function go(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? t(o) : z(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : ee(e, l, "linePrefix", 5)(o);
  }
  function l(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : z(o) ? i(o) : t(o);
  }
}
const yo = {
  name: "codeText",
  tokenize: xo,
  resolve: wo,
  previous: Co
};
function wo(e) {
  let n = e.length - 4, t = 3, r, i;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (r = t; ++r < n; )
      if (e[r][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (r = t - 1, n++; ++r <= n; )
    i === void 0 ? r !== n && e[r][1].type !== "lineEnding" && (i = r) : (r === n || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), n -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function Co(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function xo(e, n, t) {
  let r = 0, i, l;
  return o;
  function o(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(d);
  }
  function a(d) {
    return d === 96 ? (e.consume(d), r++, a) : (e.exit("codeTextSequence"), s(d));
  }
  function s(d) {
    return d === null ? t(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), s) : d === 96 ? (l = e.enter("codeTextSequence"), i = 0, p(d)) : z(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), s) : (e.enter("codeTextData"), c(d));
  }
  function c(d) {
    return d === null || d === 32 || d === 96 || z(d) ? (e.exit("codeTextData"), s(d)) : (e.consume(d), c);
  }
  function p(d) {
    return d === 96 ? (e.consume(d), i++, p) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), n(d)) : (l.type = "codeTextData", c(d));
  }
}
function Kr(e) {
  const n = {};
  let t = -1, r, i, l, o, a, s, c;
  for (; ++t < e.length; ) {
    for (; t in n; )
      t = n[t];
    if (r = e[t], t && r[1].type === "chunkFlow" && e[t - 1][1].type === "listItemPrefix" && (s = r[1]._tokenizer.events, l = 0, l < s.length && s[l][1].type === "lineEndingBlank" && (l += 2), l < s.length && s[l][1].type === "content"))
      for (; ++l < s.length && s[l][1].type !== "content"; )
        s[l][1].type === "chunkText" && (s[l][1]._isInFirstContentOfListItem = !0, l++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(n, vo(e, t)), t = n[t], c = !0);
    else if (r[1]._container) {
      for (l = t, i = void 0; l-- && (o = e[l], o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = l);
      i && (r[1].end = Object.assign({}, e[i][1].start), a = e.slice(i, t), a.unshift(r), Pe(e, i, t - i + 1, a));
    }
  }
  return !c;
}
function vo(e, n) {
  const t = e[n][1], r = e[n][2];
  let i = n - 1;
  const l = [], o = t._tokenizer || r.parser[t.contentType](t.start), a = o.events, s = [], c = {};
  let p, d, f = -1, u = t, C = 0, x = 0;
  const k = [x];
  for (; u; ) {
    for (; e[++i][1] !== u; )
      ;
    l.push(i), u._tokenizer || (p = r.sliceStream(u), u.next || p.push(null), d && o.defineSkip(u.start), u._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(p), u._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = u, u = u.next;
  }
  for (u = t; ++f < a.length; )
    // Find a void token that includes a break.
    a[f][0] === "exit" && a[f - 1][0] === "enter" && a[f][1].type === a[f - 1][1].type && a[f][1].start.line !== a[f][1].end.line && (x = f + 1, k.push(x), u._tokenizer = void 0, u.previous = void 0, u = u.next);
  for (o.events = [], u ? (u._tokenizer = void 0, u.previous = void 0) : k.pop(), f = k.length; f--; ) {
    const w = a.slice(k[f], k[f + 1]), I = l.pop();
    s.unshift([I, I + w.length - 1]), Pe(e, I, 2, w);
  }
  for (f = -1; ++f < s.length; )
    c[C + s[f][0]] = C + s[f][1], C += s[f][1] - s[f][0] - 1;
  return c;
}
const bo = {
  tokenize: Io,
  resolve: _o
}, ko = {
  tokenize: Eo,
  partial: !0
};
function _o(e) {
  return Kr(e), e;
}
function Io(e, n) {
  let t;
  return r;
  function r(a) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), i(a);
  }
  function i(a) {
    return a === null ? l(a) : z(a) ? e.check(
      ko,
      o,
      l
    )(a) : (e.consume(a), i);
  }
  function l(a) {
    return e.exit("chunkContent"), e.exit("content"), n(a);
  }
  function o(a) {
    return e.consume(a), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, i;
  }
}
function Eo(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), ee(e, l, "linePrefix");
  }
  function l(o) {
    if (o === null || z(o))
      return t(o);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : e.interrupt(r.parser.constructs.flow, t, n)(o);
  }
}
function Xr(e, n, t, r, i, l, o, a, s) {
  const c = s || Number.POSITIVE_INFINITY;
  let p = 0;
  return d;
  function d(w) {
    return w === 60 ? (e.enter(r), e.enter(i), e.enter(l), e.consume(w), e.exit(l), f) : w === null || w === 32 || w === 41 || lt(w) ? t(w) : (e.enter(r), e.enter(o), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), x(w));
  }
  function f(w) {
    return w === 62 ? (e.enter(l), e.consume(w), e.exit(l), e.exit(i), e.exit(r), n) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), u(w));
  }
  function u(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(a), f(w)) : w === null || w === 60 || z(w) ? t(w) : (e.consume(w), w === 92 ? C : u);
  }
  function C(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), u) : u(w);
  }
  function x(w) {
    return !p && (w === null || w === 41 || ge(w)) ? (e.exit("chunkString"), e.exit(a), e.exit(o), e.exit(r), n(w)) : p < c && w === 40 ? (e.consume(w), p++, x) : w === 41 ? (e.consume(w), p--, x) : w === null || w === 32 || w === 40 || lt(w) ? t(w) : (e.consume(w), w === 92 ? k : x);
  }
  function k(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), x) : x(w);
  }
}
function Jr(e, n, t, r, i, l) {
  const o = this;
  let a = 0, s;
  return c;
  function c(u) {
    return e.enter(r), e.enter(i), e.consume(u), e.exit(i), e.enter(l), p;
  }
  function p(u) {
    return a > 999 || u === null || u === 91 || u === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    u === 94 && !a && "_hiddenFootnoteSupport" in o.parser.constructs ? t(u) : u === 93 ? (e.exit(l), e.enter(i), e.consume(u), e.exit(i), e.exit(r), n) : z(u) ? (e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), p) : (e.enter("chunkString", {
      contentType: "string"
    }), d(u));
  }
  function d(u) {
    return u === null || u === 91 || u === 93 || z(u) || a++ > 999 ? (e.exit("chunkString"), p(u)) : (e.consume(u), s || (s = !Q(u)), u === 92 ? f : d);
  }
  function f(u) {
    return u === 91 || u === 92 || u === 93 ? (e.consume(u), a++, d) : d(u);
  }
}
function Gr(e, n, t, r, i, l) {
  let o;
  return a;
  function a(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(r), e.enter(i), e.consume(f), e.exit(i), o = f === 40 ? 41 : f, s) : t(f);
  }
  function s(f) {
    return f === o ? (e.enter(i), e.consume(f), e.exit(i), e.exit(r), n) : (e.enter(l), c(f));
  }
  function c(f) {
    return f === o ? (e.exit(l), s(o)) : f === null ? t(f) : z(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), ee(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), p(f));
  }
  function p(f) {
    return f === o || f === null || z(f) ? (e.exit("chunkString"), c(f)) : (e.consume(f), f === 92 ? d : p);
  }
  function d(f) {
    return f === o || f === 92 ? (e.consume(f), p) : p(f);
  }
}
function mn(e, n) {
  let t;
  return r;
  function r(i) {
    return z(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t = !0, r) : Q(i) ? ee(
      e,
      r,
      t ? "linePrefix" : "lineSuffix"
    )(i) : n(i);
  }
}
const So = {
  name: "definition",
  tokenize: Lo
}, No = {
  tokenize: Ao,
  partial: !0
};
function Lo(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(u) {
    return e.enter("definition"), o(u);
  }
  function o(u) {
    return Jr.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(u);
  }
  function a(u) {
    return i = rn(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), u === 58 ? (e.enter("definitionMarker"), e.consume(u), e.exit("definitionMarker"), s) : t(u);
  }
  function s(u) {
    return ge(u) ? mn(e, c)(u) : c(u);
  }
  function c(u) {
    return Xr(
      e,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(u);
  }
  function p(u) {
    return e.attempt(No, d, d)(u);
  }
  function d(u) {
    return Q(u) ? ee(e, f, "whitespace")(u) : f(u);
  }
  function f(u) {
    return u === null || z(u) ? (e.exit("definition"), r.parser.defined.push(i), n(u)) : t(u);
  }
}
function Ao(e, n, t) {
  return r;
  function r(a) {
    return ge(a) ? mn(e, i)(a) : t(a);
  }
  function i(a) {
    return Gr(
      e,
      l,
      t,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(a);
  }
  function l(a) {
    return Q(a) ? ee(e, o, "whitespace")(a) : o(a);
  }
  function o(a) {
    return a === null || z(a) ? n(a) : t(a);
  }
}
const Mo = {
  name: "hardBreakEscape",
  tokenize: To
};
function To(e, n, t) {
  return r;
  function r(l) {
    return e.enter("hardBreakEscape"), e.consume(l), i;
  }
  function i(l) {
    return z(l) ? (e.exit("hardBreakEscape"), n(l)) : t(l);
  }
}
const Po = {
  name: "headingAtx",
  tokenize: Fo,
  resolve: Ro
};
function Ro(e, n) {
  let t = e.length - 2, r = 3, i, l;
  return e[r][1].type === "whitespace" && (r += 2), t - 2 > r && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (r === t - 1 || t - 4 > r && e[t - 2][1].type === "whitespace") && (t -= r + 1 === t ? 2 : 4), t > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[t][1].end
  }, l = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, Pe(e, r, t - r + 1, [
    ["enter", i, n],
    ["enter", l, n],
    ["exit", l, n],
    ["exit", i, n]
  ])), e;
}
function Fo(e, n, t) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("atxHeading"), l(p);
  }
  function l(p) {
    return e.enter("atxHeadingSequence"), o(p);
  }
  function o(p) {
    return p === 35 && r++ < 6 ? (e.consume(p), o) : p === null || ge(p) ? (e.exit("atxHeadingSequence"), a(p)) : t(p);
  }
  function a(p) {
    return p === 35 ? (e.enter("atxHeadingSequence"), s(p)) : p === null || z(p) ? (e.exit("atxHeading"), n(p)) : Q(p) ? ee(e, a, "whitespace")(p) : (e.enter("atxHeadingText"), c(p));
  }
  function s(p) {
    return p === 35 ? (e.consume(p), s) : (e.exit("atxHeadingSequence"), a(p));
  }
  function c(p) {
    return p === null || p === 35 || ge(p) ? (e.exit("atxHeadingText"), a(p)) : (e.consume(p), c);
  }
}
const Do = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Jt = ["pre", "script", "style", "textarea"], Bo = {
  name: "htmlFlow",
  tokenize: Ho,
  resolveTo: zo,
  concrete: !0
}, $o = {
  tokenize: jo,
  partial: !0
}, Oo = {
  tokenize: Vo,
  partial: !0
};
function zo(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Ho(e, n, t) {
  const r = this;
  let i, l, o, a, s;
  return c;
  function c(h) {
    return p(h);
  }
  function p(h) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(h), d;
  }
  function d(h) {
    return h === 33 ? (e.consume(h), f) : h === 47 ? (e.consume(h), l = !0, x) : h === 63 ? (e.consume(h), i = 3, r.interrupt ? n : g) : Te(h) ? (e.consume(h), o = String.fromCharCode(h), k) : t(h);
  }
  function f(h) {
    return h === 45 ? (e.consume(h), i = 2, u) : h === 91 ? (e.consume(h), i = 5, a = 0, C) : Te(h) ? (e.consume(h), i = 4, r.interrupt ? n : g) : t(h);
  }
  function u(h) {
    return h === 45 ? (e.consume(h), r.interrupt ? n : g) : t(h);
  }
  function C(h) {
    const W = "CDATA[";
    return h === W.charCodeAt(a++) ? (e.consume(h), a === W.length ? r.interrupt ? n : M : C) : t(h);
  }
  function x(h) {
    return Te(h) ? (e.consume(h), o = String.fromCharCode(h), k) : t(h);
  }
  function k(h) {
    if (h === null || h === 47 || h === 62 || ge(h)) {
      const W = h === 47, X = o.toLowerCase();
      return !W && !l && Jt.includes(X) ? (i = 1, r.interrupt ? n(h) : M(h)) : Do.includes(o.toLowerCase()) ? (i = 6, W ? (e.consume(h), w) : r.interrupt ? n(h) : M(h)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? t(h) : l ? I(h) : v(h));
    }
    return h === 45 || ve(h) ? (e.consume(h), o += String.fromCharCode(h), k) : t(h);
  }
  function w(h) {
    return h === 62 ? (e.consume(h), r.interrupt ? n : M) : t(h);
  }
  function I(h) {
    return Q(h) ? (e.consume(h), I) : E(h);
  }
  function v(h) {
    return h === 47 ? (e.consume(h), E) : h === 58 || h === 95 || Te(h) ? (e.consume(h), A) : Q(h) ? (e.consume(h), v) : E(h);
  }
  function A(h) {
    return h === 45 || h === 46 || h === 58 || h === 95 || ve(h) ? (e.consume(h), A) : L(h);
  }
  function L(h) {
    return h === 61 ? (e.consume(h), y) : Q(h) ? (e.consume(h), L) : v(h);
  }
  function y(h) {
    return h === null || h === 60 || h === 61 || h === 62 || h === 96 ? t(h) : h === 34 || h === 39 ? (e.consume(h), s = h, T) : Q(h) ? (e.consume(h), y) : P(h);
  }
  function T(h) {
    return h === s ? (e.consume(h), s = null, _) : h === null || z(h) ? t(h) : (e.consume(h), T);
  }
  function P(h) {
    return h === null || h === 34 || h === 39 || h === 47 || h === 60 || h === 61 || h === 62 || h === 96 || ge(h) ? L(h) : (e.consume(h), P);
  }
  function _(h) {
    return h === 47 || h === 62 || Q(h) ? v(h) : t(h);
  }
  function E(h) {
    return h === 62 ? (e.consume(h), S) : t(h);
  }
  function S(h) {
    return h === null || z(h) ? M(h) : Q(h) ? (e.consume(h), S) : t(h);
  }
  function M(h) {
    return h === 45 && i === 2 ? (e.consume(h), te) : h === 60 && i === 1 ? (e.consume(h), le) : h === 62 && i === 4 ? (e.consume(h), H) : h === 63 && i === 3 ? (e.consume(h), g) : h === 93 && i === 5 ? (e.consume(h), be) : z(h) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      $o,
      j,
      F
    )(h)) : h === null || z(h) ? (e.exit("htmlFlowData"), F(h)) : (e.consume(h), M);
  }
  function F(h) {
    return e.check(
      Oo,
      O,
      j
    )(h);
  }
  function O(h) {
    return e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), $;
  }
  function $(h) {
    return h === null || z(h) ? F(h) : (e.enter("htmlFlowData"), M(h));
  }
  function te(h) {
    return h === 45 ? (e.consume(h), g) : M(h);
  }
  function le(h) {
    return h === 47 ? (e.consume(h), o = "", de) : M(h);
  }
  function de(h) {
    if (h === 62) {
      const W = o.toLowerCase();
      return Jt.includes(W) ? (e.consume(h), H) : M(h);
    }
    return Te(h) && o.length < 8 ? (e.consume(h), o += String.fromCharCode(h), de) : M(h);
  }
  function be(h) {
    return h === 93 ? (e.consume(h), g) : M(h);
  }
  function g(h) {
    return h === 62 ? (e.consume(h), H) : h === 45 && i === 2 ? (e.consume(h), g) : M(h);
  }
  function H(h) {
    return h === null || z(h) ? (e.exit("htmlFlowData"), j(h)) : (e.consume(h), H);
  }
  function j(h) {
    return e.exit("htmlFlow"), n(h);
  }
}
function Vo(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return z(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l) : t(o);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
function jo(e, n, t) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Pn, n, t);
  }
}
const qo = {
  name: "htmlText",
  tokenize: Wo
};
function Wo(e, n, t) {
  const r = this;
  let i, l, o;
  return a;
  function a(g) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(g), s;
  }
  function s(g) {
    return g === 33 ? (e.consume(g), c) : g === 47 ? (e.consume(g), L) : g === 63 ? (e.consume(g), v) : Te(g) ? (e.consume(g), P) : t(g);
  }
  function c(g) {
    return g === 45 ? (e.consume(g), p) : g === 91 ? (e.consume(g), l = 0, C) : Te(g) ? (e.consume(g), I) : t(g);
  }
  function p(g) {
    return g === 45 ? (e.consume(g), u) : t(g);
  }
  function d(g) {
    return g === null ? t(g) : g === 45 ? (e.consume(g), f) : z(g) ? (o = d, le(g)) : (e.consume(g), d);
  }
  function f(g) {
    return g === 45 ? (e.consume(g), u) : d(g);
  }
  function u(g) {
    return g === 62 ? te(g) : g === 45 ? f(g) : d(g);
  }
  function C(g) {
    const H = "CDATA[";
    return g === H.charCodeAt(l++) ? (e.consume(g), l === H.length ? x : C) : t(g);
  }
  function x(g) {
    return g === null ? t(g) : g === 93 ? (e.consume(g), k) : z(g) ? (o = x, le(g)) : (e.consume(g), x);
  }
  function k(g) {
    return g === 93 ? (e.consume(g), w) : x(g);
  }
  function w(g) {
    return g === 62 ? te(g) : g === 93 ? (e.consume(g), w) : x(g);
  }
  function I(g) {
    return g === null || g === 62 ? te(g) : z(g) ? (o = I, le(g)) : (e.consume(g), I);
  }
  function v(g) {
    return g === null ? t(g) : g === 63 ? (e.consume(g), A) : z(g) ? (o = v, le(g)) : (e.consume(g), v);
  }
  function A(g) {
    return g === 62 ? te(g) : v(g);
  }
  function L(g) {
    return Te(g) ? (e.consume(g), y) : t(g);
  }
  function y(g) {
    return g === 45 || ve(g) ? (e.consume(g), y) : T(g);
  }
  function T(g) {
    return z(g) ? (o = T, le(g)) : Q(g) ? (e.consume(g), T) : te(g);
  }
  function P(g) {
    return g === 45 || ve(g) ? (e.consume(g), P) : g === 47 || g === 62 || ge(g) ? _(g) : t(g);
  }
  function _(g) {
    return g === 47 ? (e.consume(g), te) : g === 58 || g === 95 || Te(g) ? (e.consume(g), E) : z(g) ? (o = _, le(g)) : Q(g) ? (e.consume(g), _) : te(g);
  }
  function E(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || ve(g) ? (e.consume(g), E) : S(g);
  }
  function S(g) {
    return g === 61 ? (e.consume(g), M) : z(g) ? (o = S, le(g)) : Q(g) ? (e.consume(g), S) : _(g);
  }
  function M(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? t(g) : g === 34 || g === 39 ? (e.consume(g), i = g, F) : z(g) ? (o = M, le(g)) : Q(g) ? (e.consume(g), M) : (e.consume(g), O);
  }
  function F(g) {
    return g === i ? (e.consume(g), i = void 0, $) : g === null ? t(g) : z(g) ? (o = F, le(g)) : (e.consume(g), F);
  }
  function O(g) {
    return g === null || g === 34 || g === 39 || g === 60 || g === 61 || g === 96 ? t(g) : g === 47 || g === 62 || ge(g) ? _(g) : (e.consume(g), O);
  }
  function $(g) {
    return g === 47 || g === 62 || ge(g) ? _(g) : t(g);
  }
  function te(g) {
    return g === 62 ? (e.consume(g), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(g);
  }
  function le(g) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), de;
  }
  function de(g) {
    return Q(g) ? ee(
      e,
      be,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(g) : be(g);
  }
  function be(g) {
    return e.enter("htmlTextData"), o(g);
  }
}
const xt = {
  name: "labelEnd",
  tokenize: Xo,
  resolveTo: Ko,
  resolveAll: Yo
}, Zo = {
  tokenize: Jo
}, Uo = {
  tokenize: Go
}, Qo = {
  tokenize: ea
};
function Yo(e) {
  let n = -1;
  for (; ++n < e.length; ) {
    const t = e[n][1];
    (t.type === "labelImage" || t.type === "labelLink" || t.type === "labelEnd") && (e.splice(n + 1, t.type === "labelImage" ? 4 : 2), t.type = "data", n++);
  }
  return e;
}
function Ko(e, n) {
  let t = e.length, r = 0, i, l, o, a;
  for (; t--; )
    if (i = e[t][1], l) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[t][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[t][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (l = t, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = t);
  const s = {
    type: e[l][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[l][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, c = {
    type: "label",
    start: Object.assign({}, e[l][1].start),
    end: Object.assign({}, e[o][1].end)
  }, p = {
    type: "labelText",
    start: Object.assign({}, e[l + r + 2][1].end),
    end: Object.assign({}, e[o - 2][1].start)
  };
  return a = [
    ["enter", s, n],
    ["enter", c, n]
  ], a = _e(a, e.slice(l + 1, l + r + 3)), a = _e(a, [["enter", p, n]]), a = _e(
    a,
    Ct(
      n.parser.constructs.insideSpan.null,
      e.slice(l + r + 4, o - 3),
      n
    )
  ), a = _e(a, [
    ["exit", p, n],
    e[o - 2],
    e[o - 1],
    ["exit", c, n]
  ]), a = _e(a, e.slice(o + 1)), a = _e(a, [["exit", s, n]]), Pe(e, l, e.length, a), e;
}
function Xo(e, n, t) {
  const r = this;
  let i = r.events.length, l, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      l = r.events[i][1];
      break;
    }
  return a;
  function a(f) {
    return l ? l._inactive ? d(f) : (o = r.parser.defined.includes(
      rn(
        r.sliceSerialize({
          start: l.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), s) : t(f);
  }
  function s(f) {
    return f === 40 ? e.attempt(
      Zo,
      p,
      o ? p : d
    )(f) : f === 91 ? e.attempt(
      Uo,
      p,
      o ? c : d
    )(f) : o ? p(f) : d(f);
  }
  function c(f) {
    return e.attempt(
      Qo,
      p,
      d
    )(f);
  }
  function p(f) {
    return n(f);
  }
  function d(f) {
    return l._balanced = !0, t(f);
  }
}
function Jo(e, n, t) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return ge(d) ? mn(e, l)(d) : l(d);
  }
  function l(d) {
    return d === 41 ? p(d) : Xr(
      e,
      o,
      a,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(d);
  }
  function o(d) {
    return ge(d) ? mn(e, s)(d) : p(d);
  }
  function a(d) {
    return t(d);
  }
  function s(d) {
    return d === 34 || d === 39 || d === 40 ? Gr(
      e,
      c,
      t,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(d) : p(d);
  }
  function c(d) {
    return ge(d) ? mn(e, p)(d) : p(d);
  }
  function p(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), n) : t(d);
  }
}
function Go(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return Jr.call(
      r,
      e,
      l,
      o,
      "reference",
      "referenceMarker",
      "referenceString"
    )(a);
  }
  function l(a) {
    return r.parser.defined.includes(
      rn(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? n(a) : t(a);
  }
  function o(a) {
    return t(a);
  }
}
function ea(e, n, t) {
  return r;
  function r(l) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), i;
  }
  function i(l) {
    return l === 93 ? (e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), e.exit("reference"), n) : t(l);
  }
}
const na = {
  name: "labelStartImage",
  tokenize: ta,
  resolveAll: xt.resolveAll
};
function ta(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), l;
  }
  function l(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), o) : t(a);
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(a) : n(a);
  }
}
const ra = {
  name: "labelStartLink",
  tokenize: ia,
  resolveAll: xt.resolveAll
};
function ia(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), l;
  }
  function l(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(o) : n(o);
  }
}
const Hn = {
  name: "lineEnding",
  tokenize: la
};
function la(e, n) {
  return t;
  function t(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), ee(e, n, "linePrefix");
  }
}
const Sn = {
  name: "thematicBreak",
  tokenize: oa
};
function oa(e, n, t) {
  let r = 0, i;
  return l;
  function l(c) {
    return e.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return i = c, a(c);
  }
  function a(c) {
    return c === i ? (e.enter("thematicBreakSequence"), s(c)) : r >= 3 && (c === null || z(c)) ? (e.exit("thematicBreak"), n(c)) : t(c);
  }
  function s(c) {
    return c === i ? (e.consume(c), r++, s) : (e.exit("thematicBreakSequence"), Q(c) ? ee(e, a, "whitespace")(c) : a(c));
  }
}
const me = {
  name: "list",
  tokenize: ca,
  continuation: {
    tokenize: ua
  },
  exit: da
}, aa = {
  tokenize: ha,
  partial: !0
}, sa = {
  tokenize: pa,
  partial: !0
};
function ca(e, n, t) {
  const r = this, i = r.events[r.events.length - 1];
  let l = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return a;
  function a(u) {
    const C = r.containerState.type || (u === 42 || u === 43 || u === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !r.containerState.marker || u === r.containerState.marker : ot(u)) {
      if (r.containerState.type || (r.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), u === 42 || u === 45 ? e.check(Sn, t, c)(u) : c(u);
      if (!r.interrupt || u === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(u);
    }
    return t(u);
  }
  function s(u) {
    return ot(u) && ++o < 10 ? (e.consume(u), s) : (!r.interrupt || o < 2) && (r.containerState.marker ? u === r.containerState.marker : u === 41 || u === 46) ? (e.exit("listItemValue"), c(u)) : t(u);
  }
  function c(u) {
    return e.enter("listItemMarker"), e.consume(u), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || u, e.check(
      Pn,
      // Can’t be empty when interrupting.
      r.interrupt ? t : p,
      e.attempt(
        aa,
        f,
        d
      )
    );
  }
  function p(u) {
    return r.containerState.initialBlankLine = !0, l++, f(u);
  }
  function d(u) {
    return Q(u) ? (e.enter("listItemPrefixWhitespace"), e.consume(u), e.exit("listItemPrefixWhitespace"), f) : t(u);
  }
  function f(u) {
    return r.containerState.size = l + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(u);
  }
}
function ua(e, n, t) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Pn, i, l);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, ee(
      e,
      n,
      "listItemIndent",
      r.containerState.size + 1
    )(a);
  }
  function l(a) {
    return r.containerState.furtherBlankLines || !Q(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(sa, n, o)(a));
  }
  function o(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, ee(
      e,
      e.attempt(me, n, t),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a);
  }
}
function pa(e, n, t) {
  const r = this;
  return ee(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(l) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? n(l) : t(l);
  }
}
function da(e) {
  e.exit(this.containerState.type);
}
function ha(e, n, t) {
  const r = this;
  return ee(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5
  );
  function i(l) {
    const o = r.events[r.events.length - 1];
    return !Q(l) && o && o[1].type === "listItemPrefixWhitespace" ? n(l) : t(l);
  }
}
const Gt = {
  name: "setextUnderline",
  tokenize: ma,
  resolveTo: fa
};
function fa(e, n) {
  let t = e.length, r, i, l;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        r = t;
        break;
      }
      e[t][1].type === "paragraph" && (i = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !l && e[t][1].type === "definition" && (l = t);
  const o = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", l ? (e.splice(i, 0, ["enter", o, n]), e.splice(l + 1, 0, ["exit", e[r][1], n]), e[r][1].end = Object.assign({}, e[l][1].end)) : e[r][1] = o, e.push(["exit", o, n]), e;
}
function ma(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(c) {
    let p = r.events.length, d;
    for (; p--; )
      if (r.events[p][1].type !== "lineEnding" && r.events[p][1].type !== "linePrefix" && r.events[p][1].type !== "content") {
        d = r.events[p][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = c, o(c)) : t(c);
  }
  function o(c) {
    return e.enter("setextHeadingLineSequence"), a(c);
  }
  function a(c) {
    return c === i ? (e.consume(c), a) : (e.exit("setextHeadingLineSequence"), Q(c) ? ee(e, s, "lineSuffix")(c) : s(c));
  }
  function s(c) {
    return c === null || z(c) ? (e.exit("setextHeadingLine"), n(c)) : t(c);
  }
}
const ga = {
  tokenize: ya
};
function ya(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    Pn,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      ee(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(bo, i)
        ),
        "linePrefix"
      )
    )
  );
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(l), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const wa = {
  resolveAll: ni()
}, Ca = ei("string"), xa = ei("text");
function ei(e) {
  return {
    tokenize: n,
    resolveAll: ni(
      e === "text" ? va : void 0
    )
  };
  function n(t) {
    const r = this, i = this.parser.constructs[e], l = t.attempt(i, o, a);
    return o;
    function o(p) {
      return c(p) ? l(p) : a(p);
    }
    function a(p) {
      if (p === null) {
        t.consume(p);
        return;
      }
      return t.enter("data"), t.consume(p), s;
    }
    function s(p) {
      return c(p) ? (t.exit("data"), l(p)) : (t.consume(p), s);
    }
    function c(p) {
      if (p === null)
        return !0;
      const d = i[p];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const u = d[f];
          if (!u.previous || u.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ni(e) {
  return n;
  function n(t, r) {
    let i = -1, l;
    for (; ++i <= t.length; )
      l === void 0 ? t[i] && t[i][1].type === "data" && (l = i, i++) : (!t[i] || t[i][1].type !== "data") && (i !== l + 2 && (t[l][1].end = t[i - 1][1].end, t.splice(l + 2, i - l - 2), i = l + 2), l = void 0);
    return e ? e(t, r) : t;
  }
}
function va(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const r = e[t - 1][1], i = n.sliceStream(r);
      let l = i.length, o = -1, a = 0, s;
      for (; l--; ) {
        const c = i[l];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32; )
            a++, o--;
          if (o) break;
          o = -1;
        } else if (c === -2)
          s = !0, a++;
        else if (c !== -1) {
          l++;
          break;
        }
      }
      if (a) {
        const c = {
          type: t === e.length || s || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a,
            _index: r.start._index + l,
            _bufferIndex: l ? o : r.start._bufferIndex + o
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, c.start), r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(
          t,
          0,
          ["enter", c, n],
          ["exit", c, n]
        ), t += 2);
      }
      t++;
    }
  return e;
}
function ba(e, n, t) {
  let r = Object.assign(
    t ? Object.assign({}, t) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, l = [];
  let o = [], a = [];
  const s = {
    consume: I,
    enter: v,
    exit: A,
    attempt: T(L),
    check: T(y),
    interrupt: T(y, {
      interrupt: !0
    })
  }, c = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: u,
    sliceSerialize: f,
    now: C,
    defineSkip: x,
    write: d
  };
  let p = n.tokenize.call(c, s);
  return n.resolveAll && l.push(n), c;
  function d(S) {
    return o = _e(o, S), k(), o[o.length - 1] !== null ? [] : (P(n, 0), c.events = Ct(l, c.events, c), c.events);
  }
  function f(S, M) {
    return _a(u(S), M);
  }
  function u(S) {
    return ka(o, S);
  }
  function C() {
    const { line: S, column: M, offset: F, _index: O, _bufferIndex: $ } = r;
    return {
      line: S,
      column: M,
      offset: F,
      _index: O,
      _bufferIndex: $
    };
  }
  function x(S) {
    i[S.line] = S.column, E();
  }
  function k() {
    let S;
    for (; r._index < o.length; ) {
      const M = o[r._index];
      if (typeof M == "string")
        for (S = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === S && r._bufferIndex < M.length; )
          w(M.charCodeAt(r._bufferIndex));
      else
        w(M);
    }
  }
  function w(S) {
    p = p(S);
  }
  function I(S) {
    z(S) ? (r.line++, r.column = 1, r.offset += S === -3 ? 2 : 1, E()) : S !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = S;
  }
  function v(S, M) {
    const F = M || {};
    return F.type = S, F.start = C(), c.events.push(["enter", F, c]), a.push(F), F;
  }
  function A(S) {
    const M = a.pop();
    return M.end = C(), c.events.push(["exit", M, c]), M;
  }
  function L(S, M) {
    P(S, M.from);
  }
  function y(S, M) {
    M.restore();
  }
  function T(S, M) {
    return F;
    function F(O, $, te) {
      let le, de, be, g;
      return Array.isArray(O) ? j(O) : "tokenize" in O ? (
        // @ts-expect-error Looks like a construct.
        j([O])
      ) : H(O);
      function H(Y) {
        return se;
        function se(ye) {
          const Fe = ye !== null && Y[ye], We = ye !== null && Y.null, Dn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Fe) ? Fe : Fe ? [Fe] : [],
            ...Array.isArray(We) ? We : We ? [We] : []
          ];
          return j(Dn)(ye);
        }
      }
      function j(Y) {
        return le = Y, de = 0, Y.length === 0 ? te : h(Y[de]);
      }
      function h(Y) {
        return se;
        function se(ye) {
          return g = _(), be = Y, Y.partial || (c.currentConstruct = Y), Y.name && c.parser.constructs.disable.null.includes(Y.name) ? X() : Y.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            M ? Object.assign(Object.create(c), M) : c,
            s,
            W,
            X
          )(ye);
        }
      }
      function W(Y) {
        return S(be, g), $;
      }
      function X(Y) {
        return g.restore(), ++de < le.length ? h(le[de]) : te;
      }
    }
  }
  function P(S, M) {
    S.resolveAll && !l.includes(S) && l.push(S), S.resolve && Pe(
      c.events,
      M,
      c.events.length - M,
      S.resolve(c.events.slice(M), c)
    ), S.resolveTo && (c.events = S.resolveTo(c.events, c));
  }
  function _() {
    const S = C(), M = c.previous, F = c.currentConstruct, O = c.events.length, $ = Array.from(a);
    return {
      restore: te,
      from: O
    };
    function te() {
      r = S, c.previous = M, c.currentConstruct = F, c.events.length = O, a = $, E();
    }
  }
  function E() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function ka(e, n) {
  const t = n.start._index, r = n.start._bufferIndex, i = n.end._index, l = n.end._bufferIndex;
  let o;
  if (t === i)
    o = [e[t].slice(r, l)];
  else {
    if (o = e.slice(t, i), r > -1) {
      const a = o[0];
      typeof a == "string" ? o[0] = a.slice(r) : o.shift();
    }
    l > 0 && o.push(e[i].slice(0, l));
  }
  return o;
}
function _a(e, n) {
  let t = -1;
  const r = [];
  let i;
  for (; ++t < e.length; ) {
    const l = e[t];
    let o;
    if (typeof l == "string")
      o = l;
    else
      switch (l) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = n ? " " : "	";
          break;
        }
        case -1: {
          if (!n && i) continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(l);
      }
    i = l === -2, r.push(o);
  }
  return r.join("");
}
const Ia = {
  42: me,
  43: me,
  45: me,
  48: me,
  49: me,
  50: me,
  51: me,
  52: me,
  53: me,
  54: me,
  55: me,
  56: me,
  57: me,
  62: Ur
}, Ea = {
  91: So
}, Sa = {
  [-2]: zn,
  [-1]: zn,
  32: zn
}, Na = {
  35: Po,
  42: Sn,
  45: [Gt, Sn],
  60: Bo,
  61: Gt,
  95: Sn,
  96: Xt,
  126: Xt
}, La = {
  38: Yr,
  92: Qr
}, Aa = {
  [-5]: Hn,
  [-4]: Hn,
  [-3]: Hn,
  33: na,
  38: Yr,
  42: at,
  60: [ro, qo],
  91: ra,
  92: [Mo, Qr],
  93: xt,
  95: at,
  96: yo
}, Ma = {
  null: [at, wa]
}, Ta = {
  null: [42, 95]
}, Pa = {
  null: []
}, Ra = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Ta,
  contentInitial: Ea,
  disable: Pa,
  document: Ia,
  flow: Na,
  flowInitial: Sa,
  insideSpan: Ma,
  string: La,
  text: Aa
}, Symbol.toStringTag, { value: "Module" }));
function Fa(e) {
  const t = (
    /** @type {FullNormalizedExtension} */
    Vl([Ra, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: t,
    content: i(Kl),
    document: i(Jl),
    flow: i(ga),
    string: i(Ca),
    text: i(xa)
  };
  return r;
  function i(l) {
    return o;
    function o(a) {
      return ba(r, l, a);
    }
  }
}
function Da(e) {
  for (; !Kr(e); )
    ;
  return e;
}
const er = /[\0\t\n\r]/g;
function Ba() {
  let e = 1, n = "", t = !0, r;
  return i;
  function i(l, o, a) {
    const s = [];
    let c, p, d, f, u;
    for (l = n + (typeof l == "string" ? l.toString() : new TextDecoder(o || void 0).decode(l)), d = 0, n = "", t && (l.charCodeAt(0) === 65279 && d++, t = void 0); d < l.length; ) {
      if (er.lastIndex = d, c = er.exec(l), f = c && c.index !== void 0 ? c.index : l.length, u = l.charCodeAt(f), !c) {
        n = l.slice(d);
        break;
      }
      if (u === 10 && d === f && r)
        s.push(-3), r = void 0;
      else
        switch (r && (s.push(-5), r = void 0), d < f && (s.push(l.slice(d, f)), e += f - d), u) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (p = Math.ceil(e / 4) * 4, s.push(-2); e++ < p; ) s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = f + 1;
    }
    return a && (r && s.push(-5), n && s.push(n), s.push(null)), s;
  }
}
const $a = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Oa(e) {
  return e.replace($a, za);
}
function za(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const i = t.charCodeAt(1), l = i === 120 || i === 88;
    return Zr(t.slice(l ? 2 : 1), l ? 16 : 10);
  }
  return wt(t) || e;
}
const ti = {}.hasOwnProperty;
function Ha(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), Va(t)(
    Da(
      Fa(t).document().write(Ba()(e, n, !0))
    )
  );
}
function Va(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(At),
      autolinkProtocol: _,
      autolinkEmail: _,
      atxHeading: l(St),
      blockQuote: l(Fe),
      characterEscape: _,
      characterReference: _,
      codeFenced: l(We),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: l(We, o),
      codeText: l(Dn, o),
      codeTextData: _,
      data: _,
      codeFlowValue: _,
      definition: l(gi),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: l(yi),
      hardBreakEscape: l(Nt),
      hardBreakTrailing: l(Nt),
      htmlFlow: l(Lt, o),
      htmlFlowData: _,
      htmlText: l(Lt, o),
      htmlTextData: _,
      image: l(wi),
      label: o,
      link: l(At),
      listItem: l(Ci),
      listItemValue: f,
      listOrdered: l(Mt, d),
      listUnordered: l(Mt),
      paragraph: l(xi),
      reference: h,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: l(St),
      strong: l(vi),
      thematicBreak: l(ki)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: L,
      autolink: s(),
      autolinkEmail: ye,
      autolinkProtocol: se,
      blockQuote: s(),
      characterEscapeValue: E,
      characterReferenceMarkerHexadecimal: X,
      characterReferenceMarkerNumeric: X,
      characterReferenceValue: Y,
      codeFenced: s(k),
      codeFencedFence: x,
      codeFencedFenceInfo: u,
      codeFencedFenceMeta: C,
      codeFlowValue: E,
      codeIndented: s(w),
      codeText: s($),
      codeTextData: E,
      data: E,
      definition: s(),
      definitionDestinationString: A,
      definitionLabelString: I,
      definitionTitleString: v,
      emphasis: s(),
      hardBreakEscape: s(M),
      hardBreakTrailing: s(M),
      htmlFlow: s(F),
      htmlFlowData: E,
      htmlText: s(O),
      htmlTextData: E,
      image: s(le),
      label: be,
      labelText: de,
      lineEnding: S,
      link: s(te),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: W,
      resourceDestinationString: g,
      resourceTitleString: H,
      resource: j,
      setextHeading: s(P),
      setextHeadingLineSequence: T,
      setextHeadingText: y,
      strong: s(),
      thematicBreak: s()
    }
  };
  ri(n, (e || {}).mdastExtensions || []);
  const t = {};
  return r;
  function r(N) {
    let D = {
      type: "root",
      children: []
    };
    const V = {
      stack: [D],
      tokenStack: [],
      config: n,
      enter: a,
      exit: c,
      buffer: o,
      resume: p,
      data: t
    }, Z = [];
    let K = -1;
    for (; ++K < N.length; )
      if (N[K][1].type === "listOrdered" || N[K][1].type === "listUnordered")
        if (N[K][0] === "enter")
          Z.push(K);
        else {
          const Ee = Z.pop();
          K = i(N, Ee, K);
        }
    for (K = -1; ++K < N.length; ) {
      const Ee = n[N[K][0]];
      ti.call(Ee, N[K][1].type) && Ee[N[K][1].type].call(
        Object.assign(
          {
            sliceSerialize: N[K][2].sliceSerialize
          },
          V
        ),
        N[K][1]
      );
    }
    if (V.tokenStack.length > 0) {
      const Ee = V.tokenStack[V.tokenStack.length - 1];
      (Ee[1] || nr).call(V, void 0, Ee[0]);
    }
    for (D.position = {
      start: ze(
        N.length > 0 ? N[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: ze(
        N.length > 0 ? N[N.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, K = -1; ++K < n.transforms.length; )
      D = n.transforms[K](D) || D;
    return D;
  }
  function i(N, D, V) {
    let Z = D - 1, K = -1, Ee = !1, Ze, De, sn, cn;
    for (; ++Z <= V; ) {
      const we = N[Z];
      switch (we[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          we[0] === "enter" ? K++ : K--, cn = void 0;
          break;
        }
        case "lineEndingBlank": {
          we[0] === "enter" && (Ze && !cn && !K && !sn && (sn = Z), cn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          cn = void 0;
      }
      if (!K && we[0] === "enter" && we[1].type === "listItemPrefix" || K === -1 && we[0] === "exit" && (we[1].type === "listUnordered" || we[1].type === "listOrdered")) {
        if (Ze) {
          let Xe = Z;
          for (De = void 0; Xe--; ) {
            const Be = N[Xe];
            if (Be[1].type === "lineEnding" || Be[1].type === "lineEndingBlank") {
              if (Be[0] === "exit") continue;
              De && (N[De][1].type = "lineEndingBlank", Ee = !0), Be[1].type = "lineEnding", De = Xe;
            } else if (!(Be[1].type === "linePrefix" || Be[1].type === "blockQuotePrefix" || Be[1].type === "blockQuotePrefixWhitespace" || Be[1].type === "blockQuoteMarker" || Be[1].type === "listItemIndent")) break;
          }
          sn && (!De || sn < De) && (Ze._spread = !0), Ze.end = Object.assign(
            {},
            De ? N[De][1].start : we[1].end
          ), N.splice(De || Z, 0, ["exit", Ze, we[2]]), Z++, V++;
        }
        if (we[1].type === "listItemPrefix") {
          const Xe = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, we[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Ze = Xe, N.splice(Z, 0, ["enter", Xe, we[2]]), Z++, V++, sn = void 0, cn = !0;
        }
      }
    }
    return N[D][1]._spread = Ee, V;
  }
  function l(N, D) {
    return V;
    function V(Z) {
      a.call(this, N(Z), Z), D && D.call(this, Z);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(N, D, V) {
    this.stack[this.stack.length - 1].children.push(N), this.stack.push(N), this.tokenStack.push([D, V]), N.position = {
      start: ze(D.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(N) {
    return D;
    function D(V) {
      N && N.call(this, V), c.call(this, V);
    }
  }
  function c(N, D) {
    const V = this.stack.pop(), Z = this.tokenStack.pop();
    if (Z)
      Z[0].type !== N.type && (D ? D.call(this, N, Z[0]) : (Z[1] || nr).call(this, N, Z[0]));
    else throw new Error(
      "Cannot close `" + N.type + "` (" + fn({
        start: N.start,
        end: N.end
      }) + "): it’s not open"
    );
    V.position.end = ze(N.end);
  }
  function p() {
    return zl(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(N) {
    if (this.data.expectingFirstListItemValue) {
      const D = this.stack[this.stack.length - 2];
      D.start = Number.parseInt(this.sliceSerialize(N), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function u() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.lang = N;
  }
  function C() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.meta = N;
  }
  function x() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function k() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.value = N.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.value = N.replace(/(\r?\n|\r)$/g, "");
  }
  function I(N) {
    const D = this.resume(), V = this.stack[this.stack.length - 1];
    V.label = D, V.identifier = rn(
      this.sliceSerialize(N)
    ).toLowerCase();
  }
  function v() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.title = N;
  }
  function A() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.url = N;
  }
  function L(N) {
    const D = this.stack[this.stack.length - 1];
    if (!D.depth) {
      const V = this.sliceSerialize(N).length;
      D.depth = V;
    }
  }
  function y() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function T(N) {
    const D = this.stack[this.stack.length - 1];
    D.depth = this.sliceSerialize(N).codePointAt(0) === 61 ? 1 : 2;
  }
  function P() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function _(N) {
    const V = this.stack[this.stack.length - 1].children;
    let Z = V[V.length - 1];
    (!Z || Z.type !== "text") && (Z = bi(), Z.position = {
      start: ze(N.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, V.push(Z)), this.stack.push(Z);
  }
  function E(N) {
    const D = this.stack.pop();
    D.value += this.sliceSerialize(N), D.position.end = ze(N.end);
  }
  function S(N) {
    const D = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const V = D.children[D.children.length - 1];
      V.position.end = ze(N.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(D.type) && (_.call(this, N), E.call(this, N));
  }
  function M() {
    this.data.atHardBreak = !0;
  }
  function F() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.value = N;
  }
  function O() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.value = N;
  }
  function $() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.value = N;
  }
  function te() {
    const N = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const D = this.data.referenceType || "shortcut";
      N.type += "Reference", N.referenceType = D, delete N.url, delete N.title;
    } else
      delete N.identifier, delete N.label;
    this.data.referenceType = void 0;
  }
  function le() {
    const N = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const D = this.data.referenceType || "shortcut";
      N.type += "Reference", N.referenceType = D, delete N.url, delete N.title;
    } else
      delete N.identifier, delete N.label;
    this.data.referenceType = void 0;
  }
  function de(N) {
    const D = this.sliceSerialize(N), V = this.stack[this.stack.length - 2];
    V.label = Oa(D), V.identifier = rn(D).toLowerCase();
  }
  function be() {
    const N = this.stack[this.stack.length - 1], D = this.resume(), V = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, V.type === "link") {
      const Z = N.children;
      V.children = Z;
    } else
      V.alt = D;
  }
  function g() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.url = N;
  }
  function H() {
    const N = this.resume(), D = this.stack[this.stack.length - 1];
    D.title = N;
  }
  function j() {
    this.data.inReference = void 0;
  }
  function h() {
    this.data.referenceType = "collapsed";
  }
  function W(N) {
    const D = this.resume(), V = this.stack[this.stack.length - 1];
    V.label = D, V.identifier = rn(
      this.sliceSerialize(N)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function X(N) {
    this.data.characterReferenceType = N.type;
  }
  function Y(N) {
    const D = this.sliceSerialize(N), V = this.data.characterReferenceType;
    let Z;
    V ? (Z = Zr(
      D,
      V === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : Z = wt(D);
    const K = this.stack.pop();
    K.value += Z, K.position.end = ze(N.end);
  }
  function se(N) {
    E.call(this, N);
    const D = this.stack[this.stack.length - 1];
    D.url = this.sliceSerialize(N);
  }
  function ye(N) {
    E.call(this, N);
    const D = this.stack[this.stack.length - 1];
    D.url = "mailto:" + this.sliceSerialize(N);
  }
  function Fe() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function We() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Dn() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function gi() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function yi() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function St() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Nt() {
    return {
      type: "break"
    };
  }
  function Lt() {
    return {
      type: "html",
      value: ""
    };
  }
  function wi() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function At() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Mt(N) {
    return {
      type: "list",
      ordered: N.type === "listOrdered",
      start: null,
      spread: N._spread,
      children: []
    };
  }
  function Ci(N) {
    return {
      type: "listItem",
      spread: N._spread,
      checked: null,
      children: []
    };
  }
  function xi() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function vi() {
    return {
      type: "strong",
      children: []
    };
  }
  function bi() {
    return {
      type: "text",
      value: ""
    };
  }
  function ki() {
    return {
      type: "thematicBreak"
    };
  }
}
function ze(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function ri(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const r = n[t];
    Array.isArray(r) ? ri(e, r) : ja(e, r);
  }
}
function ja(e, n) {
  let t;
  for (t in n)
    if (ti.call(n, t))
      switch (t) {
        case "canContainEols": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "transforms": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = n[t];
          r && Object.assign(e[t], r);
          break;
        }
      }
}
function nr(e, n) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + fn({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + n.type + "`, " + fn({
      start: n.start,
      end: n.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + n.type + "`, " + fn({
      start: n.start,
      end: n.end
    }) + ") is still open"
  );
}
function qa(e) {
  const n = this;
  n.parser = t;
  function t(r) {
    return Ha(r, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function Wa(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Za(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function Ua(e, n) {
  const t = n.value ? n.value + `
` : "", r = {};
  n.lang && (r.className = ["language-" + n.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (i.data = { meta: n.meta }), e.patch(n, i), i = e.applyData(n, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(n, i), i;
}
function Qa(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Ya(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Ka(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(n.identifier).toUpperCase(), i = an(r.toLowerCase()), l = e.footnoteOrder.indexOf(r);
  let o, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = l + 1, a += 1, e.footnoteCounts.set(r, a);
  const s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + i,
      id: t + "fnref-" + i + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(n, s);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(n, c), e.applyData(n, c);
}
function Xa(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Ja(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function ii(e, n) {
  const t = n.referenceType;
  let r = "]";
  if (t === "collapsed" ? r += "[]" : t === "full" && (r += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + r }];
  const i = e.all(n), l = i[0];
  l && l.type === "text" ? l.value = "[" + l.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function Ga(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return ii(e, n);
  const i = { src: an(r.url || ""), alt: n.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(n, l), e.applyData(n, l);
}
function es(e, n) {
  const t = { src: an(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, r), e.applyData(n, r);
}
function ns(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, r), e.applyData(n, r);
}
function ts(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return ii(e, n);
  const i = { href: an(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(n)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function rs(e, n) {
  const t = { href: an(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function is(e, n, t) {
  const r = e.all(n), i = t ? ls(t) : li(n), l = {}, o = [];
  if (typeof n.checked == "boolean") {
    const p = r[0];
    let d;
    p && p.type === "element" && p.tagName === "p" ? d = p : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), l.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const p = r[a];
    (i || a !== 0 || p.type !== "element" || p.tagName !== "p") && o.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !i ? o.push(...p.children) : o.push(p);
  }
  const s = r[r.length - 1];
  s && (i || s.type !== "element" || s.tagName !== "p") && o.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: l, children: o };
  return e.patch(n, c), e.applyData(n, c);
}
function ls(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let r = -1;
    for (; !n && ++r < t.length; )
      n = li(t[r]);
  }
  return n;
}
function li(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function os(e, n) {
  const t = {}, r = e.all(n);
  let i = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const l = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(r, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function as(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function ss(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function cs(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function us(e, n) {
  const t = e.all(n), r = t.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(n.children[0], o), i.push(o);
  }
  if (t.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, a = ft(n.children[1]), s = Or(n.children[n.children.length - 1]);
    a && s && (o.position = { start: a, end: s }), i.push(o);
  }
  const l = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function ps(e, n, t) {
  const r = t ? t.children : void 0, l = (r ? r.indexOf(n) : 1) === 0 ? "th" : "td", o = t && t.type === "table" ? t.align : void 0, a = o ? o.length : n.children.length;
  let s = -1;
  const c = [];
  for (; ++s < a; ) {
    const d = n.children[s], f = {}, u = o ? o[s] : void 0;
    u && (f.align = u);
    let C = { type: "element", tagName: l, properties: f, children: [] };
    d && (C.children = e.all(d), e.patch(d, C), C = e.applyData(d, C)), c.push(C);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(n, p), e.applyData(n, p);
}
function ds(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const tr = 9, rr = 32;
function hs(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let r = t.exec(n), i = 0;
  const l = [];
  for (; r; )
    l.push(
      ir(n.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = t.exec(n);
  return l.push(ir(n.slice(i), i > 0, !1)), l.join("");
}
function ir(e, n, t) {
  let r = 0, i = e.length;
  if (n) {
    let l = e.codePointAt(r);
    for (; l === tr || l === rr; )
      r++, l = e.codePointAt(r);
  }
  if (t) {
    let l = e.codePointAt(i - 1);
    for (; l === tr || l === rr; )
      i--, l = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function fs(e, n) {
  const t = { type: "text", value: hs(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function ms(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const gs = {
  blockquote: Wa,
  break: Za,
  code: Ua,
  delete: Qa,
  emphasis: Ya,
  footnoteReference: Ka,
  heading: Xa,
  html: Ja,
  imageReference: Ga,
  image: es,
  inlineCode: ns,
  linkReference: ts,
  link: rs,
  listItem: is,
  list: os,
  paragraph: as,
  // @ts-expect-error: root is different, but hard to type.
  root: ss,
  strong: cs,
  table: us,
  tableCell: ds,
  tableRow: ps,
  text: fs,
  thematicBreak: ms,
  toml: vn,
  yaml: vn,
  definition: vn,
  footnoteDefinition: vn
};
function vn() {
}
const oi = -1, Rn = 0, Ln = 1, An = 2, vt = 3, bt = 4, kt = 5, _t = 6, ai = 7, si = 8, lr = typeof self == "object" ? self : globalThis, ys = (e, n) => {
  const t = (i, l) => (e.set(l, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [l, o] = n[i];
    switch (l) {
      case Rn:
      case oi:
        return t(o, i);
      case Ln: {
        const a = t([], i);
        for (const s of o)
          a.push(r(s));
        return a;
      }
      case An: {
        const a = t({}, i);
        for (const [s, c] of o)
          a[r(s)] = r(c);
        return a;
      }
      case vt:
        return t(new Date(o), i);
      case bt: {
        const { source: a, flags: s } = o;
        return t(new RegExp(a, s), i);
      }
      case kt: {
        const a = t(/* @__PURE__ */ new Map(), i);
        for (const [s, c] of o)
          a.set(r(s), r(c));
        return a;
      }
      case _t: {
        const a = t(/* @__PURE__ */ new Set(), i);
        for (const s of o)
          a.add(r(s));
        return a;
      }
      case ai: {
        const { name: a, message: s } = o;
        return t(new lr[a](s), i);
      }
      case si:
        return t(BigInt(o), i);
      case "BigInt":
        return t(Object(BigInt(o)), i);
    }
    return t(new lr[l](o), i);
  };
  return r;
}, or = (e) => ys(/* @__PURE__ */ new Map(), e)(0), Je = "", { toString: ws } = {}, { keys: Cs } = Object, un = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Rn, n];
  const t = ws.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [Ln, Je];
    case "Object":
      return [An, Je];
    case "Date":
      return [vt, Je];
    case "RegExp":
      return [bt, Je];
    case "Map":
      return [kt, Je];
    case "Set":
      return [_t, Je];
  }
  return t.includes("Array") ? [Ln, t] : t.includes("Error") ? [ai, t] : [An, t];
}, bn = ([e, n]) => e === Rn && (n === "function" || n === "symbol"), xs = (e, n, t, r) => {
  const i = (o, a) => {
    const s = r.push(o) - 1;
    return t.set(a, s), s;
  }, l = (o) => {
    if (t.has(o))
      return t.get(o);
    let [a, s] = un(o);
    switch (a) {
      case Rn: {
        let p = o;
        switch (s) {
          case "bigint":
            a = si, p = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + s);
            p = null;
            break;
          case "undefined":
            return i([oi], o);
        }
        return i([a, p], o);
      }
      case Ln: {
        if (s)
          return i([s, [...o]], o);
        const p = [], d = i([a, p], o);
        for (const f of o)
          p.push(l(f));
        return d;
      }
      case An: {
        if (s)
          switch (s) {
            case "BigInt":
              return i([s, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([s, o.valueOf()], o);
          }
        if (n && "toJSON" in o)
          return l(o.toJSON());
        const p = [], d = i([a, p], o);
        for (const f of Cs(o))
          (e || !bn(un(o[f]))) && p.push([l(f), l(o[f])]);
        return d;
      }
      case vt:
        return i([a, o.toISOString()], o);
      case bt: {
        const { source: p, flags: d } = o;
        return i([a, { source: p, flags: d }], o);
      }
      case kt: {
        const p = [], d = i([a, p], o);
        for (const [f, u] of o)
          (e || !(bn(un(f)) || bn(un(u)))) && p.push([l(f), l(u)]);
        return d;
      }
      case _t: {
        const p = [], d = i([a, p], o);
        for (const f of o)
          (e || !bn(un(f))) && p.push(l(f));
        return d;
      }
    }
    const { message: c } = o;
    return i([a, { name: s, message: c }], o);
  };
  return l;
}, ar = (e, { json: n, lossy: t } = {}) => {
  const r = [];
  return xs(!(n || t), !!n, /* @__PURE__ */ new Map(), r)(e), r;
}, Mn = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? or(ar(e, n)) : structuredClone(e)
) : (e, n) => or(ar(e, n));
function vs(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function bs(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function ks(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || vs, r = e.options.footnoteBackLabel || bs, i = e.options.footnoteLabel || "Footnotes", l = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let s = -1;
  for (; ++s < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(e.footnoteOrder[s]);
    if (!c)
      continue;
    const p = e.all(c), d = String(c.identifier).toUpperCase(), f = an(d.toLowerCase());
    let u = 0;
    const C = [], x = e.footnoteCounts.get(d);
    for (; x !== void 0 && ++u <= x; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let I = typeof t == "string" ? t : t(s, u);
      typeof I == "string" && (I = { type: "text", value: I }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + f + (u > 1 ? "-" + u : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(s, u),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(I) ? I : [I]
      });
    }
    const k = p[p.length - 1];
    if (k && k.type === "element" && k.tagName === "p") {
      const I = k.children[k.children.length - 1];
      I && I.type === "text" ? I.value += " " : k.children.push({ type: "text", value: " " }), k.children.push(...C);
    } else
      p.push(...C);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + f },
      children: e.wrap(p, !0)
    };
    e.patch(c, w), a.push(w);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: l,
          properties: {
            ...Mn(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const ci = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return Ss;
    if (typeof e == "function")
      return Fn(e);
    if (typeof e == "object")
      return Array.isArray(e) ? _s(e) : Is(e);
    if (typeof e == "string")
      return Es(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function _s(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = ci(e[t]);
  return Fn(r);
  function r(...i) {
    let l = -1;
    for (; ++l < n.length; )
      if (n[l].apply(this, i)) return !0;
    return !1;
  }
}
function Is(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Fn(t);
  function t(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let l;
    for (l in e)
      if (i[l] !== n[l]) return !1;
    return !0;
  }
}
function Es(e) {
  return Fn(n);
  function n(t) {
    return t && t.type === e;
  }
}
function Fn(e) {
  return n;
  function n(t, r, i) {
    return !!(Ns(t) && e.call(
      this,
      t,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function Ss() {
  return !0;
}
function Ns(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const ui = [], Ls = !0, sr = !1, As = "skip";
function Ms(e, n, t, r) {
  let i;
  typeof n == "function" && typeof t != "function" ? (r = t, t = n) : i = n;
  const l = ci(i), o = r ? -1 : 1;
  a(e, void 0, [])();
  function a(s, c, p) {
    const d = (
      /** @type {Record<string, unknown>} */
      s && typeof s == "object" ? s : {}
    );
    if (typeof d.type == "string") {
      const u = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (s.type + (u ? "<" + u + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let u = ui, C, x, k;
      if ((!n || l(s, c, p[p.length - 1] || void 0)) && (u = Ts(t(s, p)), u[0] === sr))
        return u;
      if ("children" in s && s.children) {
        const w = (
          /** @type {UnistParent} */
          s
        );
        if (w.children && u[0] !== As)
          for (x = (r ? w.children.length : -1) + o, k = p.concat(w); x > -1 && x < w.children.length; ) {
            const I = w.children[x];
            if (C = a(I, x, k)(), C[0] === sr)
              return C;
            x = typeof C[1] == "number" ? C[1] : x + o;
          }
      }
      return u;
    }
  }
}
function Ts(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Ls, e] : e == null ? ui : [e];
}
function pi(e, n, t, r) {
  let i, l, o;
  typeof n == "function" && typeof t != "function" ? (l = void 0, o = n, i = t) : (l = n, o = t, i = r), Ms(e, l, a, i);
  function a(s, c) {
    const p = c[c.length - 1], d = p ? p.children.indexOf(s) : void 0;
    return o(s, d, p);
  }
}
const st = {}.hasOwnProperty, Ps = {};
function Rs(e, n) {
  const t = n || Ps, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), o = { ...gs, ...t.handlers }, a = {
    all: c,
    applyData: Ds,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: l,
    footnoteOrder: [],
    handlers: o,
    one: s,
    options: t,
    patch: Fs,
    wrap: $s
  };
  return pi(e, function(p) {
    if (p.type === "definition" || p.type === "footnoteDefinition") {
      const d = p.type === "definition" ? r : i, f = String(p.identifier).toUpperCase();
      d.has(f) || d.set(f, p);
    }
  }), a;
  function s(p, d) {
    const f = p.type, u = a.handlers[f];
    if (st.call(a.handlers, f) && u)
      return u(a, p, d);
    if (a.options.passThrough && a.options.passThrough.includes(f)) {
      if ("children" in p) {
        const { children: x, ...k } = p, w = Mn(k);
        return w.children = a.all(p), w;
      }
      return Mn(p);
    }
    return (a.options.unknownHandler || Bs)(a, p, d);
  }
  function c(p) {
    const d = [];
    if ("children" in p) {
      const f = p.children;
      let u = -1;
      for (; ++u < f.length; ) {
        const C = a.one(f[u], p);
        if (C) {
          if (u && f[u - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = cr(C.value)), !Array.isArray(C) && C.type === "element")) {
            const x = C.children[0];
            x && x.type === "text" && (x.value = cr(x.value));
          }
          Array.isArray(C) ? d.push(...C) : d.push(C);
        }
      }
    }
    return d;
  }
}
function Fs(e, n) {
  e.position && (n.position = gl(e));
}
function Ds(e, n) {
  let t = n;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, l = e.data.hProperties;
    if (typeof r == "string")
      if (t.type === "element")
        t.tagName = r;
      else {
        const o = "children" in t ? t.children : [t];
        t = { type: "element", tagName: r, properties: {}, children: o };
      }
    t.type === "element" && l && Object.assign(t.properties, Mn(l)), "children" in t && t.children && i !== null && i !== void 0 && (t.children = i);
  }
  return t;
}
function Bs(e, n) {
  const t = n.data || {}, r = "value" in n && !(st.call(t, "hProperties") || st.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function $s(e, n) {
  const t = [];
  let r = -1;
  for (n && t.push({ type: "text", value: `
` }); ++r < e.length; )
    r && t.push({ type: "text", value: `
` }), t.push(e[r]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function cr(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function ur(e, n) {
  const t = Rs(e, n), r = t.one(e, void 0), i = ks(t), l = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && l.children.push({ type: "text", value: `
` }, i), l;
}
function Os(e, n) {
  return e && "run" in e ? async function(t, r) {
    const i = (
      /** @type {HastRoot} */
      ur(t, { file: r, ...n })
    );
    await e.run(i, r);
  } : function(t, r) {
    return (
      /** @type {HastRoot} */
      ur(t, { file: r, ...n || e })
    );
  };
}
function pr(e) {
  if (e)
    throw e;
}
var Nn = Object.prototype.hasOwnProperty, di = Object.prototype.toString, dr = Object.defineProperty, hr = Object.getOwnPropertyDescriptor, fr = function(n) {
  return typeof Array.isArray == "function" ? Array.isArray(n) : di.call(n) === "[object Array]";
}, mr = function(n) {
  if (!n || di.call(n) !== "[object Object]")
    return !1;
  var t = Nn.call(n, "constructor"), r = n.constructor && n.constructor.prototype && Nn.call(n.constructor.prototype, "isPrototypeOf");
  if (n.constructor && !t && !r)
    return !1;
  var i;
  for (i in n)
    ;
  return typeof i > "u" || Nn.call(n, i);
}, gr = function(n, t) {
  dr && t.name === "__proto__" ? dr(n, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : n[t.name] = t.newValue;
}, yr = function(n, t) {
  if (t === "__proto__")
    if (Nn.call(n, t)) {
      if (hr)
        return hr(n, t).value;
    } else return;
  return n[t];
}, zs = function e() {
  var n, t, r, i, l, o, a = arguments[0], s = 1, c = arguments.length, p = !1;
  for (typeof a == "boolean" && (p = a, a = arguments[1] || {}, s = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); s < c; ++s)
    if (n = arguments[s], n != null)
      for (t in n)
        r = yr(a, t), i = yr(n, t), a !== i && (p && i && (mr(i) || (l = fr(i))) ? (l ? (l = !1, o = r && fr(r) ? r : []) : o = r && mr(r) ? r : {}, gr(a, { name: t, newValue: e(p, o, i) })) : typeof i < "u" && gr(a, { name: t, newValue: i }));
  return a;
};
const Vn = /* @__PURE__ */ el(zs);
function ct(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Hs() {
  const e = [], n = { run: t, use: r };
  return n;
  function t(...i) {
    let l = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    a(null, ...i);
    function a(s, ...c) {
      const p = e[++l];
      let d = -1;
      if (s) {
        o(s);
        return;
      }
      for (; ++d < i.length; )
        (c[d] === null || c[d] === void 0) && (c[d] = i[d]);
      i = c, p ? Vs(p, a)(...c) : o(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), n;
  }
}
function Vs(e, n) {
  let t;
  return r;
  function r(...o) {
    const a = e.length > o.length;
    let s;
    a && o.push(i);
    try {
      s = e.apply(this, o);
    } catch (c) {
      const p = (
        /** @type {Error} */
        c
      );
      if (a && t)
        throw p;
      return i(p);
    }
    a || (s && s.then && typeof s.then == "function" ? s.then(l, i) : s instanceof Error ? i(s) : l(s));
  }
  function i(o, ...a) {
    t || (t = !0, n(o, ...a));
  }
  function l(o) {
    i(null, o);
  }
}
const Me = { basename: js, dirname: qs, extname: Ws, join: Zs, sep: "/" };
function js(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  xn(e);
  let t = 0, r = -1, i = e.length, l;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (l) {
          t = i + 1;
          break;
        }
      } else r < 0 && (l = !0, r = i + 1);
    return r < 0 ? "" : e.slice(t, r);
  }
  if (n === e)
    return "";
  let o = -1, a = n.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (l) {
        t = i + 1;
        break;
      }
    } else
      o < 0 && (l = !0, o = i + 1), a > -1 && (e.codePointAt(i) === n.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = o));
  return t === r ? r = o : r < 0 && (r = e.length), e.slice(t, r);
}
function qs(e) {
  if (xn(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, r;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (r) {
        n = t;
        break;
      }
    } else r || (r = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function Ws(e) {
  xn(e);
  let n = e.length, t = -1, r = 0, i = -1, l = 0, o;
  for (; n--; ) {
    const a = e.codePointAt(n);
    if (a === 47) {
      if (o) {
        r = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (o = !0, t = n + 1), a === 46 ? i < 0 ? i = n : l !== 1 && (l = 1) : i > -1 && (l = -1);
  }
  return i < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  l === 0 || // The (right-most) trimmed path component is exactly `..`.
  l === 1 && i === t - 1 && i === r + 1 ? "" : e.slice(i, t);
}
function Zs(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    xn(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : Us(t);
}
function Us(e) {
  xn(e);
  const n = e.codePointAt(0) === 47;
  let t = Qs(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function Qs(e, n) {
  let t = "", r = 0, i = -1, l = 0, o = -1, a, s;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      a = e.codePointAt(o);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(i === o - 1 || l === 1)) if (i !== o - 1 && l === 2) {
        if (t.length < 2 || r !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (s = t.lastIndexOf("/"), s !== t.length - 1) {
              s < 0 ? (t = "", r = 0) : (t = t.slice(0, s), r = t.length - 1 - t.lastIndexOf("/")), i = o, l = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", r = 0, i = o, l = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", r = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(i + 1, o) : t = e.slice(i + 1, o), r = o - i - 1;
      i = o, l = 0;
    } else a === 46 && l > -1 ? l++ : l = -1;
  }
  return t;
}
function xn(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const Ys = { cwd: Ks };
function Ks() {
  return "/";
}
function ut(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function Xs(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!ut(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return Js(e);
}
function Js(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const r = n.codePointAt(t + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(n);
}
const jn = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class hi {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? ut(n) ? t = { path: n } : typeof n == "string" || Gs(n) ? t = { value: n } : t = n : t = {}, this.cwd = Ys.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < jn.length; ) {
      const l = jn[r];
      l in t && t[l] !== void 0 && t[l] !== null && (this[l] = l === "history" ? [...t[l]] : t[l]);
    }
    let i;
    for (i in t)
      jn.includes(i) || (this[i] = t[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Me.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Wn(n, "basename"), qn(n, "basename"), this.path = Me.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Me.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    wr(this.basename, "dirname"), this.path = Me.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Me.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (qn(n, "extname"), wr(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Me.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    ut(n) && (n = Xs(n)), Wn(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Me.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Wn(n, "stem"), qn(n, "stem"), this.path = Me.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, r) {
    const i = this.message(n, t, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, r) {
    const i = this.message(n, t, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, r) {
    const i = new ce(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function qn(e, n) {
  if (e && e.includes(Me.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Me.sep + "`"
    );
}
function Wn(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function wr(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function Gs(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const ec = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], l = function() {
      return i.apply(l, arguments);
    };
    Object.setPrototypeOf(l, r);
    const o = Object.getOwnPropertyNames(i);
    for (const a of o) {
      const s = Object.getOwnPropertyDescriptor(i, a);
      s && Object.defineProperty(l, a, s);
    }
    return l;
  }
), nc = {}.hasOwnProperty;
class It extends ec {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Hs();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new It()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const r = this.attachers[t];
      n.use(...r);
    }
    return n.data(Vn(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (Qn("data", this.frozen), this.namespace[n] = t, this) : nc.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Qn("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = t.call(n, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = kn(n), r = this.parser || this.Parser;
    return Zn("parse", r), r(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const r = this;
    return this.freeze(), Zn("process", this.parser || this.Parser), Un("process", this.compiler || this.Compiler), t ? i(void 0, t) : new Promise(i);
    function i(l, o) {
      const a = kn(n), s = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(s, a, function(p, d, f) {
        if (p || !d || !f)
          return c(p);
        const u = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), C = r.stringify(u, f);
        ic(C) ? f.value = C : f.result = C, c(
          p,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function c(p, d) {
        p || !d ? o(p) : l ? l(d) : t(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, r;
    return this.freeze(), Zn("processSync", this.parser || this.Parser), Un("processSync", this.compiler || this.Compiler), this.process(n, i), xr("processSync", "process", t), r;
    function i(l, o) {
      t = !0, pr(l), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, r) {
    Cr(n), this.freeze();
    const i = this.transformers;
    return !r && typeof t == "function" && (r = t, t = void 0), r ? l(void 0, r) : new Promise(l);
    function l(o, a) {
      const s = kn(t);
      i.run(n, s, c);
      function c(p, d, f) {
        const u = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || n
        );
        p ? a(p) : o ? o(u) : r(void 0, u, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let r = !1, i;
    return this.run(n, t, l), xr("runSync", "run", r), i;
    function l(o, a) {
      pr(o), i = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const r = kn(t), i = this.compiler || this.Compiler;
    return Un("stringify", i), Cr(n), i(n, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const r = this.attachers, i = this.namespace;
    if (Qn("use", this.frozen), n != null) if (typeof n == "function")
      s(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? a(n) : o(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function l(c) {
      if (typeof c == "function")
        s(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [p, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          s(p, d);
        } else
          o(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(c.plugins), c.settings && (i.settings = Vn(!0, i.settings, c.settings));
    }
    function a(c) {
      let p = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++p < c.length; ) {
          const d = c[p];
          l(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function s(c, p) {
      let d = -1, f = -1;
      for (; ++d < r.length; )
        if (r[d][0] === c) {
          f = d;
          break;
        }
      if (f === -1)
        r.push([c, ...p]);
      else if (p.length > 0) {
        let [u, ...C] = p;
        const x = r[f][1];
        ct(x) && ct(u) && (u = Vn(!0, x, u)), r[f] = [c, u, ...C];
      }
    }
  }
}
const tc = new It().freeze();
function Zn(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Un(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Qn(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Cr(e) {
  if (!ct(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function xr(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function kn(e) {
  return rc(e) ? e : new hi(e);
}
function rc(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function ic(e) {
  return typeof e == "string" || lc(e);
}
function lc(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const oc = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", vr = [], br = { allowDangerousHtml: !0 }, ac = /^(https?|ircs?|mailto|xmpp)$/i, sc = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function wn(e) {
  const n = e.allowedElements, t = e.allowElement, r = e.children || "", i = e.className, l = e.components, o = e.disallowedElements, a = e.rehypePlugins || vr, s = e.remarkPlugins || vr, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...br } : br, p = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || cc, u = tc().use(qa).use(s).use(Os, c).use(a), C = new hi();
  typeof r == "string" && (C.value = r);
  for (const I of sc)
    Object.hasOwn(e, I.from) && ("" + I.from + (I.to ? "use `" + I.to + "` instead" : "remove it") + oc + I.id, void 0);
  const x = u.parse(C);
  let k = u.runSync(x, C);
  return i && (k = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      k.type === "root" ? k.children : [k]
    )
  }), pi(k, w), bl(k, {
    Fragment: Oe,
    components: l,
    ignoreInvalidStyle: !0,
    jsx: m,
    jsxs: B,
    passKeys: !0,
    passNode: !0
  });
  function w(I, v, A) {
    if (I.type === "raw" && A && typeof v == "number")
      return p ? A.children.splice(v, 1) : A.children[v] = { type: "text", value: I.value }, v;
    if (I.type === "element") {
      let L;
      for (L in On)
        if (Object.hasOwn(On, L) && Object.hasOwn(I.properties, L)) {
          const y = I.properties[L], T = On[L];
          (T === null || T.includes(I.tagName)) && (I.properties[L] = f(String(y || ""), L, I));
        }
    }
    if (I.type === "element") {
      let L = n ? !n.includes(I.tagName) : o ? o.includes(I.tagName) : !1;
      if (!L && t && typeof v == "number" && (L = !t(I, v, A)), L && A && typeof v == "number")
        return d && I.children ? A.children.splice(v, 1, ...I.children) : A.children.splice(v, 1), v;
    }
  }
}
function cc(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && n > i || t > -1 && n > t || r > -1 && n > r || // It is a protocol, it should be allowed.
    ac.test(e.slice(0, n)) ? e : ""
  );
}
const uc = (e) => {
  const { message: n, className: t, children: r, ...i } = e;
  let l = n ? /* @__PURE__ */ m(wn, { rehypePlugins: [gn], children: n }) : r;
  return !n && r && typeof r == "string" && (l = /* @__PURE__ */ m(wn, { rehypePlugins: [gn], children: r })), /* @__PURE__ */ m("div", { className: `${Fi.message} ${t ?? ""}`, ...i, children: l });
}, pc = "_message_kmwb2_1149", dc = {
  message: pc
}, hc = (e) => {
  const { message: n, className: t, children: r, ...i } = e;
  let l = n ? /* @__PURE__ */ m(wn, { rehypePlugins: [gn], children: n }) : r;
  return !n && r && typeof r == "string" && (l = /* @__PURE__ */ m(wn, { rehypePlugins: [gn], children: r })), /* @__PURE__ */ m("div", { className: `${dc.message} ${t ?? ""}`, ...i, children: l });
}, fc = "_questions_1trlq_1149", mc = "_question_1trlq_1149", Yn = {
  questions: fc,
  question: mc
}, x5 = (e) => {
  const { questions: n } = e;
  return /* @__PURE__ */ B("div", { className: Yn.questions, children: [
    n.map((t) => /* @__PURE__ */ m("div", { className: Yn.question, children: t.question }, t.id)),
    /* @__PURE__ */ m("div", { className: Yn.addQuestion, onClick: e.onAddQuestion, children: "Add your own question" })
  ] });
}, gc = "_chatInputContainer_jr78b_1149", yc = "_chatInput_jr78b_1149", wc = "_disabled_jr78b_1169", Cc = "_inputs_jr78b_1173", xc = "_message_jr78b_1184", vc = "_files_jr78b_1207", bc = "_fileInput_jr78b_1216", kc = "_attachButton_jr78b_1219", _c = "_sendButton_jr78b_1251", $e = {
  chatInputContainer: gc,
  chatInput: yc,
  disabled: wc,
  inputs: Cc,
  message: xc,
  files: vc,
  fileInput: bc,
  attachButton: kc,
  sendButton: _c
}, Ic = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M3.35355 8.35356C3.26306 8.44404 3.13807 8.5 3 8.5C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.85955 2.55791 7.73263 2.65115 7.64181L7.64181 2.65115C7.73263 2.55791 7.85955 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73264 13.5 7.85956 13.5 8C13.5 8.27614 13.2761 8.5 13 8.5C12.8619 8.5 12.7369 8.44404 12.6465 8.35356L8.5 4.20717L8.5 13C8.5 13.2761 8.27614 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13L7.5 4.20717L3.35355 8.35356Z", fill: "#0E5FE3" })), Ec = (e) => /* @__PURE__ */ b.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M7.42829 3.57115C7.42829 3.33446 7.23641 3.14258 6.99972 3.14258C6.76303 3.14258 6.57115 3.33446 6.57115 3.57115V6.57115H3.57115C3.33446 6.57115 3.14258 6.76303 3.14258 6.99972C3.14258 7.23642 3.33446 7.42829 3.57115 7.42829H6.57115V10.4283C6.57115 10.665 6.76303 10.8569 6.99972 10.8569C7.23642 10.8569 7.42829 10.665 7.42829 10.4283V7.42829H10.4283C10.665 7.42829 10.8569 7.23641 10.8569 6.99972C10.8569 6.76303 10.665 6.57115 10.4283 6.57115H7.42829V3.57115Z", fill: "#999999" })), Sc = "_chips_1hpsg_1168", Nc = "_fileChip_1hpsg_1174", Lc = "_uploaded_1hpsg_1197", Ac = "_fileName_1hpsg_1200", Mc = "_crossCircleIcon_1hpsg_1203", Tc = "_folderIconContainer_1hpsg_1206", Pc = "_folderIcon_1hpsg_1206", Rc = "_loading_1hpsg_1255", Fc = "_loadingIcon_1hpsg_1268", Dc = "_rotateSpinner_1hpsg_1", Bc = "_dash_1hpsg_1", He = {
  chips: Sc,
  fileChip: Nc,
  uploaded: Lc,
  fileName: Ac,
  crossCircleIcon: Mc,
  folderIconContainer: Tc,
  folderIcon: Pc,
  loading: Rc,
  loadingIcon: Fc,
  rotateSpinner: Dc,
  dash: Bc
}, $c = (e) => /* @__PURE__ */ b.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "#666666", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("g", { id: "icon/file-generic" }, /* @__PURE__ */ b.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M11.8438 4.12926L11.8921 4.17752C12.0528 4.33827 12.1431 4.55628 12.1431 4.78361V12.1429C12.1431 12.6162 11.7594 13 11.286 13H2.71456C2.24118 13 1.85742 12.6162 1.85742 12.1429V1.85714C1.85742 1.38376 2.24118 1 2.71456 1H8.35952C8.58685 1 8.80487 1.09031 8.96562 1.25105L9.01381 1.29924C9.01508 1.30049 9.01635 1.30174 9.01761 1.303L11.8401 4.12548C11.8413 4.12674 11.8426 4.128 11.8438 4.12926ZM11.286 12.1429H2.71456L2.71456 1.85714H8.28599V4.42853C8.28599 4.66522 8.47787 4.8571 8.71457 4.8571H11.286V12.1429Z" }))), Oc = (e) => /* @__PURE__ */ b.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#CCCCCC", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M8.78038 16.2803C8.64465 16.416 8.45713 16.5 8.25 16.5C7.83579 16.5 7.5 16.1642 7.5 15.75C7.5 15.5412 7.58535 15.3523 7.72308 15.2163L10.9394 12L7.72672 8.78729C7.58686 8.65105 7.5 8.46067 7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.45711 7.5 8.64462 7.58395 8.78034 7.71968L12.0001 10.9393L15.2163 7.72308C15.3523 7.58535 15.5412 7.5 15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.45708 16.4161 8.64456 16.2804 8.78028L13.0607 12L16.2804 15.2196C16.4161 15.3554 16.5 15.5429 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.5393 16.5 15.349 16.4131 15.2127 16.2733L12.0001 13.0606L8.78038 16.2803Z" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25Z" })), zc = (e) => /* @__PURE__ */ b.createElement("svg", { className: "spinner", viewBox: "0 0 50 50", fill: "none", ...e }, /* @__PURE__ */ b.createElement("circle", { className: "path", cx: 25, cy: 25, r: 20, strokeWidth: 5 })), Hc = (e) => {
  const { filename: n, disabled: t, removeFile: r } = e;
  return /* @__PURE__ */ B(
    "button",
    {
      className: `${He.fileChip} ${t === !1 ? He.uploaded : ""}`,
      onClick: r,
      disabled: t,
      children: [
        /* @__PURE__ */ m("div", { className: He.folderIconContainer, children: /* @__PURE__ */ m($c, { className: He.folderIcon }) }),
        /* @__PURE__ */ m("div", { className: He.fileName, children: n }),
        /* @__PURE__ */ m(Oc, { className: He.crossCircleIcon }),
        t && /* @__PURE__ */ m("div", { className: He.loading, children: /* @__PURE__ */ m(zc, { className: He.loadingIcon }) })
      ]
    }
  );
}, Vc = (e) => {
  const n = e.name.replace(/([^a-zA-Z0-9-_. ])/g, "_");
  return new File([e], n, { type: e.type });
}, jc = ne((e, n) => {
  const { onSendMessage: t, className: r, inputsClassName: i, disabled: l } = e, { t: o } = Re(), a = pe(null), [s, c] = b.useState(""), p = pe(null), [d, f] = b.useState([]), u = pe(null), C = b.useRef(null), x = (y = void 0) => {
    y == null || y.preventDefault(), y == null || y.stopPropagation(), l || (t({ text: s, files: d }), c(""), f([]));
  }, k = (y) => {
    y.key === "Enter" && !y.shiftKey && (y.preventDefault(), x());
  };
  ie(() => {
    w();
  }, [s]);
  const w = () => {
    const y = C.current;
    y && (y.style.height = "auto", y.style.height = `${y.scrollHeight}px`), y && u.current && (y.style.height = "auto", y.style.height = `${y.scrollHeight}px`);
  }, I = (y) => {
    y.preventDefault(), p.current && p.current.click();
  }, v = re(
    (y) => {
      var P;
      const T = (P = y.clipboardData) == null ? void 0 : P.items;
      if (T) {
        const _ = [];
        for (let E = 0; E < T.length; E++)
          if (T[E].kind === "file") {
            const S = T[E].getAsFile();
            S && _.push(S);
          }
        _.length && (f([...d, ..._]), y.preventDefault());
      }
    },
    [d, f]
  ), A = re((y) => {
    if (p.current) {
      const T = y.map(Vc);
      f([...d, ...T]);
    }
  }, [d]);
  Tn(n, () => ({
    ...a.current,
    // Spread the HTMLDivElement properties
    inputContainerRef: a,
    addFiles: A,
    setMessage: c
  }));
  const L = re((y) => {
    const T = [...d];
    T.splice(y, 1), f(T);
  }, [d, f]);
  return ie(() => {
    var y;
    l ? (c(""), f([])) : (y = C.current) == null || y.focus({
      preventScroll: !0
    });
  }, [l]), /* @__PURE__ */ m("div", { className: `${$e.chatInputContainer} ${r ?? ""}`, children: /* @__PURE__ */ B(
    "div",
    {
      className: `${$e.chatInput} ${l ? $e.disabled : ""}`,
      id: "chat-input",
      ref: a,
      children: [
        /* @__PURE__ */ m(
          "input",
          {
            ref: p,
            type: "file",
            className: $e.fileInput,
            multiple: !0,
            onChange: (y) => f(Array.from(y.target.files || [])),
            disabled: l
          }
        ),
        /* @__PURE__ */ m("button", { className: $e.attachButton, onClick: I, children: /* @__PURE__ */ m(Ec, {}) }),
        /* @__PURE__ */ B(
          "div",
          {
            ref: u,
            className: `${$e.inputs} ${i ?? ""}`,
            children: [
              /* @__PURE__ */ m(
                "textarea",
                {
                  ref: C,
                  className: $e.message,
                  value: s,
                  onChange: (y) => c(y.target.value),
                  onKeyDown: k,
                  rows: 1,
                  placeholder: o("chat.input-placeholder"),
                  autoFocus: !0,
                  onPaste: v,
                  disabled: l
                }
              ),
              d && (d == null ? void 0 : d.length) > 0 ? /* @__PURE__ */ m("div", { className: $e.files, children: d.map((y, T) => /* @__PURE__ */ m(
                Hc,
                {
                  filename: y.name,
                  removeFile: () => L(T)
                },
                y.name
              )) }) : null
            ]
          }
        ),
        /* @__PURE__ */ m("button", { className: $e.sendButton, onClick: x, children: /* @__PURE__ */ m(Ic, {}) })
      ]
    }
  ) });
}), qc = "_chat_1r3nn_1149", Wc = "_messages_1r3nn_1158", Zc = "_messageWithAction_1r3nn_1184", Uc = "_message_1r3nn_1158", Qc = "_input_1r3nn_1196", Yc = "_messageWrapper_1r3nn_1200", Kc = "_timestamp_1r3nn_1205", Xc = "_right_1r3nn_1223", Jc = "_show_1r3nn_1228", ke = {
  chat: qc,
  messages: Wc,
  messageWithAction: Zc,
  message: Uc,
  input: Qc,
  messageWrapper: Yc,
  timestamp: Kc,
  right: Xc,
  show: Jc
}, Gc = (e, n) => new Intl.DateTimeFormat(n, {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}).format(e), v5 = (e, n) => new Intl.DateTimeFormat(n, {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(e), b5 = (e, n) => new Intl.DateTimeFormat(n, {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(e), k5 = (e, n) => new Intl.DateTimeFormat(n, {
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit"
}).format(e), eu = (e, n) => new Intl.DateTimeFormat(n, {
  weekday: "short",
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: !0
}).format(e), _5 = ne(
  (e, n) => {
    const {
      onSendMessage: t,
      messages: r,
      isLoading: i,
      children: l,
      inputClassName: o,
      withHover: a,
      ...s
    } = e, c = pe(null), { stayScrolled: p } = Ei(c), d = pe(null), f = pe(null);
    return _i(() => {
      p();
    }, [r, p]), Tn(n, () => ({
      inputRef: d ?? null,
      chatRef: f
    })), /* @__PURE__ */ B(
      "div",
      {
        ...s,
        className: `${ke.chat} ${e.className || ""}`,
        ref: f,
        children: [
          /* @__PURE__ */ B("div", { ref: c, className: ke.messages, children: [
            l,
            r.map((u, C) => /* @__PURE__ */ m(
              nu,
              {
                message: u,
                hoverDelay: 200,
                withHover: a
              },
              C
            )),
            i && /* @__PURE__ */ m("div", { className: `${ke.message} ${ke.lawyer}`, children: "typing.." })
          ] }),
          /* @__PURE__ */ m(
            jc,
            {
              onSendMessage: t,
              ref: d,
              className: `${ke.input} ${o}`
            }
          )
        ]
      }
    );
  }
), nu = (e) => {
  const { message: n, withHover: t } = e, r = e.hoverDelay ?? 200, [i, l] = J(!1), o = n.from === "lawyer" ? hc : uc, a = pe(null), s = re(() => {
    a.current && (clearTimeout(a.current), a.current = null), l(!0);
  }, []), c = re(() => {
    a.current = setTimeout(() => {
      l(!1);
    }, r);
  }, [r]);
  return /* @__PURE__ */ B("div", { className: ke.messageWrapper, children: [
    /* @__PURE__ */ m(
      o,
      {
        message: typeof n.content == "string" ? n.content : "",
        timestamp: n.createdAt,
        className: ke.message,
        onMouseEnter: s,
        onMouseLeave: c
      }
    ),
    t && /* @__PURE__ */ m(
      "div",
      {
        className: `${ke.timestamp}
          ${i ? ke.show : ke.hide}
          ${n.from === "lawyer" ? ke.left : ke.right}`,
        children: eu(n.createdAt ?? Date.now())
      }
    )
  ] });
}, tu = "_yesNoInput_10dl3_1149", ru = "_actionButton_10dl3_1156", iu = "_dot_10dl3_1173", lu = "_disabled_10dl3_1179", ou = "_active_10dl3_1183", Ve = {
  yesNoInput: tu,
  actionButton: ru,
  dot: iu,
  disabled: lu,
  active: ou
}, au = ne(
  (e, n) => {
    var s;
    const {
      value: t,
      disabled: r,
      onChange: i,
      language: l
    } = e, { t: o } = Re(void 0, { lng: l ?? "en" }), a = re((c) => (p) => {
      p.preventDefault(), r || i(c);
    }, [r, i]);
    return /* @__PURE__ */ B(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Ve.yesNoInput} ${r ? Ve.disabled : ""} ${(s = e.props) == null ? void 0 : s.className}`,
        children: [
          /* @__PURE__ */ B(
            "button",
            {
              className: `${Ve.actionButton} ${(t == null ? void 0 : t.toLocaleLowerCase()) === "yes" ? Ve.active : ""}`,
              onClick: a("yes"),
              disabled: r,
              children: [
                /* @__PURE__ */ m("div", { className: Ve.dot }),
                o("confirm.yes")
              ]
            }
          ),
          /* @__PURE__ */ B(
            "button",
            {
              className: `${Ve.actionButton} ${(t == null ? void 0 : t.toLocaleLowerCase()) === "no" ? Ve.active : ""}`,
              onClick: a("no"),
              disabled: r,
              children: [
                /* @__PURE__ */ m("div", { className: Ve.dot }),
                o("confirm.no")
              ]
            }
          )
        ]
      }
    );
  }
), su = "_progressBar_1t1hx_1149", cu = "_cover_1t1hx_1158", kr = {
  progressBar: su,
  cover: cu
}, uu = ne((e, n) => {
  const {
    value: t,
    ...r
    // this must be last and is the div props
  } = e;
  return /* @__PURE__ */ m("div", { ref: n, ...r, className: `${kr.progressBar} ${r.className}`, children: /* @__PURE__ */ m("div", { className: kr.cover, style: { width: `${100 - t}%` } }) });
}), pu = "_textInput_10z1r_1149", du = {
  textInput: pu
}, hu = ne((e, n) => {
  var i;
  const { value: t, onChange: r } = e;
  return /* @__PURE__ */ m(
    "input",
    {
      ref: n,
      ...e.props,
      className: `${du.textInput} ${((i = e.props) == null ? void 0 : i.className) || ""}`,
      type: "text",
      value: t || "",
      onChange: (l) => r(l.target.value)
    }
  );
}), fu = "_radioInputLabel_5aj0o_1149", mu = "_radioInput_5aj0o_1149", _r = {
  radioInputLabel: fu,
  radioInput: mu
}, gu = ne((e, n) => {
  var c;
  const { checked: t = !1, value: r, name: i, label: l, disabled: o, onChange: a } = e, s = re((p) => {
    o || a(p.target.checked ? p.target.value : "");
  }, [o, a]);
  return /* @__PURE__ */ B("label", { className: _r.radioInputLabel, htmlFor: `${i}-${r}`, children: [
    /* @__PURE__ */ m(
      "input",
      {
        id: `${i}-${r}`,
        ref: n,
        ...e.props,
        className: `${_r.radioInput} ${((c = e.props) == null ? void 0 : c.className) || ""}`,
        type: "radio",
        name: i,
        value: r,
        checked: t,
        onChange: s,
        disabled: o
      }
    ),
    l
  ] });
}), yu = "_checkboxInputLabel_1hn58_1149", wu = "_checkboxInput_1hn58_1149", Ir = {
  checkboxInputLabel: yu,
  checkboxInput: wu
}, Cu = ne((e, n) => {
  var s;
  const { checked: t = !1, value: r, label: i, disabled: l, onChange: o } = e, a = re((c) => {
    l || o(c.target.value, c.target.checked);
  }, [l, o]);
  return /* @__PURE__ */ B("label", { className: Ir.checkboxInputLabel, htmlFor: `checkbox-${r}`, children: [
    /* @__PURE__ */ m(
      "input",
      {
        id: `checkbox-${r}`,
        ref: n,
        ...e.props,
        className: `${Ir.checkboxInput} ${((s = e.props) == null ? void 0 : s.className) || ""}`,
        type: "checkbox",
        value: r,
        checked: t,
        onChange: a,
        disabled: l
      }
    ),
    i
  ] });
}), xu = "_dateInputWrapper_q3fks_1149", vu = "_dateInput_q3fks_1149", bu = "_calendarIcon_q3fks_1183", Kn = {
  dateInputWrapper: xu,
  dateInput: vu,
  calendarIcon: bu
}, ku = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("g", { id: "icon/calendar" }, /* @__PURE__ */ b.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M5.49631 3.5H7.49631V3C7.49631 2.72386 7.72016 2.5 7.99631 2.5C8.27245 2.5 8.49631 2.72386 8.49631 3V3.5H10.4963V3C10.4963 2.72386 10.7202 2.5 10.9963 2.5C11.2724 2.5 11.4963 2.72386 11.4963 3V3.5H13.4963C14.0486 3.5 14.4963 3.94772 14.4963 4.5V13.5C14.4963 14.0523 14.0486 14.5 13.4963 14.5H2.49631C1.94402 14.5 1.49631 14.0523 1.49631 13.5V4.5C1.49631 3.94772 1.94402 3.5 2.49631 3.5H4.49631V3C4.49631 2.72386 4.72016 2.5 4.99631 2.5C5.27245 2.5 5.49631 2.72386 5.49631 3V3.5ZM10.4963 5C10.4963 5.27614 10.7202 5.5 10.9963 5.5C11.2724 5.5 11.4963 5.27614 11.4963 5V4.5H13.4963V6.5H2.49631V4.5H4.49631V5C4.49631 5.27614 4.72017 5.5 4.99631 5.5C5.27245 5.5 5.49631 5.27614 5.49631 5V4.5H7.49631V5C7.49631 5.27614 7.72017 5.5 7.99631 5.5C8.27245 5.5 8.49631 5.27614 8.49631 5V4.5H10.4963V5ZM2.49631 13.5L2.49631 7.5H13.4963V13.5H2.49631Z", fill: "#666666" }))), _u = ne((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, l = re((a) => {
    r || i(new Date(a.target.value).getTime());
  }, [r, i]);
  return /* @__PURE__ */ B("div", { className: Kn.dateInputWrapper, children: [
    /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${Kn.dateInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "date",
        value: t && !isNaN(t) ? new Date(t).toISOString().split("T")[0] : "",
        onChange: l,
        disabled: r
      }
    ),
    /* @__PURE__ */ m("div", { className: Kn.calendarIcon, children: /* @__PURE__ */ m(ku, {}) })
  ] });
}), Iu = "_dateTimeInputWrapper_8yelm_1149", Eu = "_dateTimeInput_8yelm_1149", Su = "_calendarIcon_8yelm_1183", Xn = {
  dateTimeInputWrapper: Iu,
  dateTimeInput: Eu,
  calendarIcon: Su
}, Nu = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("g", { id: "icon/calendar" }, /* @__PURE__ */ b.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M5.49631 3.5H7.49631V3C7.49631 2.72386 7.72016 2.5 7.99631 2.5C8.27245 2.5 8.49631 2.72386 8.49631 3V3.5H10.4963V3C10.4963 2.72386 10.7202 2.5 10.9963 2.5C11.2724 2.5 11.4963 2.72386 11.4963 3V3.5H13.4963C14.0486 3.5 14.4963 3.94772 14.4963 4.5V13.5C14.4963 14.0523 14.0486 14.5 13.4963 14.5H2.49631C1.94402 14.5 1.49631 14.0523 1.49631 13.5V4.5C1.49631 3.94772 1.94402 3.5 2.49631 3.5H4.49631V3C4.49631 2.72386 4.72016 2.5 4.99631 2.5C5.27245 2.5 5.49631 2.72386 5.49631 3V3.5ZM10.4963 5C10.4963 5.27614 10.7202 5.5 10.9963 5.5C11.2724 5.5 11.4963 5.27614 11.4963 5V4.5H13.4963V6.5H2.49631V4.5H4.49631V5C4.49631 5.27614 4.72017 5.5 4.99631 5.5C5.27245 5.5 5.49631 5.27614 5.49631 5V4.5H7.49631V5C7.49631 5.27614 7.72017 5.5 7.99631 5.5C8.27245 5.5 8.49631 5.27614 8.49631 5V4.5H10.4963V5ZM2.49631 13.5L2.49631 7.5H13.4963V13.5H2.49631Z", fill: "#666666" }))), Lu = ne((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, l = re((a) => {
    r || i(a.target.value);
  }, [r, i]);
  return /* @__PURE__ */ B("div", { className: Xn.dateTimeInputWrapper, children: [
    /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${Xn.dateTimeInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "datetime-local",
        value: t ? new Date(t).toISOString().slice(0, 16) : "",
        onChange: l,
        disabled: r
      }
    ),
    /* @__PURE__ */ m("div", { className: Xn.calendarIcon, children: /* @__PURE__ */ m(Nu, {}) })
  ] });
}), Au = "_timeInputWrapper_fp8sc_1149", Mu = "_timeInput_fp8sc_1149", Tu = "_clockIcon_fp8sc_1183", Jn = {
  timeInputWrapper: Au,
  timeInput: Mu,
  clockIcon: Tu
}, Pu = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("g", { id: "icon/clock" }, /* @__PURE__ */ b.createElement("g", { id: "Union" }, /* @__PURE__ */ b.createElement("path", { d: "M10.5 10.5C10.5 10.7761 10.2761 11 10 11C9.85956 11 9.73264 10.9421 9.64182 10.8489L7.65114 8.85819C7.55791 8.76737 7.5 8.64045 7.5 8.5V5.5C7.5 5.22386 7.72386 5 8 5C8.27614 5 8.5 5.22386 8.5 5.5V8.29283L10.3536 10.1464C10.4441 10.2369 10.5 10.3619 10.5 10.5Z", fill: "#666666" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.5899 15 14.5 12.0899 14.5 8.5C14.5 4.91015 11.5899 2 8 2C4.41015 2 1.5 4.91015 1.5 8.5C1.5 12.0899 4.41015 15 8 15ZM8 14C11.0376 14 13.5 11.5376 13.5 8.5C13.5 5.46243 11.0376 3 8 3C4.96243 3 2.5 5.46243 2.5 8.5C2.5 11.5376 4.96243 14 8 14Z", fill: "#666666" })))), Ru = ne((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, l = re((a) => {
    r || i(a.target.value);
  }, [r, i]);
  return /* @__PURE__ */ B("div", { className: Jn.timeInputWrapper, children: [
    /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${Jn.timeInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "time",
        value: t,
        onChange: l,
        disabled: r
      }
    ),
    /* @__PURE__ */ m("div", { className: Jn.clockIcon, children: /* @__PURE__ */ m(Pu, {}) })
  ] });
}), Fu = "_inputLabel_uwv0v_1149", Du = "_desktop_uwv0v_1165", Bu = "_mobile_uwv0v_1169", $u = "_textWithEmail_uwv0v_1206", pn = {
  inputLabel: Fu,
  desktop: Du,
  mobile: Bu,
  textWithEmail: $u
}, Ou = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3V2C12 1.44772 11.5523 1 11 1H3C2.44772 1 2 1.44772 2 2V12C2 12.5523 2.44772 13 3 13H4V14C4 14.5523 4.44772 15 5 15H13C13.5523 15 14 14.5523 14 14V4C14 3.44772 13.5523 3 13 3H12ZM11 2H3V12H4V4C4 3.44772 4.44772 3 5 3H11V2ZM5 4V14H13V4H5Z", fill: "#666666" })), zu = ne(
  (e, n) => {
    var s;
    const { text: t, language: r } = e, { t: i } = Re(void 0, { lng: r ?? "en" }), [l, o] = J(null);
    ie(() => {
      if (typeof t == "string") {
        const c = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, p = t.match(c);
        p && o(p[0]);
      }
    }, [t]);
    const a = re((c) => {
      l && (c.preventDefault(), Si(l), Ni.success(i("chat.copied-link")));
    }, [l, i]);
    return ie(() => {
      var c;
      return (c = document.getElementById("email-files")) == null || c.addEventListener("click", a), () => {
        var p;
        (p = document.getElementById("email-files")) == null || p.removeEventListener("click", a);
      };
    }, [a, l]), /* @__PURE__ */ m(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${pn.inputLabel} ${((s = e.props) == null ? void 0 : s.className) || ""}`,
        children: typeof t == "string" && l ? /* @__PURE__ */ B(Oe, { children: [
          /* @__PURE__ */ m("div", { className: pn.mobile, children: /* @__PURE__ */ m("div", { className: pn.mobileFileLabel, dangerouslySetInnerHTML: { __html: i("chat.questionnaire-upload-mobile") } }) }),
          /* @__PURE__ */ B("div", { className: pn.desktop, children: [
            i("chat.questionnaire-upload-desktop"),
            /* @__PURE__ */ m("div", { style: { display: "inline-block" }, children: /* @__PURE__ */ B("div", { className: pn.textWithEmail, onClick: a, children: [
              /* @__PURE__ */ B("div", { children: [
                /* @__PURE__ */ m("span", { children: l }),
                "."
              ] }),
              /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(Ou, {}) })
            ] }) })
          ] })
        ] }) : t
      }
    );
  }
), Hu = "_inputDescription_om8wf_1149", Vu = {
  inputDescription: Hu
}, _n = ne((e, n) => {
  var r;
  const { text: t } = e;
  return /* @__PURE__ */ m("div", { ref: n, ...e.props, className: `${Vu.inputDescription} ${((r = e.props) == null ? void 0 : r.className) || ""}`, children: t });
}), ju = "_fileInput_19etk_1157", qu = "_fileInputLabel_19etk_1168", Wu = "_dragging_19etk_1193", Zu = "_fileList_19etk_1199", Uu = "_fileChips_19etk_1217", Qu = "_fileChip_19etk_1217", Yu = "_uploaded_19etk_1239", Ku = "_uploading_19etk_1243", Xu = "_active_19etk_1258", Ju = "_rotate_19etk_1", Gu = "_fileIcon_19etk_1264", e1 = "_fileRemoveIcon_19etk_1276", Se = {
  fileInput: ju,
  fileInputLabel: qu,
  dragging: Wu,
  fileList: Zu,
  fileChips: Uu,
  fileChip: Qu,
  uploaded: Yu,
  uploading: Ku,
  active: Xu,
  rotate: Ju,
  fileIcon: Gu,
  fileRemoveIcon: e1
}, n1 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("rect", { width: 32, height: 32, rx: 16, fill: "#EEEEEE" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.458 12.1724L22.5224 12.2367C22.7367 12.451 22.8571 12.7417 22.8571 13.0448V22.8571C22.8571 23.4883 22.3454 24 21.7143 24H10.2857C9.6545 24 9.14282 23.4883 9.14282 22.8571V9.14286C9.14282 8.51168 9.6545 8 10.2857 8H17.8123C18.1154 8 18.4061 8.12041 18.6204 8.33474L18.6847 8.39899C18.6864 8.40065 18.6881 8.40232 18.6897 8.404L22.453 12.1673C22.4547 12.169 22.4564 12.1707 22.458 12.1724ZM21.7143 22.8571H10.2857L10.2857 9.14286H17.7143V12.5714C17.7143 12.887 17.9701 13.1428 18.2857 13.1428H21.7143V22.8571Z", fill: "#666666" })), t1 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#CCCCCC", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M8.78038 16.2803C8.64465 16.416 8.45713 16.5 8.25 16.5C7.83579 16.5 7.5 16.1642 7.5 15.75C7.5 15.5412 7.58535 15.3523 7.72308 15.2163L10.9394 12L7.72672 8.78729C7.58686 8.65105 7.5 8.46067 7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.45711 7.5 8.64462 7.58395 8.78034 7.71968L12.0001 10.9393L15.2163 7.72308C15.3523 7.58535 15.5412 7.5 15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.45708 16.4161 8.64456 16.2804 8.78028L13.0607 12L16.2804 15.2196C16.4161 15.3554 16.5 15.5429 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.5393 16.5 15.349 16.4131 15.2127 16.2733L12.0001 13.0606L8.78038 16.2803Z" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25Z" })), r1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGYSURBVHgB1VRLUsJAFJwEizVHiCdQb8ANgBNgNlCs0BOIJ1BXFGSReILoCeQG6gmMN4jbfO2mJhT5SUiykK6CN4HJ6zc9/Z4Qpw7l0AbTNHue510rinKBRy2O49fpdPooKuKs7I/lcql1Op07JuczEjsgccSRKDyBYRj9KIpsrhGfEKzZbOaIGsgRrFarIYKNaj/CMBzVTVxIQFlUVX3jutvtXum67oqGSN0BNYfWGmQ5byM5sTuBrP4L0liTyUQXLUHdW/f5Bd3vRYvYEUCeAYLb9FJLCYAenSMaYr1ez+HEmyKCtjBEoYMcAdzzTQeJhkCOS7jwJ0cAUB4Ns0cTNUEnIvTgxpccARrLYkxmTx2wjxjhxE2OQDbWMz5zWclR4DuQh1M3NbdSlwztFrISm2NaVAT3yhHjZPsoRUBmkIx4UZDqvcpJuMf3fSbn3ttsHxWOazlRH/gSj8yqsi/SDEEQjFHQ1vMsDHs22VzKX5Xh2Assx/InN2lEaWdtm6CkgIME+0QIfZANkCy5Fwckn3ReW1P3/+IX0T/GHCkkTN4AAAAASUVORK5CYII=", i1 = ne(
  (e, n) => {
    var k;
    const { value: t = [], onChange: r, disabled: i, language: l } = e, { t: o } = Re(void 0, { lng: l ?? "en" }), a = pe(null), [s, c] = J(!1), p = re(() => {
      i || c(!0);
    }, [i]), d = re(() => {
      i || c(!1);
    }, [i]), f = (w) => {
      w.target.files && !i && r([...t || [], ...Array.from(w.target.files)]);
    }, u = (w) => {
      w.preventDefault(), w.dataTransfer.files && !i && r([...t || [], ...Array.from(w.dataTransfer.files)]), c(!1);
    }, C = (w) => {
      var I;
      w.preventDefault(), i || (I = a.current) == null || I.click();
    }, x = (w) => {
      i || r((t || []).filter((I, v) => v !== w));
    };
    return ie(() => {
      var w;
      return (w = document.getElementById("browse-file")) == null || w.addEventListener("click", C), () => {
        var I;
        (I = document.getElementById("browse-file")) == null || I.removeEventListener("click", C);
      };
    }, []), Tn(n, () => ({
      click: C
    })), /* @__PURE__ */ B(
      "div",
      {
        ...e.props,
        className: `${Se.fileInput} ${s ? Se.dragging : ""} ${((k = e.props) == null ? void 0 : k.className) || ""}`,
        onDrop: u,
        onDragOver: (w) => w.preventDefault(),
        onDragEnter: p,
        onDragLeave: d,
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              className: Se.fileInputLabel,
              dangerouslySetInnerHTML: { __html: o("chat.browse-or-drop") }
            }
          ),
          /* @__PURE__ */ m("input", { ref: a, type: "file", onChange: f }),
          t.length > 0 ? /* @__PURE__ */ m("div", { className: Se.fileList, children: /* @__PURE__ */ m("div", { className: Se.fileChips, children: t.map((w, I) => /* @__PURE__ */ B(
            "div",
            {
              className: `${Se.fileChip} ${!(w instanceof File) && w.id ? Se.uploaded : ""}`,
              children: [
                /* @__PURE__ */ m("div", { className: `${Se.uploading} ${w.uploading ? Se.active : ""}`, children: /* @__PURE__ */ m("img", { src: r1, alt: "loading" }) }),
                /* @__PURE__ */ m("div", { className: Se.fileIcon, children: /* @__PURE__ */ m(n1, {}) }),
                w.name || "file",
                "id" in w && !w.attachedToMessage || !("id" in w) ? /* @__PURE__ */ m(
                  "div",
                  {
                    className: Se.fileRemoveIcon,
                    onClick: () => x(I),
                    title: "Remove file",
                    children: /* @__PURE__ */ m(t1, {})
                  }
                ) : null
              ]
            },
            I
          )) }) }) : null
        ]
      }
    );
  }
), l1 = "_numericInput_1przn_1149", o1 = {
  numericInput: l1
}, a1 = ne(
  (e, n) => {
    var o;
    const { value: t, disabled: r, onChange: i } = e, l = re((a) => {
      a.preventDefault(), a.stopPropagation(), r || i(a.target.value);
    }, [r, i]);
    return /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${o1.numericInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "number",
        value: t,
        onChange: l
      }
    );
  }
), s1 = "_inputSeparator_3zmll_1149", c1 = {
  inputSeparator: s1
}, fi = ne((e, n) => {
  var t;
  return /* @__PURE__ */ m("div", { ref: n, ...e.props, className: `${c1.inputSeparator} ${(t = e.props) == null ? void 0 : t.className}` });
}), u1 = "_questionWrapper_56ixz_1149", p1 = "_multiPartQuestion_56ixz_1160", d1 = "_childQuestionWrapper_56ixz_1166", dn = {
  questionWrapper: u1,
  multiPartQuestion: p1,
  childQuestionWrapper: d1
}, h1 = "_tabList_1eqw8_1", f1 = "_tabItems_1eqw8_7", m1 = "_tabItem_1eqw8_7", g1 = "_reverse_1eqw8_31", y1 = "_active_1eqw8_40", w1 = "_tabAdd_1eqw8_44", C1 = "_tab_1eqw8_1", x1 = "_tabRemove_1eqw8_90", Ce = {
  tabList: h1,
  tabItems: f1,
  tabItem: m1,
  reverse: g1,
  active: y1,
  tabAdd: w1,
  tab: C1,
  tabRemove: x1
}, Er = (e) => /* @__PURE__ */ b.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, stroke: "#0E5FE3" }), /* @__PURE__ */ b.createElement("path", { d: "M9.5 5C9.5 4.72386 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.72386 8.5 5V8.5H5C4.72386 8.5 4.5 8.72386 4.5 9C4.5 9.27614 4.72386 9.5 5 9.5H8.5V13C8.5 13.2761 8.72386 13.5 9 13.5C9.27614 13.5 9.5 13.2761 9.5 13V9.5H13C13.2761 9.5 13.5 9.27614 13.5 9C13.5 8.72386 13.2761 8.5 13 8.5H9.5V5Z", fill: "#0E5FE3" })), v1 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, stroke: "#BB1600" }), /* @__PURE__ */ b.createElement("path", { d: "M12.75 4.875C12.9571 4.875 13.125 5.04289 13.125 5.25C13.125 5.35354 13.083 5.44728 13.0152 5.51514L9.53036 8.99998L13.0152 12.4848C13.0831 12.5527 13.125 12.6464 13.125 12.75C13.125 12.9571 12.9571 13.125 12.75 13.125C12.6447 13.125 12.5495 13.0816 12.4814 13.0117L9.00003 9.53031L5.51519 13.0151C5.44733 13.083 5.35356 13.125 5.25 13.125C5.04289 13.125 4.875 12.9571 4.875 12.75C4.875 12.6456 4.91768 12.5511 4.98654 12.4831L8.4697 8.99998L4.98835 5.51864C4.91843 5.45052 4.875 5.35533 4.875 5.25C4.875 5.04289 5.04289 4.875 5.25 4.875C5.35356 4.875 5.44731 4.91698 5.51517 4.98484L9.00003 8.46965L12.4831 4.98654C12.5511 4.91768 12.6456 4.875 12.75 4.875Z", fill: "#BB1600" })), b1 = (e) => {
  var u, C, x;
  const { questions: n, question: t, onChange: r, disabled: i = !1, language: l } = e, { t: o } = Re(), [a, s] = J(0), c = (k) => (w) => {
    w.preventDefault(), s(k);
  }, p = (k) => {
    k.stopPropagation(), k.preventDefault();
    const w = {
      ...t,
      answer: [
        ...t.answer || [],
        t.questions
      ]
    };
    r(w), s(w.answer && w.answer.length > 0 ? w.answer.length - 1 : 0);
  }, d = (k) => (w) => {
    var v;
    w.stopPropagation(), w.preventDefault();
    const I = {
      ...t,
      answer: (v = t.answer) == null ? void 0 : v.filter(
        (A, L) => L !== k
      )
    };
    r(I), s(k - 1 > 0 ? k - 1 : 0);
  }, f = (k) => (w) => {
    const I = { ...t };
    I.answer && I.answer[k] && (I.answer[k] = I.answer[k].map((v) => v.id === w.id ? w : v)), r(I);
  };
  return ie(() => {
    t.answer || p(new MouseEvent("click"));
  }, []), /* @__PURE__ */ B("div", { className: Ce.tabList, children: [
    /* @__PURE__ */ B("div", { className: Ce.tabItems, children: [
      (u = t.answer) == null ? void 0 : u.map((k, w) => {
        var v;
        const I = (v = k.find((A) => A.id === t.label)) == null ? void 0 : v.answer;
        return /* @__PURE__ */ m(
          "button",
          {
            onClick: c(w),
            className: `${Ce.tabItem} ${w === a ? Ce.active : ""}`,
            children: t.label && I && typeof I != "object" ? I || o("prematter.new") : `#${w + 1}`
          },
          w
        );
      }),
      /* @__PURE__ */ B("button", { onClick: p, className: Ce.tabAdd, disabled: i, children: [
        /* @__PURE__ */ m(Er, {}),
        " ",
        o("prematter.add")
      ] })
    ] }),
    (C = t.answer) == null ? void 0 : C.map((k, w) => /* @__PURE__ */ B(
      "div",
      {
        className: `${Ce.tab} ${w === a ? Ce.active : ""}`,
        children: [
          k.map((I, v) => /* @__PURE__ */ m(
            ln,
            {
              questions: n,
              question: I,
              onChange: f(w),
              disabled: i,
              language: l
            },
            v
          )),
          /* @__PURE__ */ m(fi, {}),
          /* @__PURE__ */ B("button", { onClick: d(w), className: Ce.tabRemove, children: [
            /* @__PURE__ */ m(v1, {}),
            " ",
            o("prematter.remove")
          ] })
        ]
      },
      w
    )),
    /* @__PURE__ */ B("div", { className: Ce.tabItems, children: [
      (x = t.answer) == null ? void 0 : x.map((k, w) => {
        var v;
        const I = (v = k.find((A) => A.id === t.label)) == null ? void 0 : v.answer;
        return /* @__PURE__ */ m(
          "button",
          {
            onClick: c(w),
            className: `${Ce.tabItem} ${Ce.reverse} ${w === a ? Ce.active : ""}`,
            children: typeof I != "object" && I || o("prematter.new")
          },
          w
        );
      }),
      /* @__PURE__ */ B("button", { onClick: p, className: Ce.tabAdd, disabled: i, children: [
        /* @__PURE__ */ m(Er, {}),
        " ",
        o("prematter.add")
      ] })
    ] })
  ] });
}, k1 = "_scaleInputContainer_kao9s_1149", _1 = "_scaleInput_kao9s_1149", I1 = "_scaleInputLabels_kao9s_1212", E1 = "_labelWrapper_kao9s_1220", S1 = "_currentValue_kao9s_1227", N1 = "_label_kao9s_1220", Ge = {
  scaleInputContainer: k1,
  scaleInput: _1,
  scaleInputLabels: I1,
  labelWrapper: E1,
  currentValue: S1,
  label: N1
}, L1 = ne(
  (e, n) => {
    var u, C;
    const { value: t, labels: r = [], min: i, max: l, onChange: o, disabled: a } = e, [s, c] = J(t), [p, d] = J(void 0);
    ie(() => {
      if (s !== void 0)
        for (let x = 0; x < r.length; x++) {
          const k = r[x];
          if (k.lower && k.upper && s >= k.lower && s <= k.upper) {
            d(k.text);
            break;
          } else if (k.lower && !k.upper && s >= k.lower) {
            d(k.text);
            break;
          } else if (!k.lower && k.upper && s <= k.upper) {
            d(k.text);
            break;
          }
        }
    }, [s, r]);
    const f = (x) => {
      c(x), o(x);
    };
    return ie(() => {
      c(t);
    }, [t]), /* @__PURE__ */ B("div", { className: Ge.scaleInputContainer, children: [
      /* @__PURE__ */ m(
        "input",
        {
          ref: n,
          ...e.props,
          className: `${Ge.scaleInput} ${((u = e.props) == null ? void 0 : u.className) || ""}`,
          type: "range",
          value: s === void 0 ? i : s,
          min: i,
          max: l,
          onChange: (x) => f(parseInt(x.target.value)),
          style: {
            ...(C = e.props) == null ? void 0 : C.style,
            ...s ? {
              "--percentage": s === void 0 ? 0 : ((s || 0) - i) / (l - i) * 100 + "%"
            } : {}
          },
          disabled: a
        }
      ),
      /* @__PURE__ */ B("div", { className: Ge.scaleInputLabels, children: [
        /* @__PURE__ */ m("div", { children: i }),
        /* @__PURE__ */ B("div", { className: Ge.labelWrapper, children: [
          /* @__PURE__ */ m("div", { className: Ge.currentValue, children: s }),
          p ? /* @__PURE__ */ m("div", { className: Ge.label, children: p }) : null
        ] }),
        /* @__PURE__ */ m("div", { children: l })
      ] })
    ] });
  }
), A1 = "_splitDateInputWrapper_ysk4l_1149", M1 = "_splitDateInput_ysk4l_1149", In = {
  splitDateInputWrapper: A1,
  splitDateInput: M1
}, T1 = ne(
  (e, n) => {
    var v;
    const { value: t = {}, onChange: r, disabled: i } = e, [l, o] = J(t.year || ""), [a, s] = J(t.month || ""), [c, p] = J(t.day || ""), [d, f] = J([
      "day",
      "month",
      "year"
    ]);
    ie(() => {
      w();
    }, []);
    const u = (A, L) => new Date(A, L, 0).getDate(), C = (A) => {
      const L = A.target.value, y = parseInt(L, 10), T = parseInt(l, 10), P = parseInt(a, 10);
      if (!isNaN(y) && !isNaN(T) && !isNaN(P)) {
        const _ = u(T, P);
        y >= 1 && y <= _ && (p(L), r({ year: l, month: a, day: L }));
      } else (L === "" || !isNaN(y) && y < 31 && !l && !a) && (p(L), r({ year: l, month: a, day: L }));
    }, x = (A) => {
      const L = A.target.value, y = parseInt(L, 10), T = parseInt(l, 10), P = parseInt(c, 10);
      if (!isNaN(y) && y >= 1 && y <= 12) {
        s(L), r({ year: l, month: L, day: c });
        const _ = u(T, y);
        !isNaN(P) && P > _ && (p(_.toString()), r({ year: l, month: L, day: _.toString() }));
      } else L === "" && (s(L), r({ year: l, month: L, day: c }));
    }, k = (A) => {
      const L = A.target.value, y = parseInt(L, 10), T = parseInt(a, 10), P = parseInt(c, 10);
      if (isNaN(y))
        L === "" && (o(L), r({ year: L, month: a, day: c }));
      else {
        o(L), r({ year: L, month: a, day: c });
        const _ = u(y, T);
        !isNaN(P) && P > _ && (p(_.toString()), r({ year: L, month: a, day: _.toString() }));
      }
    }, w = () => {
      const y = new Date(1999, 11, 31).toLocaleDateString().split(/\D/);
      parseInt(y[0], 10) === 31 ? f(["day", "month", "year"]) : parseInt(y[0], 10) === 1999 ? f(["year", "month", "day"]) : f(["month", "day", "year"]);
    }, I = () => d.map((A, L) => A === "day" ? /* @__PURE__ */ m(
      "input",
      {
        type: "text",
        value: c,
        onChange: C,
        placeholder: "Day",
        className: In.splitDateInput,
        disabled: i
      },
      L
    ) : A === "month" ? /* @__PURE__ */ B("select", { value: a, onChange: x, className: In.splitDateInput, disabled: i, children: [
      /* @__PURE__ */ m("option", { value: "", children: "Month" }),
      /* @__PURE__ */ m("option", { value: "1", children: "January" }),
      /* @__PURE__ */ m("option", { value: "2", children: "February" }),
      /* @__PURE__ */ m("option", { value: "3", children: "March" }),
      /* @__PURE__ */ m("option", { value: "4", children: "April" }),
      /* @__PURE__ */ m("option", { value: "5", children: "May" }),
      /* @__PURE__ */ m("option", { value: "6", children: "June" }),
      /* @__PURE__ */ m("option", { value: "7", children: "July" }),
      /* @__PURE__ */ m("option", { value: "8", children: "August" }),
      /* @__PURE__ */ m("option", { value: "9", children: "September" }),
      /* @__PURE__ */ m("option", { value: "10", children: "October" }),
      /* @__PURE__ */ m("option", { value: "11", children: "November" }),
      /* @__PURE__ */ m("option", { value: "12", children: "December" })
    ] }, L) : A === "year" ? /* @__PURE__ */ m(
      "input",
      {
        type: "text",
        value: l,
        onChange: k,
        placeholder: "Year",
        className: In.splitDateInput,
        disabled: i
      },
      L
    ) : null);
    return /* @__PURE__ */ m(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${In.splitDateInputWrapper} ${(v = e.props) == null ? void 0 : v.className}`,
        children: I()
      }
    );
  }
), Et = (e, n) => {
  for (const t of n) {
    if (t.id === e)
      return t;
    if (t.type === U.MultiPart) {
      const r = Et(e, t.questions);
      if (r)
        return r;
    }
  }
  return null;
}, Ue = (e, n) => {
  var l;
  const t = /{{(.*?)(?:, *(.*?))?}}/g;
  let r, i = e;
  for (; r = t.exec(e); ) {
    const a = r[1].trim().split("."), s = a[0], c = (l = r[2]) == null ? void 0 : l.trim(), p = Et(s, n);
    if (p && p.answer)
      if (typeof p.answer == "object") {
        const d = p.answer;
        a.length > 1 ? i = i.replace(
          r[0],
          d[a[1]] || c || ""
        ) : i = i.replace(r[0], p.answer);
      } else
        i = i.replace(r[0], p.answer);
    else c ? i = i.replace(r[0], c) : i = i.replace(r[0], "");
  }
  return i;
}, ln = ne(
  (e, n) => {
    var c, p, d, f;
    const { questions: t, question: r, onChange: i, disabled: l = !1, language: o } = e, a = (u) => {
      if (!l) {
        const C = { ...r, answer: u, answeredAt: Date.now() };
        i(C);
      }
    };
    let s = null;
    switch (r.type) {
      case U.Text: {
        s = /* @__PURE__ */ m(hu, { value: r.answer || "", onChange: a });
        break;
      }
      case U.FreeText: {
        s = /* @__PURE__ */ m(
          Pi,
          {
            value: r.answer || "",
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case U.YesNo: {
        const u = (C) => {
          a(C === "yes");
        };
        s = /* @__PURE__ */ m(
          au,
          {
            value: r.answer === void 0 || r.answer === null ? void 0 : r.answer ? "yes" : "no",
            onChange: u,
            disabled: l,
            language: o
          }
        );
        break;
      }
      case U.Scale: {
        s = /* @__PURE__ */ m(
          L1,
          {
            value: r.answer,
            labels: r.labels,
            min: r.lowerBound,
            max: r.upperBound,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case U.Financial:
      case U.Numeric: {
        s = /* @__PURE__ */ m(
          a1,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case U.Time: {
        s = /* @__PURE__ */ m(
          Ru,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case U.Date: {
        s = /* @__PURE__ */ m(
          _u,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case U.SplitDate: {
        s = /* @__PURE__ */ m(
          T1,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case U.File: {
        s = /* @__PURE__ */ m(
          i1,
          {
            value: r.answer,
            onChange: a,
            disabled: l,
            language: o
          }
        );
        break;
      }
      case U.DateTime: {
        s = /* @__PURE__ */ m(
          Lu,
          {
            value: r.answer || Date.now(),
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case U.Radio: {
        s = /* @__PURE__ */ m(Oe, { children: (c = r == null ? void 0 : r.options) == null ? void 0 : c.map((u, C) => {
          var x;
          return /* @__PURE__ */ B(nt, { children: [
            /* @__PURE__ */ m(
              gu,
              {
                checked: r.answer === u.value,
                value: u.value,
                label: Ue(u.label, t),
                name: r.id,
                onChange: a,
                disabled: l
              }
            ),
            r.answer === u.value && u.description ? /* @__PURE__ */ m(
              _n,
              {
                text: Ue(
                  u.description,
                  t
                )
              }
            ) : null,
            r.answer === u.value && u.questions ? (x = u.questions) == null ? void 0 : x.map((k, w) => /* @__PURE__ */ m(
              ln,
              {
                questions: t,
                question: k,
                onChange: (I) => {
                  var A;
                  const v = { ...r };
                  v.options = (A = v.options) == null ? void 0 : A.map((L) => {
                    var T;
                    const y = { ...L };
                    return y.value === u.value && (y.questions = (T = y.questions) == null ? void 0 : T.map((P) => P.id === I.id ? I : P)), y;
                  }), i({
                    ...v,
                    answeredAt: Date.now()
                  });
                },
                disabled: l,
                language: o,
                props: {
                  style: { paddingLeft: "20px" },
                  className: dn.childQuestionWrapper
                }
              },
              w
            )) : null
          ] }, C);
        }) });
        break;
      }
      case U.Checkbox: {
        const u = (C, x) => {
          const k = [...r.answer || []];
          if (x)
            k.push(C);
          else {
            const w = k.indexOf(C);
            w !== -1 && k.splice(w, 1);
          }
          a(k);
        };
        s = /* @__PURE__ */ m(Oe, { children: (p = r == null ? void 0 : r.options) == null ? void 0 : p.map((C) => {
          var x, k, w;
          return /* @__PURE__ */ B(nt, { children: [
            /* @__PURE__ */ m(
              Cu,
              {
                checked: (x = r.answer) == null ? void 0 : x.includes(C.value),
                value: C.value,
                label: Ue(C.label, t),
                onChange: u,
                disabled: l
              },
              C.value
            ),
            (k = r.answer) != null && k.includes(C.value) ? /* @__PURE__ */ B(Oe, { children: [
              C.description ? /* @__PURE__ */ m(
                _n,
                {
                  text: Ue(
                    C.description,
                    t
                  )
                }
              ) : null,
              (w = C.questions) != null && w.length ? /* @__PURE__ */ m(Oe, { children: C.questions.map((I, v) => /* @__PURE__ */ m(
                ln,
                {
                  questions: t,
                  question: I,
                  onChange: (A) => {
                    var y;
                    const L = { ...r };
                    L.options = (y = L.options) == null ? void 0 : y.map((T) => {
                      var _;
                      const P = { ...T };
                      return P.value === C.value && (P.questions = (_ = P.questions) == null ? void 0 : _.map((E) => E.id === A.id ? A : E)), P;
                    }), i({
                      ...L,
                      answeredAt: Date.now()
                    });
                  },
                  disabled: l,
                  language: o,
                  props: {
                    style: { paddingLeft: "20px" },
                    className: dn.childQuestionWrapper
                  }
                },
                v
              )) }) : null
            ] }) : null
          ] }, C.value);
        }) });
        break;
      }
      case U.Items: {
        console.log("render"), s = /* @__PURE__ */ m(
          b1,
          {
            questions: t,
            question: r,
            onChange: i,
            disabled: l,
            language: o
          }
        );
        break;
      }
      case U.MultiPart: {
        const u = (C) => (x) => {
          const k = { ...r, questions: [...r.questions] };
          k.questions[C] = { ...x, answeredAt: Date.now() }, i(k);
        };
        s = /* @__PURE__ */ m("div", { className: dn.multiPartQuestion, children: (d = r == null ? void 0 : r.questions) == null ? void 0 : d.map((C, x) => {
          if (C.onlyAvailableIf) {
            const k = C.onlyAvailableIf, w = Et(
              k.questionId,
              t
            );
            if (w && w.answer !== (k == null ? void 0 : k.answer))
              return null;
          }
          return /* @__PURE__ */ m(
            ln,
            {
              questions: t,
              question: C,
              onChange: u(x),
              disabled: l,
              props: {
                className: dn.childQuestionWrapper
              }
            },
            x
          );
        }) });
        break;
      }
    }
    return /* @__PURE__ */ Ii(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${dn.questionWrapper} ${(f = e.props) == null ? void 0 : f.className}`,
        key: r.id
      },
      r.question && (r.question || "").trim().length > 0 ? /* @__PURE__ */ m(
        zu,
        {
          text: Ue(r.question, t),
          language: o
        }
      ) : null,
      r.description ? /* @__PURE__ */ m(
        _n,
        {
          text: Ue(r.description, t)
        }
      ) : null,
      s,
      r.information ? /* @__PURE__ */ m(
        _n,
        {
          text: Ue(r.information, t)
        }
      ) : null
    );
  }
), P1 = "_complete_r2lyt_1149", R1 = "_inlineForm_r2lyt_1159", F1 = "_inlineFormTitle_r2lyt_1167", D1 = "_formFooter_r2lyt_1175", B1 = "_formFooterLeft_r2lyt_1182", $1 = "_formFooterRight_r2lyt_1207", O1 = "_inlineFormError_r2lyt_1232", en = {
  complete: P1,
  inlineForm: R1,
  inlineFormTitle: F1,
  formFooter: D1,
  formFooterLeft: B1,
  formFooterRight: $1,
  inlineFormError: O1
}, z1 = ne(
  (e, n) => {
    var $, te, le, de, be, g;
    const { title: t, form: r, onChange: i, onComplete: l, complete: o, onFileUpload: a, onFileRemove: s, files: c, onBack: p, language: d } = e, { t: f } = Re(void 0, { lng: d ?? "en" }), [u, C] = J(r.questions), [x, k] = J([]), [w, I] = J(0), [v, A] = J(0), [L, y] = J(), [T, P] = J(!1), _ = u[v].type === U.File && (($ = u[v].answer) == null ? void 0 : $.some((H) => !("id" in H)));
    ie(() => {
      const H = u.map((j) => j.type === U.File && c ? {
        ...j,
        answer: [
          ...c,
          ...(j.answer || []).filter((h) => !("id" in h) && !c.some((W) => W.name === h.name))
        ]
      } : j);
      C(H);
    }, [c]), ie(() => {
      i && w > 0 && i(u);
    }, [w]), ie(() => {
      o && (I(100), P(!0));
    }, [o]);
    const E = (H) => {
      if (H > u.length - 1)
        return null;
      const j = u[H + 1];
      if (!j)
        return null;
      if (j.onlyAvailableIf) {
        const h = j.onlyAvailableIf, W = (Y, se) => {
          for (const ye of se) {
            if (ye.id === Y)
              return ye;
            if (ye.type === U.MultiPart) {
              const Fe = W(Y, ye.questions);
              if (Fe)
                return Fe;
            }
          }
          return null;
        }, X = W(
          h.questionId,
          u
        );
        if (X) {
          if (Array.isArray(h.answer)) {
            if (!h.answer.includes(
              X.answer
            ))
              return E(H + 1);
          } else if (X.answer !== (h == null ? void 0 : h.answer))
            return E(H + 1);
        }
      }
      return j;
    }, S = (H) => {
      if (H && H.type === U.File) {
        const h = u.find((Y) => Y.id === H.id).answer || [], W = H.answer || [], X = [];
        h.forEach(
          (Y) => {
            "id" in Y && (W.filter((se) => "id" in se).some((se) => Y.id === se.id) || (s && s(Y), X.push(Y)));
          }
        ), X.length > 0 && (H.answer = [
          ...H.answer || [],
          ...X
        ]);
      }
      C((j) => {
        const h = j.findIndex((X) => X.id === H.id), W = [...j];
        return W[h] = { ...H, answeredAt: Date.now() }, W;
      }), y("");
    }, M = (H) => {
      H.preventDefault();
      const j = u[v];
      if (j && j.required && (j.answer === void 0 || j.answer === "" || j.answer === null)) {
        y(f("toast.answer-question"));
        return;
      } else if (j.type === U.SplitDate && j.answer && (j.answer.year === "" || j.answer.year === void 0 || j.answer === null)) {
        y(f("toast.answer-question"));
        return;
      }
      const h = E(v);
      if (h) {
        S({ ...j, answeredAt: Date.now() }), k([...x, j.id]), y("");
        const W = u.findIndex(
          (X) => X.id === h.id
        );
        A(W), I(W / u.length * 100), P(!1);
      } else {
        const W = {
          ...j,
          answeredAt: Date.now()
        };
        S(W);
        const Y = u.filter((se) => se.type !== U.File).map((se) => se.id == j.id ? W : se);
        l && l(Y), I(100), P(!0);
      }
    }, F = (H) => {
      H.preventDefault();
      const j = x[x.length - 1], h = u.find(
        (W) => W.id === j
      );
      if (h) {
        const W = u.findIndex(
          (X) => X.id === h.id
        );
        k(x.slice(0, x.length - 1)), A(W), I(W / u.length * 100), y("");
      }
    }, O = (H) => (j) => {
      if (j.preventDefault(), H.type === U.File && H.answer) {
        const h = H.answer.filter(
          (W) => !("id" in W)
        );
        if (h.length > 0) {
          const W = H.answer.map((X) => ("id" in X || (X.uploading = !0), X));
          S({ ...H, answer: W, answeredAt: Date.now() }), a && a(h);
        }
      }
    };
    return /* @__PURE__ */ B(
      "form",
      {
        ref: n,
        ...e.props,
        className: `${en.inlineForm} ${(te = e.props) == null ? void 0 : te.className}`,
        children: [
          /* @__PURE__ */ m("div", { className: en.inlineFormTitle, children: t || r.name }),
          /* @__PURE__ */ m(uu, { value: w }),
          T ? null : /* @__PURE__ */ B(Oe, { children: [
            u && u[v] ? /* @__PURE__ */ m(
              ln,
              {
                questions: u,
                question: u[v],
                onChange: S,
                language: d
              },
              u[v].id
            ) : null,
            /* @__PURE__ */ B("div", { className: en.formFooter, children: [
              /* @__PURE__ */ m("div", { className: en.formFooterLeft, children: v > 0 || p ? /* @__PURE__ */ m(
                "button",
                {
                  onClick: v > 0 ? F : p,
                  disabled: x.length === 0 && !p,
                  children: f("chat.back")
                }
              ) : null }),
              /* @__PURE__ */ B("div", { className: en.formFooterRight, children: [
                ((le = u[v]) == null ? void 0 : le.type) === U.File ? /* @__PURE__ */ m("button", { onClick: O(u[v]), disabled: !_ || !((de = u[v].answer) != null && de.filter((H) => !("id" in H)).length) || ((be = u[v].answer) == null ? void 0 : be.filter((H) => !("id" in H) && H.uploading).length) > 0, children: f("prematter.upload") }) : (g = u[v]) != null && g.required ? null : /* @__PURE__ */ m("button", { onClick: M, children: f("chat.dunno") }),
                /* @__PURE__ */ m("button", { onClick: M, disabled: !!L || _, children: E(v) ? f("chat.next") : f("chat.finish") })
              ] })
            ] }),
            L ? /* @__PURE__ */ m("div", { className: en.inlineFormError, children: L }) : null
          ] })
        ]
      }
    );
  }
), H1 = "_complete_1kbvq_1149", V1 = "_overviewForm_1kbvq_1159", j1 = "_overviewFormTitle_1kbvq_1172", q1 = "_overviewQuestions_1kbvq_1180", W1 = "_uploadButton_1kbvq_1187", Z1 = "_overviewFormError_1kbvq_1213", U1 = "_submitButton_1kbvq_1224", nn = {
  complete: H1,
  overviewForm: V1,
  overviewFormTitle: j1,
  overviewQuestions: q1,
  uploadButton: W1,
  overviewFormError: Z1,
  submitButton: U1
}, Q1 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z", fill: "#0E5FE3" })), I5 = ne(
  (e, n) => {
    var _;
    const { title: t, form: r, onChange: i, onSubmit: l, onSubmitLabel: o, disabled: a = !1, hideFileUpload: s = !1, onFileUpload: c, onFileRemove: p, files: d, language: f } = e, u = pe(d || []), { t: C } = Re(), [x, k] = J(r.questions), [w, I] = J(), v = x.filter((E) => {
      var S;
      return E.type === U.File && ((S = E.answer) == null ? void 0 : S.some((M) => !("id" in M)));
    }).length > 0;
    ie(() => {
      if (d && d.length !== u.current.length) {
        const E = x.map((S) => S.type === U.File && d ? {
          ...S,
          answer: [
            ...d,
            ...(S.answer || []).filter((M) => !("id" in M) && !d.some((F) => F.name === M.name))
          ]
        } : S);
        k(E);
      }
    }, [d]);
    const A = (E) => {
      if (E && E.type === U.File) {
        const M = x.find(($) => $.id === E.id).answer || [], F = E.answer || [], O = [];
        M.forEach(
          ($) => {
            "id" in $ && (F.filter((te) => "id" in te).some((te) => $.id === te.id) || (p && p($), O.push($)));
          }
        ), O.length > 0 && (E.answer = [
          ...E.answer || [],
          ...O
        ]);
      }
      k((S) => {
        const M = S.findIndex((O) => O.id === E.id), F = [...S];
        return F[M] = { ...E }, F;
      }), i && i(x), I("");
    }, L = (E, S) => {
      for (const M of S) {
        if (M.id === E)
          return M;
        if (M.type === U.MultiPart) {
          const F = L(E, M.questions);
          if (F)
            return F;
        }
      }
      return null;
    }, y = () => {
      const E = (S) => S != null && S !== "";
      for (const S of x)
        if (S.required && !E(S.answer)) {
          if (S.onlyAvailableIf) {
            const M = S.onlyAvailableIf, F = L(
              M.questionId,
              x
            );
            if (F && !E(F.answer))
              return I(`${C("toast.answer-question")}: ${S.question}`), !1;
          }
          return I(`${C("toast.answer-question")}: ${S.question}`), !1;
        }
      return !0;
    }, T = (E) => {
      E.preventDefault();
      const S = y();
      if (!a && S) {
        const M = x.filter((F) => F.type !== U.File);
        l && l(M);
      }
    }, P = (E) => (S) => {
      if (S.preventDefault(), E.type === U.File && E.answer) {
        const M = E.answer.filter(
          (F) => !("id" in F)
        );
        if (M.length > 0) {
          const F = E.answer.map((O) => ("id" in O || (O.uploading = !0), O));
          A({ ...E, answer: F }), c && c(M);
        }
      }
    };
    return /* @__PURE__ */ B(
      "form",
      {
        ref: n,
        ...e.props,
        className: `${nn.overviewForm} ${(_ = e.props) == null ? void 0 : _.className}`,
        children: [
          t ? /* @__PURE__ */ m("div", { className: nn.overviewFormTitle, children: t }) : null,
          /* @__PURE__ */ B("div", { className: nn.overviewQuestions, children: [
            x.map((E) => {
              var S, M;
              if (s && E.type === U.File)
                return null;
              if (E.onlyAvailableIf) {
                const F = E.onlyAvailableIf, O = L(
                  F.questionId,
                  x
                );
                if (O) {
                  if (Array.isArray(F.answer)) {
                    if (!F.answer.includes(
                      O.answer
                    ))
                      return null;
                  } else if (O.answer !== (F == null ? void 0 : F.answer))
                    return null;
                }
              }
              return /* @__PURE__ */ B(nt, { children: [
                /* @__PURE__ */ m(
                  ln,
                  {
                    questions: x,
                    question: E,
                    onChange: A,
                    disabled: a,
                    language: f
                  }
                ),
                E.type === U.File && /* @__PURE__ */ m(
                  "button",
                  {
                    className: nn.uploadButton,
                    onClick: P(E),
                    disabled: a || !((S = E.answer) != null && S.filter((F) => !("id" in F)).length) || ((M = E.answer) == null ? void 0 : M.filter((F) => !("id" in F) && F.uploading).length) > 0,
                    children: C("prematter.upload")
                  }
                ),
                /* @__PURE__ */ m(fi, {})
              ] }, E.id);
            }),
            w ? /* @__PURE__ */ m("div", { className: nn.overviewFormError, children: w }) : null
          ] }),
          /* @__PURE__ */ B(
            "button",
            {
              className: nn.submitButton,
              type: "submit",
              onClick: T,
              disabled: !!w || a || v,
              children: [
                o || C("chat.submit"),
                /* @__PURE__ */ m(Q1, {})
              ]
            }
          )
        ]
      }
    );
  }
), Y1 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 7.5, stroke: "#666666" }), /* @__PURE__ */ b.createElement("path", { d: "M12.375 4.25C12.7202 4.25 13 4.52982 13 4.875C13 5.04757 12.9301 5.2038 12.817 5.3169L6.56699 11.5669C6.45388 11.68 6.29761 11.75 6.125 11.75C5.94944 11.75 5.79079 11.6776 5.67726 11.5611L3.18893 9.07274C3.07238 8.95921 3 8.80056 3 8.625C3 8.27982 3.27982 8 3.625 8C3.79759 8 3.95385 8.06996 4.06695 8.18307L6.12505 10.2411L11.9302 4.4359C12.0436 4.32113 12.201 4.25 12.375 4.25Z", fill: "#666666" })), K1 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#999999", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("g", { id: "icon/warning circle" }, /* @__PURE__ */ b.createElement("g", { id: "Union" }, /* @__PURE__ */ b.createElement("path", { d: "M12.75 7.5V13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5V7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5Z" }), /* @__PURE__ */ b.createElement("path", { d: "M12.75 16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5C11.25 16.0858 11.5858 15.75 12 15.75C12.4142 15.75 12.75 16.0858 12.75 16.5Z" }), /* @__PURE__ */ b.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12Z" })))), X1 = "_tickIcon_1wmmw_1149", J1 = "_toastWrapper_1wmmw_1159", G1 = "_toast_1wmmw_1159", e2 = "_body_1wmmw_1205", hn = {
  tickIcon: X1,
  toastWrapper: J1,
  toast: G1,
  body: e2
}, E5 = (e) => /* @__PURE__ */ m(
  Li,
  {
    position: "bottom-center",
    autoClose: 4e3,
    hideProgressBar: !0,
    newestOnTop: !0,
    closeOnClick: !0,
    rtl: !1,
    pauseOnFocusLoss: !1,
    draggable: !1,
    pauseOnHover: !1,
    icon: (t) => {
      if (t.type === "success")
        return /* @__PURE__ */ m(Y1, { className: hn.tickIcon });
      if (t.type === "error")
        return /* @__PURE__ */ m(K1, { className: hn.tickIcon });
    },
    closeButton: !1,
    toastClassName: hn.toast,
    bodyClassName: hn.body,
    className: hn.toastWrapper,
    limit: 3,
    ...e
  }
), n2 = "_container_1iu4n_1149", t2 = "_clickable_1iu4n_1173", r2 = "_hideMobile_1iu4n_1177", i2 = "_rowButton_1iu4n_1177", l2 = "_timestamp_1iu4n_1178", o2 = "_newDot_1iu4n_1182", a2 = "_detailsContainer_1iu4n_1195", s2 = "_lawyerName_1iu4n_1201", c2 = "_prematterName_1iu4n_1202", u2 = "_buttonLabel_1iu4n_1254", Ne = {
  container: n2,
  clickable: t2,
  hideMobile: r2,
  rowButton: i2,
  timestamp: l2,
  newDot: o2,
  detailsContainer: a2,
  lawyerName: s2,
  prematterName: c2,
  buttonLabel: u2
}, p2 = "_contextMenuWrapper_v41hj_1", d2 = "_open_v41hj_11", h2 = "_menuIcon_v41hj_14", f2 = "_contextMenu_v41hj_1", m2 = "_contextMenuItem_v41hj_18", g2 = "_label_v41hj_18", y2 = "_icon_v41hj_22", w2 = "_disabled_v41hj_61", je = {
  contextMenuWrapper: p2,
  open: d2,
  menuIcon: h2,
  contextMenu: f2,
  contextMenuItem: m2,
  label: g2,
  icon: y2,
  disabled: w2
}, C2 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M12 7.5C12.8284 7.5 13.5 6.82843 13.5 6C13.5 5.17157 12.8284 4.5 12 4.5C11.1716 4.5 10.5 5.17157 10.5 6C10.5 6.82843 11.1716 7.5 12 7.5Z", fill: "#777777" }), /* @__PURE__ */ b.createElement("path", { d: "M13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12Z", fill: "#777777" }), /* @__PURE__ */ b.createElement("path", { d: "M13.5 18C13.5 18.8284 12.8284 19.5 12 19.5C11.1716 19.5 10.5 18.8284 10.5 18C10.5 17.1716 11.1716 16.5 12 16.5C12.8284 16.5 13.5 17.1716 13.5 18Z", fill: "#777777" })), x2 = (e, n) => {
  ie(
    () => {
      const t = (r) => {
        !e.current || e.current.contains(r.target) || n(r);
      };
      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [e, n]
  );
}, mi = (e) => {
  const { items: n, className: t, activeClassName: r, menuItemsClassName: i } = e, [l, o] = et.useState(!1), a = et.useRef(null);
  x2(a, () => o(!1));
  const s = re((c) => {
    c.preventDefault(), c.stopPropagation(), o((p) => !p);
  }, []);
  return /* @__PURE__ */ B(
    "div",
    {
      className: `${je.contextMenuWrapper} ${t ?? ""} ${l ? `${je.open} ${r ?? ""}` : ""}`,
      onClick: s,
      ref: a,
      children: [
        /* @__PURE__ */ m(C2, { className: je.menuIcon }),
        l && /* @__PURE__ */ m("div", { className: `${je.contextMenu} ${i ?? ""}`, children: n.map((c, p) => /* @__PURE__ */ B(
          "div",
          {
            className: `${je.contextMenuItem} ${c.disabled ? je.disabled : ""} ${t ?? ""}`,
            onClick: (d) => {
              d.preventDefault(), d.stopPropagation(), c.disabled || (o(!1), c.onClick(d));
            },
            children: [
              /* @__PURE__ */ m("div", { className: je.label, children: c.label }),
              c.icon && /* @__PURE__ */ m("div", { className: je.icon, children: c.icon })
            ]
          },
          p
        )) })
      ]
    }
  );
}, S5 = (e) => {
  const {
    isNew: n,
    Image: t,
    description: r,
    timestamp: i,
    title: l,
    button: o,
    items: a,
    showAllMobile: s,
    onClick: c
  } = e;
  return /* @__PURE__ */ B(
    "div",
    {
      className: `${Ne.container} ${s ? "" : Ne.hideMobile} ${c ? Ne.clickable : ""}`,
      onClick: c ?? (() => {
      }),
      children: [
        n && /* @__PURE__ */ m("div", { className: Ne.newDot }),
        t,
        /* @__PURE__ */ B("div", { className: Ne.detailsContainer, children: [
          /* @__PURE__ */ m("div", { className: Ne.lawyerName, children: l }),
          /* @__PURE__ */ m("div", { className: Ne.prematterName, children: r })
        ] }),
        i && /* @__PURE__ */ m("div", { className: Ne.timestamp, children: Gc(i) }),
        o ? /* @__PURE__ */ B(
          "button",
          {
            onClick: o.onClick,
            className: `${Ne.rowButton} ${o.className ?? ""}`,
            children: [
              /* @__PURE__ */ m("div", { className: Ne.buttonLabel, children: o.label }),
              o.icon
            ]
          }
        ) : null,
        a != null && a.length ? /* @__PURE__ */ m(mi, { className: Ne.menuIcon, items: a }) : null
      ]
    }
  );
}, v2 = "_container_advxl_1149", b2 = "_cardsContainer_advxl_1149", k2 = "_cards_advxl_1149", _2 = "_actionBar_advxl_1184", I2 = "_scrollBar_advxl_1197", E2 = "_scrolledPosition_advxl_1205", S2 = "_actionButtonContainer_advxl_1213", N2 = "_actionButton_advxl_1213", L2 = "_actionIcon_advxl_1235", A2 = "_active_advxl_1240", Le = {
  container: v2,
  cardsContainer: b2,
  cards: k2,
  actionBar: _2,
  scrollBar: I2,
  scrolledPosition: E2,
  actionButtonContainer: S2,
  actionButton: N2,
  actionIcon: L2,
  active: A2
}, M2 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#777777", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M12.5303 5.03032C12.6661 4.8946 12.75 4.7071 12.75 4.5C12.75 4.08579 12.4142 3.75 12 3.75C11.7893 3.75 11.5989 3.83686 11.4627 3.97672L3.97672 11.4627C3.83686 11.5989 3.75 11.7893 3.75 12C3.75 12.2107 3.83686 12.4011 3.97672 12.5373L11.4627 20.0233C11.599 20.1631 11.7893 20.25 12 20.25C12.4142 20.25 12.75 19.9142 12.75 19.5C12.75 19.2929 12.6661 19.1054 12.5303 18.9697L6.31075 12.75H19.5C19.9142 12.75 20.25 12.4142 20.25 12C20.25 11.5858 19.9142 11.25 19.5 11.25H6.31075L12.5303 5.03032Z" })), T2 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "#0E5FE3", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z" })), P2 = 30, N5 = ne((e, n) => {
  const { showProgressBar: t, cardWidth: r, items: i, offsetWidth: l, classNames: o, debug: a } = e, s = Bn(() => l ?? 20, [l]), [c, p] = J(0), [d, f] = J(0), u = pe(null), C = pe(null), x = pe(null), k = Bn(
    () => i != null && i.length && d ? 1 / (i.length + 1 - d) : 0,
    [d, i == null ? void 0 : i.length]
  ), w = Bn(() => d && c != null && i.length != null && k != null && i.length + 1 - d > 0 ? c * k * 100 : 0, [c, d, i.length, k]), I = re(
    (P) => {
      x.current && (clearTimeout(x.current), x.current = null), u.current && (a && (console.log("new Index ", P), console.log(
        "scrolling to ",
        P * r + s * P
      )), u.current.scrollTo({
        left: P * r + s * P,
        behavior: "smooth"
      }), p(P));
    },
    [a, s, r]
  ), v = re(() => {
    c > 0 && I(c - 1);
  }, [c, I]), A = re(() => {
    c < i.length && I(c + 1);
  }, [c, i == null ? void 0 : i.length, I]), L = re(() => {
    x.current && (clearTimeout(x.current), x.current = null), x.current = setTimeout(() => {
      var P, _, E;
      if (C.current && ((P = u.current) == null ? void 0 : P.scrollLeft) != null) {
        a && console.log(
          "on scroll handling set active",
          ((_ = u.current) == null ? void 0 : _.scrollLeft) / (r + s)
        );
        const S = ((E = u.current) == null ? void 0 : E.scrollLeft) / (r + s);
        i.length - d === Math.ceil(S) ? p(i.length - d) : p(Math.round(S));
      }
      x.current = null;
    }, P2);
  }, [a, r, s, i.length, d]), y = re(() => {
    var P, _;
    if ((P = C == null ? void 0 : C.current) != null && P.clientWidth)
      return Math.floor(
        (((_ = C == null ? void 0 : C.current) == null ? void 0 : _.clientWidth) + s) / (r + s)
      );
  }, [s, r]), T = re(() => {
    const P = y();
    P && f(P);
  }, [y]);
  return ie(() => (T(), window.addEventListener("resize", T), () => window.removeEventListener("resize", T)), [T]), Tn(n, () => ({
    cardsScrollRef: u,
    getExpectedCards: y
  })), ie(() => {
    a && console.log("expectedCards", d);
  }, [a, d]), ie(() => {
    a && console.log("cardWidth", r);
  }, [a, r]), ie(() => {
    a && console.log("offsetWidth", s);
  }, [a, s]), ie(() => {
    a && console.log("activeIndex", c);
  }, [a, c]), /* @__PURE__ */ B(
    "div",
    {
      className: `${Le.container} ${(o == null ? void 0 : o.container) ?? ""}`,
      ref: C,
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: `${Le.cardsContainer} ${(o == null ? void 0 : o.cardsPosition) ?? ""}`,
            children: /* @__PURE__ */ m(
              "div",
              {
                ref: u,
                className: `${Le.cards} ${(o == null ? void 0 : o.cardsContainer) ?? ""}`,
                onScroll: L,
                style: {
                  gap: `0 ${s}px`,
                  gridTemplateColumns: `repeat(auto-fill, minmax(${r}px, 1fr)`,
                  gridAutoColumns: `minmax(${r}px, 1fr)`
                },
                children: i.map((P) => P)
              }
            )
          }
        ),
        t ? /* @__PURE__ */ B("div", { className: `${Le.actionBar}  ${(o == null ? void 0 : o.actionBar) ?? ""}`, children: [
          /* @__PURE__ */ m("div", { className: Le.scrollBar, children: /* @__PURE__ */ m(
            "div",
            {
              className: Le.scrolledPosition,
              style: {
                width: `${k * 100}%`,
                left: `${w}%`
              }
            }
          ) }),
          /* @__PURE__ */ B("div", { className: Le.actionButtonContainer, children: [
            /* @__PURE__ */ m(
              "button",
              {
                className: Le.actionButton,
                onClick: v,
                disabled: c <= 0,
                children: /* @__PURE__ */ m(M2, { className: Le.actionIcon })
              }
            ),
            /* @__PURE__ */ m(
              "button",
              {
                className: Le.actionButton,
                disabled: c >= i.length - d,
                onClick: A,
                children: /* @__PURE__ */ m(T2, { className: Le.actionIcon })
              }
            )
          ] })
        ] }) : null
      ]
    }
  );
}), R2 = "_sectionedForm_1sa61_1149", F2 = "_title_1sa61_1156", D2 = "_section_1sa61_1149", B2 = "_sectionTitle_1sa61_1178", $2 = "_available_1sa61_1194", O2 = "_sectionTitleText_1sa61_1198", z2 = "_complete_1sa61_1201", H2 = "_caret_1sa61_1202", V2 = "_submitButton_1sa61_1210", ue = {
  sectionedForm: R2,
  title: F2,
  section: D2,
  sectionTitle: B2,
  available: $2,
  sectionTitleText: O2,
  complete: z2,
  caret: H2,
  submitButton: V2
}, Sr = (e) => /* @__PURE__ */ b.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M7.71966 5.03032C7.58394 4.8946 7.5 4.7071 7.5 4.5C7.5 4.08579 7.83579 3.75 8.25 3.75C8.46067 3.75 8.65105 3.83686 8.78729 3.97672L16.2733 11.4627C16.4131 11.5989 16.5 11.7893 16.5 12C16.5 12.2107 16.4131 12.4011 16.2733 12.5373L8.78728 20.0233C8.65105 20.1631 8.46067 20.25 8.25 20.25C7.83579 20.25 7.5 19.9142 7.5 19.5C7.5 19.2929 7.58394 19.1054 7.71966 18.9697L14.6892 12L7.71966 5.03032Z", fill: "#666666" })), Nr = (e) => /* @__PURE__ */ b.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M21.75 5.25C21.75 4.83579 21.4142 4.5 21 4.5C20.7912 4.5 20.6023 4.58535 20.4663 4.72308L7.50006 17.6893L3.53039 13.7196C3.39466 13.5839 3.20711 13.5 3 13.5C2.58579 13.5 2.25 13.8358 2.25 14.25C2.25 14.4607 2.33686 14.6511 2.47672 14.7873L6.96272 19.2733C7.09896 19.4131 7.28934 19.5 7.5 19.5C7.70713 19.5 7.89465 19.416 8.03038 19.2803L21.5304 5.7803C21.6661 5.64458 21.75 5.45708 21.75 5.25Z", fill: "#666666" })), j2 = (e) => /* @__PURE__ */ b.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z", fill: "#0E5FE3" })), Gn = (e) => e.charAt(0).toUpperCase() + e.slice(1).replace(/-/g, " "), L5 = ne(
  (e, n) => {
    var I;
    const { title: t, form: r, onChange: i, onSubmit: l, disabled: o, onSubmitLabel: a } = e, { t: s } = Re(), [c, p] = J([]), [d, f] = J(null), u = c.every((v) => v.complete);
    ie(() => {
      const v = r.questions.reduce(
        (_, E) => {
          var S, M;
          if (E.section) {
            const F = E.section.split("/");
            if (F.length > 1) {
              _[F[0]] || (_[F[0]] = {
                id: F[0],
                title: F[0],
                questions: [],
                children: [],
                complete: !1
              });
              const O = _[F[0]], $ = (S = O.children) == null ? void 0 : S.find(
                (te) => te.title === F[1]
              );
              $ ? $.questions.push(E) : (M = O.children) == null || M.push({
                id: E.section,
                title: F[1],
                questions: [E],
                children: [],
                complete: !1
              });
            } else
              _[F[0]] ? _[F[0]].questions.push(E) : _[F[0]] = {
                id: E.section,
                title: F[0],
                questions: [E],
                children: [],
                complete: !1
              };
          }
          return _;
        },
        {}
      ), A = (_, E) => {
        for (const S of E) {
          if (S.id === _)
            return S;
          if (S.type === U.MultiPart) {
            const M = A(_, S.questions);
            if (M)
              return M;
          }
        }
        return null;
      }, L = (_) => _ != null && _ !== "", y = (_) => {
        if (_.answeredAt)
          return !0;
        if (_.onlyAvailableIf) {
          const E = _.onlyAvailableIf, S = A(
            E.questionId,
            r.questions
          );
          if (S)
            return Array.isArray(E.answer) ? E.answer.includes(
              S.answer
            ) ? !0 : null : S.answer !== (E == null ? void 0 : E.answer) ? null : _.required && !L(_.answer) ? !1 : !_.required && _.answer === null;
        }
        return _.required && !L(_.answer) ? !1 : !_.required && _.answer === null;
      };
      let T = !1;
      const P = Object.values(v).map(
        (_) => {
          if (Object.keys(v).indexOf(_.id) > 0 && !T)
            return _.complete = !1, _;
          let S = !1;
          if (_.children && _.children.length > 0) {
            const F = _.children.map((O) => O.questions.map(($) => y($))).filter((O) => O !== null).map((O) => O.filter(($) => $ !== null).every(($) => $));
            S = F.every((O) => O), _.children = _.children.map((O, $) => (O.complete = F[$], O));
          } else
            S = _.questions.map((F) => y(F)).filter((F) => F !== null).every((F) => F);
          return S ? (_.complete = !0, T = !0) : T = !1, _;
        }
      );
      p(P);
    }, [r.questions]);
    const C = (v) => (A) => {
      A.preventDefault(), o || f(v);
    }, x = (v) => {
      if (!d || o)
        return;
      const A = {
        ...d,
        questions: v
      };
      f(A);
      const L = c.map((T) => {
        var _;
        if (T.id === A.id)
          return A;
        const P = d.id.split("/");
        return P.length > 1 && T.id === P[0] ? {
          ...T,
          children: (_ = T.children) == null ? void 0 : _.map((E) => E.id === d.id ? A : E)
        } : T;
      }), y = L.reduce((T, P) => P.children && P.children.length > 0 ? T.concat(
        P.children.reduce(
          (_, E) => _.concat(E.questions),
          []
        )
      ) : T.concat(P.questions), []);
      i && i(y), p(L);
    }, k = (v) => {
      if (!d || o)
        return;
      const A = {
        ...d,
        questions: v,
        complete: !0
      }, L = c.map((T) => {
        var _;
        if (T.id === A.id)
          return A;
        const P = d.id.split("/");
        return P.length > 1 && T.id === P[0] ? {
          ...T,
          children: (_ = T.children) == null ? void 0 : _.map((E) => E.id === d.id ? A : E)
        } : T;
      }), y = L.reduce((T, P) => P.children && P.children.length > 0 ? T.concat(
        P.children.reduce(
          (_, E) => _.concat(E.questions),
          []
        )
      ) : T.concat(P.questions), []);
      i && i(y), p(L), console.log(L), f(null);
    }, w = (v) => {
      if (v.preventDefault(), u && !o) {
        const A = c.reduce((L, y) => y.children && y.children.length > 0 ? L.concat(
          y.children.reduce(
            (T, P) => T.concat(P.questions),
            []
          )
        ) : L.concat(y.questions), []);
        l && l(A);
      }
    };
    return /* @__PURE__ */ B(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${ue.sectionedForm} ${(I = e.props) == null ? void 0 : I.className}`,
        children: [
          d ? null : /* @__PURE__ */ B(Oe, { children: [
            t ? /* @__PURE__ */ m("div", { className: ue.title, children: t }) : null,
            c.map((v, A) => {
              var y, T;
              const L = A === 0 || v.complete || A > 0 && c[A - 1].complete;
              return /* @__PURE__ */ B("div", { className: ue.section, children: [
                v.title && /* @__PURE__ */ B(
                  "div",
                  {
                    className: `${ue.sectionTitle} ${L ? ue.available : ""}`,
                    style: {
                      cursor: !o && v.children && (v.children.length >= 0 && L || L && v.children.length === 0) ? "pointer" : "default"
                    },
                    onClick: !v.children || v.children.length === 0 && L ? C(v) : void 0,
                    children: [
                      /* @__PURE__ */ m("div", { className: ue.sectionTitleText, children: Gn(v.title) }),
                      v.complete ? /* @__PURE__ */ m("div", { className: ue.complete, children: /* @__PURE__ */ m(Nr, {}) }) : null,
                      !v.children || v.children.length === 0 ? /* @__PURE__ */ m("div", { className: ue.caret, children: /* @__PURE__ */ m(Sr, {}) }) : null
                    ]
                  }
                ),
                v.children && ((y = v.children) == null ? void 0 : y.length) > 0 ? /* @__PURE__ */ m("div", { className: ue.section, children: (T = v.children) == null ? void 0 : T.map((P, _) => {
                  const E = A === 0 && _ === 0 || P.complete || A > 0 && c[A - 1].complete && (_ === 0 || _ > 0 && v.children && v.children[_ - 1].complete);
                  return /* @__PURE__ */ B(
                    "div",
                    {
                      className: `${ue.sectionTitle} ${E ? ue.available : ""}`,
                      onClick: !o && (!P.children || P.children.length === 0 && E) ? C(P) : void 0,
                      children: [
                        /* @__PURE__ */ m("div", { className: ue.sectionTitleText, children: Gn(P.title) }),
                        P.complete ? /* @__PURE__ */ m("div", { className: ue.complete, children: /* @__PURE__ */ m(Nr, {}) }) : null,
                        /* @__PURE__ */ m("div", { className: ue.caret, children: /* @__PURE__ */ m(Sr, {}) })
                      ]
                    },
                    _
                  );
                }) }) : null
              ] }, A);
            }),
            /* @__PURE__ */ B(
              "button",
              {
                className: ue.submitButton,
                type: "submit",
                onClick: w,
                disabled: !u || o,
                children: [
                  a || s("chat.submit"),
                  /* @__PURE__ */ m(j2, {})
                ]
              }
            )
          ] }),
          d ? /* @__PURE__ */ m(
            z1,
            {
              form: {
                id: d.id,
                name: Gn(d.title),
                questions: d.questions
              },
              onChange: x,
              onComplete: k,
              onBack: () => f(null)
            }
          ) : null
        ]
      }
    );
  }
), q2 = "_messageWrapper_1yffq_1149", W2 = "_relativeContainer_1yffq_1162", Z2 = "_timestampContainer_1yffq_1170", U2 = "_show_1yffq_1184", Q2 = "_left_1yffq_1187", Y2 = "_right_1yffq_1190", K2 = "_timestamp_1yffq_1170", X2 = "_message_1yffq_1149", J2 = "_withExternalBody_1yffq_1259", G2 = "_expandMargin_1yffq_1263", ep = "_noExternalBody_1yffq_1280", oe = {
  messageWrapper: q2,
  relativeContainer: W2,
  timestampContainer: Z2,
  show: U2,
  left: Q2,
  right: Y2,
  timestamp: K2,
  message: X2,
  withExternalBody: J2,
  expandMargin: G2,
  noExternalBody: ep
}, np = "_fileTextContainer_1h0fb_1149", tp = "_fileName_1h0fb_1155", rp = "_full_1h0fb_1161", ip = "_icon_1h0fb_1164", lp = "_loadingContainer_1h0fb_1168", op = "_loadingIconContainer_1h0fb_1174", ap = "_loadingIcon_1h0fb_1174", sp = "_rotateSpinner_1h0fb_1", cp = "_dash_1h0fb_1", up = "_text_1h0fb_1195", pp = "_receiver_1h0fb_1226", dp = "_filePreviewContainer_1h0fb_1238", hp = "_contextMenuContainer_1h0fb_1245", fp = "_contextMenu_1h0fb_1245", mp = "_fileImageContainer_1h0fb_1255", gp = "_fileImage_1h0fb_1255", yp = "_textContent_1h0fb_1272", wp = "_sender_1h0fb_1286", he = {
  fileTextContainer: np,
  fileName: tp,
  full: rp,
  icon: ip,
  loadingContainer: lp,
  loadingIconContainer: op,
  loadingIcon: ap,
  rotateSpinner: sp,
  dash: cp,
  text: up,
  receiver: pp,
  filePreviewContainer: dp,
  contextMenuContainer: hp,
  contextMenu: fp,
  fileImageContainer: mp,
  fileImage: gp,
  textContent: yp,
  sender: wp
}, Cp = (e) => /* @__PURE__ */ b.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#103F91", fillRule: "evenodd", d: "M13 21.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#185ABD", fillRule: "evenodd", d: "M13 18.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#2B7CD3", fillRule: "evenodd", d: "M13 15.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#41A5EE", fillRule: "evenodd", d: "M13 12.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#185ABD", d: "M3.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H3.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#F9F7F7", d: "M6.66125 17.9114h.0165C6.6845 17.8129 7.5275 13 7.5275 13h.9795s.855 4.5883.88125 4.9029H9.401c.01125-.216.708-4.9029.708-4.9029H11l-1.0965 6H8.86175s-.86475-4.74-.8715-4.824h-.0135C7.96925 14.2729 7.1645 19 7.1645 19H6.107L5 13h.9075s.75 4.806.75375 4.9114Z" }))), xp = (e) => /* @__PURE__ */ b.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10.4545 12c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091ZM10 15.5c0-.2761.2035-.5.4545-.5h9.091c.251 0 .4545.2239.4545.5s-.2035.5-.4545.5h-9.091c-.251 0-.4545-.2239-.4545-.5Zm.4545 2.5c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Zm0 3c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Z", clipRule: "evenodd" }))), vp = (e) => /* @__PURE__ */ b.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M4.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H4.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M13.7143 23H4.28571c-.60621 0-1.18759-.2408-1.61624-.6695C2.24082 21.9019 2 21.3205 2 20.7143v-9.4286c0-.6062.24082-1.1876.66947-1.61623C3.09812 9.24082 3.67951 9 4.28571 9h9.42859c.6062 0 1.1876.24082 1.6162.66947.4287.42863.6695 1.01003.6695 1.61623v9.4286c0 .6062-.2408 1.1876-.6695 1.6162-.4286.4287-1.01.6695-1.6162.6695Zm0-1H4.28571c-.34099 0-.66801-.1355-.90913-.3766C3.13546 21.3823 3 21.0553 3 20.7143v-9.4286c0-.341.13546-.668.37658-.9091.24112-.2411.56814-.3766.90913-.3766h9.42859c.341 0 .668.1355.9091.3766.2411.2411.3766.5681.3766.9091v9.4286c0 .341-.1355.668-.3766.9091-.2411.2411-.5681.3766-.9091.3766Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#A6CCC3", d: "m9.86848 16.228-.84379 1.1999-1.35011-1.8089c-.02779-.0372-.06282-.0672-.10255-.0877-.03972-.0206-.08315-.0313-.12714-.0313-.04398 0-.08741.0107-.12713.0313-.03973.0205-.07476.0505-.10255.0877l-2.15248 2.8836c-.15021.2019-.01371.4974.22983.4974h6.41484c.2398 0 .3774-.2872.2348-.4901l-1.6041-2.2819c-.0277-.0393-.0632-.0712-.1039-.0931-.0407-.0219-.0855-.0333-.1309-.0333-.0454 0-.0902.0114-.13096.0333-.04071.0219-.07625.0538-.10386.0931Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#FF9810", d: "M11.5 15c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z" }))), bp = (e) => /* @__PURE__ */ b.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#D65532", d: "M4.91667 22h4.85416c.06078 0 .11907-.0101.16205-.0492.04298-.0391.06712-.0681.06712-.1234v-4.5833c0-.0553-.02414-.1455-.06712-.1845C9.8899 17.0205 9.83161 17 9.77083 17H4.91667c-.24312 0-.47628.0878-.64818.2441-.17191.1563-.26849.3682-.26849.5892v3.3334c0 .221.09658.4329.26849.5892.1719.1563.40506.2441.64818.2441Zm20.16663-5h-4.8541c-.0608 0-.1191.0219-.1621.061-.043.0391-.0671.0921-.0671.1473v4.5834c0 .115.1027.2083.2292.2083h4.8541c.2431 0 .4763-.0878.6482-.2441S26 21.3877 26 21.1667v-3.3334c0-.221-.0966-.4329-.2685-.5892-.1719-.1563-.4051-.2441-.6482-.2441Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#D65532", fillRule: "evenodd", d: "M11 17.5848C11 16.7095 11.613 16 12.3691 16h5.2618C18.387 16 19 16.7095 19 17.5848v3.8304C19 22.2905 18.387 23 17.6309 23h-5.2618C11.613 23 11 22.2905 11 21.4152v-3.8304ZM12.4564 17c-.2521 0-.4564.293-.4564.5848v3.8304c0 .2918.2043.5848.4564.5848h5.1745c.252 0 .3691-.293.3691-.5848v-3.8304c0-.2918-.1171-.5848-.3691-.5848h-5.1745Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10.4545 11c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Zm0 3c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Z", clipRule: "evenodd" }))), kp = (e) => /* @__PURE__ */ b.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#134A2C", fillRule: "evenodd", d: "M17 21.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#21A366", fillRule: "evenodd", d: "M17 18.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#33C481", fillRule: "evenodd", d: "M17 15.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Zm0-3c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#185C37", fillRule: "evenodd", d: "M13 21.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#107C41", fillRule: "evenodd", d: "M13 18.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#21A366", fillRule: "evenodd", d: "M13 15.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Zm0-3c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#107C41", d: "M3.09091 22h9.81819c.2893 0 .5668-.1149.7714-.3195S14 21.1984 14 20.9091v-9.8182c0-.2893-.1149-.5668-.3195-.7714S13.1984 10 12.9091 10H3.09091c-.28933 0-.56681.1149-.77139.3195-.20459.2046-.31952.4821-.31952.7714v9.8182c0 .2893.11493.5668.31952.7714.20458.2046.48206.3195.77139.3195Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#F9F7F7", d: "m5.00056 19 2.17305-3.0085L5.18283 13h1.60199l1.08681 1.9125c.09987.181.16815.3165.20596.4055h.01411c.07166-.145.14671-.286.22458-.4225L9.4787 13h1.47l-2.04275 2.975L11 19H9.43581l-1.25552-2.1c-.05906-.0894-.1091-.1833-.14954-.2805h-.01862c-.03636.0952-.08502.1863-.14502.2715L6.57434 19H5h.00056Z" }))), _p = (e) => /* @__PURE__ */ b.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486H23c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-4.6549c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10 11.5c0-.2761.2239-.5.5-.5h9c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-9c-.2761 0-.5-.2239-.5-.5Zm0 3c0-.2761.2239-.5.5-.5h9c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-9c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#185ABD", d: "M5 17c0-.5523.44772-1 1-1h12.9847c.5523 0 1 .4477 1 1v5.0431c0 .5523-.4477 1-1 1H6c-.55228 0-1-.4477-1-1V17Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M7.89258 17.9h1.54651c.03942.0306.15135.1604.15135.6298 0 .3601-.07468.5081-.10844.5538l-.00359.0048H7.89258V17.9Zm-.4-.8h2.01048c.50544.0133.88734.548.88734 1.4298 0 .4531-.0913.7941-.265 1.0292-.17149.2322-.41693.3457-.65033.3294h-.4855l1.29653 1.3239c.1546.1578.1519.4111-.0059.5656-.1578.1546-.4111.152-.56567-.0059l-1.82195-1.8604V21.5c0 .2209-.17908.4-.4.4-.22091 0-.4-.1791-.4-.4v-2.005l-.00005-.0066.00005-.0067v-1.9751L7.09253 17.5c0-.2209.17909-.4.4-.4h.00005Zm6.50002.8c.2209 0 .4-.1791.4-.4s-.1791-.4-.4-.4h-3c-.2209 0-.4.1791-.4.4s.1791.4.4.4h1.1002v3.6c0 .2209.1791.4.4.4s.4-.1791.4-.4v-3.6h1.0998Zm3.9-.4c0 .2209-.1791.4-.4.4h-1.5998v1.2h1.5998c.2209 0 .4.1791.4.4s-.1791.4-.4.4h-1.5998v1.6c0 .2209-.1791.4-.4.4s-.4-.1791-.4-.4v-1.9874l-.0002-.0126.0002-.0127v-1.9747l-.0002-.0126c0-.2209.1791-.4.4-.4h2c.2209 0 .4.1791.4.4Z", clipRule: "evenodd" }))), Ip = (e) => /* @__PURE__ */ b.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2H18v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141C18.509 3.08592 18.2021 3.00005 18 3V2c.4897.00011 1.0579.20883 1.3822.55575m0 0 4.1249 4.41129c.3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ b.createElement("path", { fill: "#ED6C47", d: "M16.1818 16.625 15.5455 16h-1.9091L13 16.625v3.24c.7686.7287 1.7954 1.1356 2.8636 1.135 1.0971 0 2.1492-.428 2.9249-1.1899C19.5642 19.0483 20 18.0149 20 16.9375v-.3125h-3.8182Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#FF8F6B", d: "M15.7 13c-1.0077-.0009-1.9762.4343-2.7 1.2133V17h3v-4h-.3Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#FFC7B5", d: "M17 12v4h4c0-1.0609-.4214-2.0783-1.1716-2.8284C19.0783 12.4214 18.0609 12 17 12Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#C43E1C", d: "M3.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H3.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ b.createElement("path", { fill: "#fff", d: "M8.45259 13c.8238 0 1.45349.1877 1.89181.5614.4365.3746.6556.9167.6556 1.6263 0 .4562-.1038.8649-.3202 1.2193-.2156.3553-.5277.6263-.92667.8228-.39893.1974-.85599.3-1.38104.3H7.05993L7.05546 20H6v-7h2.45259Zm-1.39713 3.4912H8.5c.44991 0 .79159-.1035 1.02236-.3096.23077-.207.39446-.5746.39446-.972 0-.771-.49017-1.35-1.37478-1.35H7.05546v2.6316Z" }))), Ep = "_fileIconContainer_1mrbn_1", Sp = {
  fileIconContainer: Ep
}, Np = (e) => {
  const { file: n, className: t, noContainer: r, containerClassName: i } = e;
  let l = "";
  if (n != null && n.id)
    l = n == null ? void 0 : n.mime;
  else {
    const a = e == null ? void 0 : e.file;
    l = a == null ? void 0 : a.type;
  }
  let o = null;
  if (l != null && l.startsWith("image/"))
    o = /* @__PURE__ */ m(vp, { className: t ?? "" });
  else
    switch (l) {
      case "application/pdf":
        o = /* @__PURE__ */ m(bp, { className: t ?? "" });
        break;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        o = /* @__PURE__ */ m(Cp, { className: t ?? "" });
        break;
      case "application/rtf":
        o = /* @__PURE__ */ m(_p, { className: t ?? "" });
        break;
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        o = /* @__PURE__ */ m(kp, { className: t ?? "" });
        break;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        o = /* @__PURE__ */ m(Ip, { className: t ?? "" });
        break;
      default:
        o = /* @__PURE__ */ m(xp, { className: t ?? "" });
        break;
    }
  return r ? o : /* @__PURE__ */ m("div", { className: `${Sp.fileIconContainer} ${i ?? ""}`, children: o });
}, Lp = (e) => /* @__PURE__ */ b.createElement("svg", { width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("g", { id: "icon/download export" }, /* @__PURE__ */ b.createElement("g", { id: "Union" }, /* @__PURE__ */ b.createElement("path", { d: "M6.5 13V23C6.5 23.5523 6.94772 24 7.5 24H25.5C26.0523 24 26.5 23.5523 26.5 23V13C26.5 12.4477 26.9477 12 27.5 12C28.0523 12 28.5 12.4477 28.5 13V23C28.5 24.6569 27.1569 26 25.5 26H7.5C5.84315 26 4.5 24.6569 4.5 23L4.5 13C4.5 12.4477 4.94772 12 5.5 12C6.05229 12 6.5 12.4477 6.5 13Z", fill: "#333333" }), /* @__PURE__ */ b.createElement("path", { d: "M22.5 14C22.5 14.2814 22.3838 14.5357 22.1967 14.7174L17.2184 19.6957C17.2147 19.6995 17.2109 19.7033 17.2071 19.7071C16.8166 20.0977 16.1834 20.0977 15.7929 19.7071L10.7929 14.7071C10.6932 14.6074 10.619 14.4919 10.5702 14.3687C10.5249 14.2546 10.5 14.1302 10.5 14C10.5 13.859 10.5292 13.7248 10.5818 13.6032C10.6231 13.5076 10.68 13.4172 10.7525 13.3358C10.7793 13.3056 10.8079 13.2771 10.8381 13.2504C10.9142 13.1831 10.998 13.1294 11.0865 13.0892C11.2125 13.0319 11.3525 13 11.5 13C11.6475 13 11.7875 13.0319 11.9135 13.0892C12.002 13.1294 12.0858 13.1831 12.1619 13.2504C12.179 13.2655 12.1955 13.2811 12.2116 13.2974L15.5 16.5858V7C15.5 6.44772 15.9477 6 16.5 6C17.0523 6 17.5 6.44772 17.5 7V16.5856L20.7928 13.2928C20.9738 13.1119 21.2239 13 21.5 13C22.0523 13 22.5 13.4477 22.5 14Z", fill: "#333333" })))), Ap = (e) => {
  const { file: n, receiver: t, className: r, previewClassName: i, toggleTimestamp: l } = e, [o, a] = et.useState(null);
  if (!n || o)
    return null;
  let s = null;
  if (n.mime.startsWith("image/") && n.url)
    s = /* @__PURE__ */ m(
      "div",
      {
        className: `${he.fileImageContainer}
        ${t ? he.receiver : ""}`,
        children: /* @__PURE__ */ m(
          "img",
          {
            src: n.url.path,
            alt: n.name,
            className: he.fileImage,
            onError: () => a(!0)
          }
        )
      }
    );
  else if (n.textContent)
    s = /* @__PURE__ */ m(
      "div",
      {
        className: `${he.textContent} ${t ? he.receiver : he.sender}`,
        children: n.textContent
      }
    );
  else
    return null;
  return /* @__PURE__ */ B(Oe, { children: [
    /* @__PURE__ */ B(
      "div",
      {
        className: `
        ${he.fileName}
        ${t ? he.receiver : ""}
        ${r ?? ""}
      `,
        onClick: l,
        children: [
          /* @__PURE__ */ m(Np, { file: n, className: he.icon }),
          n == null ? void 0 : n.name
        ]
      }
    ),
    /* @__PURE__ */ B("div", { className: `
        ${he.filePreviewContainer}
        ${t ? he.receiver : ""}
        ${i ?? ""}
      `, children: [
      s,
      n.url ? /* @__PURE__ */ m("div", { className: he.contextMenuContainer, children: /* @__PURE__ */ m(
        mi,
        {
          items: [
            {
              label: "Download",
              onClick: () => {
                var c;
                document.location.href = ((c = n.url) == null ? void 0 : c.path) ?? "";
              },
              icon: /* @__PURE__ */ m(Lp, { className: he.downloadIcon })
            }
          ],
          className: he.contextMenu
        }
      ) }) : null
    ] })
  ] });
};
var Mp = /* @__PURE__ */ ((e) => (e.Receiver = "Receiver", e.Sender = "Sender", e))(Mp || {});
const Tp = (e) => /* @__PURE__ */ m("a", { href: e.href, target: "_blank", rel: "noreferrer", children: e.children }), A5 = (e) => {
  const {
    externalBody: n,
    messageBody: t,
    avatar: r,
    avatarClassName: i,
    type: l,
    className: o,
    wrapperClassName: a,
    timestamp: s,
    timestampClassName: c,
    files: p,
    fileClassName: d,
    filePreviewClassName: f,
    systemFormMessage: u,
    ...C
  } = e, [x, k] = J(!1), w = pe(null), I = re(() => {
    k && (x ? k(!1) : (w.current && clearTimeout(w.current), w.current = setTimeout(() => {
      k(!1), w.current = null;
    }, 2e3), k(!0)));
  }, [x, k]), v = t && typeof t == "string" ? /* @__PURE__ */ m(
    wn,
    {
      rehypePlugins: [gn],
      components: { a: Tp },
      children: t
    }
  ) : t;
  return /* @__PURE__ */ B(
    "div",
    {
      className: `${oe.messageWrapper} ${l === "Sender" ? oe.right : oe.left} ${a ?? ""}`,
      children: [
        r ? /* @__PURE__ */ m("div", { className: `${i ?? ""}`, children: r }) : null,
        /* @__PURE__ */ B("div", { className: `${oe.relativeContainer} ${n ? oe.withExternalBody : oe.noExternalBody}
        ${x ? oe.show : oe.hide}
        `, children: [
          v ? /* @__PURE__ */ m(
            "div",
            {
              className: `${oe.message} ${u ? oe.systemFormMessage : l === "Sender" ? oe.messageRight : oe.messageLeft} ${o ?? ""}`,
              ...C,
              onClick: I,
              children: v
            }
          ) : null,
          p == null ? void 0 : p.map((A, L) => /* @__PURE__ */ m(
            Ap,
            {
              file: A,
              receiver: l === "Receiver",
              className: d,
              previewClassName: f,
              toggleTimestamp: I
            },
            (A == null ? void 0 : A.id) ?? L
          )),
          s ? /* @__PURE__ */ m("div", { className: `${oe.timestampContainer}
            ${x ? oe.show : oe.hide}`, children: /* @__PURE__ */ m(
            "div",
            {
              className: `${oe.timestamp} ${c ?? ""}
              ${l === "Receiver" ? oe.left : oe.right}
              ${n ? oe.withExternalBody : oe.noExternalBody}`,
              children: s
            }
          ) }) : null
        ] }),
        n
      ]
    }
  );
};
var pt, En = Ai;
if (process.env.NODE_ENV === "production")
  pt = En.createRoot, En.hydrateRoot;
else {
  var Lr = En.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  pt = function(e, n) {
    Lr.usingClientEntryPoint = !0;
    try {
      return En.createRoot(e, n);
    } finally {
      Lr.usingClientEntryPoint = !1;
    }
  };
}
const Pp = "_confirmModalWrapper_1er25_1149", Rp = "_confirmModal_1er25_1149", Fp = "_confirmModalHeader_1er25_1173", Dp = "_confirmModalTitle_1er25_1182", Bp = "_confirmModalDescription_1er25_1194", $p = "_confirmModalFooter_1er25_1205", Op = "_disabled_1er25_1248", Qe = {
  confirmModalWrapper: Pp,
  confirmModal: Rp,
  confirmModalHeader: Fp,
  confirmModalTitle: Dp,
  confirmModalDescription: Bp,
  confirmModalFooter: $p,
  disabled: Op
}, zp = ne(
  (e, n) => {
    const { t } = Re();
    return /* @__PURE__ */ B("div", { className: Qe.confirmModalWrapper, children: [
      /* @__PURE__ */ B("div", { ref: n, className: Qe.confirmModal, children: [
        /* @__PURE__ */ B("div", { className: Qe.confirmModalHeader, children: [
          /* @__PURE__ */ m("div", { className: Qe.confirmModalTitle, children: e.title }),
          /* @__PURE__ */ m("div", { className: Qe.confirmModalDescription, children: e.description })
        ] }),
        /* @__PURE__ */ B("div", { className: Qe.confirmModalFooter, children: [
          /* @__PURE__ */ m("button", { onClick: e.onCancel, children: t("confirm.cancel") }),
          /* @__PURE__ */ m("button", { onClick: e.onConfirm, children: t("confirm.yes") })
        ] })
      ] }),
      /* @__PURE__ */ m("div", { className: Qe.confirmModalBackground })
    ] });
  }
), M5 = ({
  title: e,
  description: n,
  onConfirm: t
}) => {
  const r = document.createElement("div");
  document.body.appendChild(r);
  const i = pt(r);
  document.body.style.overflow = "hidden";
  const l = () => {
    t(), a();
  }, o = () => {
    a();
  }, a = () => {
    i.unmount(), document.body.removeChild(r), document.body.style.overflow = "auto";
  };
  i.render(
    /* @__PURE__ */ m(
      zp,
      {
        title: e,
        description: n,
        onConfirm: l,
        onCancel: o
      }
    )
  );
}, Hp = "_aiLawyerSelectorWrapper_9850r_1149", Vp = "_aiLawyerIconContainer_9850r_1157", jp = "_aiLawyerIcon_9850r_1157", qp = "_hoverEnabled_9850r_1189", Wp = "_popupOverlay_9850r_1193", Zp = "_aiLawyerPickerWrapper_9850r_1200", Up = "_aiLawyerPickerItem_9850r_1211", Qp = "_aiLawyerPickerImage_9850r_1221", Yp = "_selectedLawyer_9850r_1225", Kp = "_topStart_9850r_1235", Xp = "_topMiddle_9850r_1248", Jp = "_bottomStart_9850r_1253", Gp = "_bottomMiddle_9850r_1267", e5 = "_noSelect_9850r_1329", fe = {
  aiLawyerSelectorWrapper: Hp,
  aiLawyerIconContainer: Vp,
  aiLawyerIcon: jp,
  hoverEnabled: qp,
  popupOverlay: Wp,
  aiLawyerPickerWrapper: Zp,
  aiLawyerPickerItem: Up,
  aiLawyerPickerImage: Qp,
  selectedLawyer: Yp,
  topStart: Kp,
  topMiddle: Xp,
  bottomStart: Jp,
  bottomMiddle: Gp,
  noSelect: e5
}, T5 = (e) => {
  const [n, t] = J(""), [r, i] = J(!1), { isSelectorEnabled: l, selectedAiLawyer: o, aiLawyers: a, onAiLawyerChange: s, headerContainerRef: c, chatContainerRef: p } = e, [d, f] = J(!1), u = pe(null), [C, x] = J("topMiddle"), k = 76, w = 312, I = pe(null), v = (_) => {
    s && s(_), f(!1);
  };
  ie(() => {
    o && ((E) => {
      const S = a.find(
        (M) => M.aiLawyer === E
      );
      S && (t(S.image), i(!0));
    })(o);
  }, [o, a]);
  const A = () => {
    var _;
    if (I.current && clearTimeout(I.current), c && c.current && p && p.current) {
      const E = c.current.getBoundingClientRect(), S = p.current.getBoundingClientRect(), M = (_ = u.current) == null ? void 0 : _.getBoundingClientRect();
      E && M && S && (E.bottom < M.top - k && S.left < M.left - w / 2 ? x("topMiddle") : E.bottom < M.top - k && S.left >= M.left - w / 2 ? x("topStart") : S.left < M.left - w / 2 ? x("bottomMiddle") : x("bottomStart"));
    }
    f(!0);
  }, L = () => {
    I.current = setTimeout(() => {
      f(!1);
    }, 300);
  }, y = () => {
    I.current && clearTimeout(I.current);
  }, T = () => {
    I.current = setTimeout(() => {
      f(!1);
    }, 300);
  }, P = () => {
    i(!1);
  };
  return /* @__PURE__ */ B("div", { className: fe.aiLawyerSelectorWrapper, children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: `${fe.aiLawyerIconContainer} ${fe.noSelect} ${d && l ? fe.hoverEnabled : ""} `,
        onMouseEnter: () => A(),
        onMouseLeave: () => L(),
        ref: u,
        children: r ? /* @__PURE__ */ m(
          "img",
          {
            className: `${fe.aiLawyerIcon} ${fe.noSelect}`,
            src: n,
            onError: P
          }
        ) : null
      }
    ),
    d && l && /* @__PURE__ */ m(
      "div",
      {
        className: `${fe.popupOverlay} ${fe.noSelect} ${fe[C]}`,
        onMouseEnter: () => y(),
        onMouseLeave: () => T(),
        children: /* @__PURE__ */ m("div", { className: fe.aiLawyerPickerWrapper, children: a.map((_) => /* @__PURE__ */ m(
          "div",
          {
            className: `${fe.aiLawyerPickerItem} ${o === _.aiLawyer ? fe.selectedLawyer : ""}`,
            onClick: () => v(_.aiLawyer),
            children: /* @__PURE__ */ m(
              "img",
              {
                className: `${fe.aiLawyerPickerImage} ${fe.noSelect}`,
                src: _.image
              }
            )
          },
          _.aiLawyer
        )) })
      }
    )
  ] });
}, n5 = "_financialInput_13hbr_1149", t5 = {
  financialInput: n5
}, P5 = ne(
  (e, n) => {
    var o;
    const { value: t, disabled: r, onChange: i } = e, l = re((a) => {
      a.preventDefault(), a.stopPropagation(), r || i(a.target.value);
    }, [r, i]);
    return /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${t5.numericInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "number",
        value: t,
        onChange: l
      }
    );
  }
), r5 = "_onOffInputContainer_jr8ym_1149", i5 = "_onOffInputTitle_jr8ym_1158", l5 = "_onOffInputValue_jr8ym_1165", o5 = "_switchButton_jr8ym_1173", a5 = "_switchButtonCircle_jr8ym_1180", s5 = "_on_jr8ym_1149", c5 = "_off_jr8ym_1195", u5 = "_disabled_jr8ym_1200", Ae = {
  onOffInputContainer: r5,
  onOffInputTitle: i5,
  onOffInputValue: l5,
  switchButton: o5,
  switchButtonCircle: a5,
  on: s5,
  off: c5,
  disabled: u5
}, R5 = ne(
  (e, n) => {
    const {
      title: t,
      value: r,
      disabled: i,
      onChange: l,
      className: o
    } = e, { t: a } = Re(), s = () => {
      l(!r);
    };
    return /* @__PURE__ */ B(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Ae.onOffInputContainer} ${o || ""}`,
        children: [
          /* @__PURE__ */ m("div", { className: `${Ae.onOffInputTitle}`, children: t }),
          /* @__PURE__ */ m("div", { className: `${Ae.onOffInputValue}`, children: a(r ? "confirm.on" : "confirm.off") }),
          /* @__PURE__ */ m("div", { className: `${Ae.switchButton} ${r ? Ae.on : Ae.off} ${i ? Ae.disabled : ""}`, onClick: s, children: /* @__PURE__ */ m("div", { className: `${Ae.switchButtonCircle} ${r ? Ae.on : Ae.off}` }) })
        ]
      }
    );
  }
);
export {
  T5 as AiLawyerSelector,
  N5 as Carousel,
  _5 as ChatElement,
  jc as ChatInput,
  Mp as ChatMessageType,
  A5 as ChatMessageWrapper,
  Cu as CheckboxInput,
  zp as ConfirmModal,
  mi as ContextMenu,
  _u as DateInput,
  Lu as DateTimeInput,
  i1 as FileInput,
  P5 as FinancialInput,
  z1 as InlineForm,
  _n as InputDescription,
  zu as InputLabel,
  fi as InputSeparator,
  hc as LawyerChatMessage,
  S5 as MessageRow,
  a1 as NumericInput,
  R5 as OnOffInput,
  I5 as OverviewForm,
  uu as ProgressBar,
  x5 as QuestionList,
  ln as QuestionWrapper,
  gu as RadioInput,
  L1 as ScaleInput,
  L5 as SectionedForm,
  T1 as SplitDateInput,
  hu as TextInput,
  Pi as TextareaInput,
  Ru as TimeInput,
  E5 as Toast,
  uc as UserChatMessage,
  au as YesNoInput,
  M5 as confirm,
  Gc as formatDate,
  b5 as formatDateTime,
  eu as formatLongDateTime,
  k5 as formatMediumDateTime,
  v5 as formatTime
};
